import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal, Button, Accordion } from "react-bootstrap";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomInput from "../../../CustomControls/CustomInput";
import { post, postFormData } from "../../../helpers/api_helper";
import {
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  dataUrlToFile,
  dataUrlToFileUsingFetch,
} from "../../../CustomControls/Utils";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import Cropper from "react-cropper";
import { useRef } from "react";
import Webcam from "react-webcam";
import {
  POST_DDLGetTestMasterByInwardMaterialID,
  POST_DDLParametersRange_SubGroupByReferenceStandardID_TestMasterID,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerDDLList,
  POST_GetCustomerProjectContactPersonDDLList,
  POST_GetMixDesignMasterDropDownListAll,
  POST_GetTestingDateWiseParameterTestMethodDDLList,
  POST_GetTestingParameterFormulaExpressionResult,
  POST_GetTestingsApprovalDetailByID,
  POST_GetTestingDateWiseTestMethodDDLList,
  POST_GetTestingsDetailByID,
  POST_GetTestingsInwardMaterialDetailByID,
  // POST_GetTestingsParametersListOnTestMethodChange,
  POST_TestingCSVFileImport,
  POST_TestingFetchMachineList,
  POST_TestingFetchMachineParameterResults,
  POST_TestingFilesSave,
  POST_TestingMachineList,
  POST_TestingSave,
  POST_GetDepartmentDropDownList,
} from "../../../helpers/url_helper";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import swal from "sweetalert";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import MixDesignIncludedTestResultDetail from "./MixDesignIncludedTestResultDetail";

const AddTesting = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { InwardMaterialIDParam, InwardMaterialTestDetailIDParam } =
    useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);
  const [showTestMasterImagesModal, setShowTestMasterImagesModal] =
    useState(false);
  const [showTestingImagesModal, setShowTestingImagesModal] = useState(false);

  const [unitOptions, setUnitOptions] = useState([]);
  const [testMethodOptions, setTestMethodOptions] = useState([]);
  const [referenceStandardOptions, setReferenceStandardOptions] = useState([]);
  const [machineOptions, setMachineOptions] = useState([]);
  const [testMasterOptions, setTestMasterOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [materialTypeOptions, setMaterialTypeOptions] = useState([]);

  const [showAddTPIDetailModal, setShowAddTPIDetailModal] = useState(false);
  const [tpiCustomerOptions, setTPICustomerOptions] = useState([]);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);
  const [refSubGroupOptions, setRefSubGroupOptions] = useState([]);
  const [parametersRangeList, setParametersRangeList] = useState([]);
  const [parametersNABLRangeList, setParametersNABLRangeList] = useState([]);

  const [singleSubGroupSelect, setSingleSubGroupSelect] = useState(false);
  const [selectedSubGroup, setSelectedSubGroup] = useState(false);

  // const [showAddParametersModal, setShowAddParametersModal] = useState(false);

  const [fileKeyCSVFile, setFileKeyCSVFile] = useState();

  const [showTestingRemarksModal, setShowTestingRemarksModal] = useState(false);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };

  const locationTypeOptions = [
    { label: "Permanent Facility", value: 1 },
    { label: "On Site", value: 2 },
  ];

  const validationSchema = Yup.object().shape({
    InwardMaterialTestDetailIDEncrypt: Yup.string().required(
      "Test Name is required field"
    ),
    btnSubmitType: Yup.number(),
    TestingStatus: Yup.number(),
    TestingQty: Yup.number().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.number()
            .required("Testing Qty is required field")
            .min(1, "Testing Qty is required field");
        return schema;
      }
    ),
    InvoiceQty: Yup.number().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.number()
            .required("Invoice Qty is required field")
            .min(1, "Invoice Qty is required field");
        return schema;
      }
    ),
    // UnitID: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
    //   if (btnSubmitType != 1)
    //     return Yup.string().required("Unit is required field");
    //   return schema;
    // }),
    // TestMethodIDEncrypt: Yup.string().when(
    //   "btnSubmitType",
    //   ([btnSubmitType], schema) => {
    //     if (btnSubmitType != 1)
    //       return Yup.string().required("Test Method is required field");
    //     return schema;
    //   }
    // ),
    ReferenceStandardIDEncrypted: Yup.string(),
    // MachineIDEncrypt: Yup.string().when(
    //   "btnSubmitType",
    //   ([btnSubmitType], schema) => {
    //     if (btnSubmitType != 1)
    //       return Yup.string().required("Machine is required field");
    //     return schema;
    //   }
    // ),
    ProductGroupIDEncrypt: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Material Group is required field");
        return schema;
      }
    ),
    MaterialTypeIDEncrypt: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Material Type is required field");
        return schema;
      }
    ),
    ChangeNote: Yup.string().when(
      ["btnSubmitType", "TestingStatus"],
      ([btnSubmitType, TestingStatus], schema) => {
        if (btnSubmitType != 1 && TestingStatus > 1)
          return Yup.string().required("Change Note is required field");
        return schema;
      }
    ),
    ReferenceSubGroup: Yup.string().when(
      ["btnSubmitType", "ReferenceStandardIDEncrypted"],
      ([btnSubmitType, ReferenceStandardIDEncrypted], schema) => {
        if (
          btnSubmitType != 1 &&
          ReferenceStandardIDEncrypted &&
          refSubGroupOptions?.filter((x) => x.value != "")?.length > 0
        )
          return Yup.string().required("Group is required field");
        return schema;
      }
    ),
    SampleDetail: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string()
            .trim()
            .required("Sample Detail is required field");
        return schema;
      }
    ),
    Condition: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().trim().required("Condition is required field");
      return schema;
    }),
    Size: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().trim().required("Size is required field");
      return schema;
    }),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TestMasterIDEncrypt: "",
      InwardMaterialIDEncrypt: InwardMaterialIDParam
        ? window.atob(InwardMaterialIDParam)
        : "",
      TestingIDEncrypt: "",
      InwardIDEncrypt: "",
      InwardMaterialTestDetailIDEncrypt: InwardMaterialTestDetailIDParam
        ? window.atob(InwardMaterialTestDetailIDParam)
        : "",
      InwardNo: "",
      InwardDate: "",
      ExpectedDateOfDelivery: "",
      InwardMaterialID: "",
      TestName: "",
      TestingDate: new Date(),
      TestingToDate: new Date(),
      TestingQty: "",
      InvoiceQty: "",
      UnitID: "",
      TestMethodIDEncrypt: "",
      TestingByID: "",
      ReferenceStandardIDEncrypted: "",
      MachineIDEncrypt: "",
      ParameterWith: 1,
      IsMergeSameValue: false,
      ReferenceSubGroup: "",
      Result: "",
      Remarks: "",
      ChangeNote: "",
      TestingStatus: 0,
      //TestingStatusDDL: 0,
      LetterRefNo: "",
      SampleNote: "",
      IsMaterialReturnable: false,
      IsTPIRequired: true,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListTestingResultImages: [],
      ListTestMasterImages: [],
      TCNo: "",
      DepartmentIDEncrypt: "",
      DepartmentName: "",
      ProductGroupIDEncrypt: "",
      ProductGroupName: "",
      MaterialTypeName: "",
      MaterialTypeIDEncrypt: "",
      SampleDetail: "",
      searchTestingBy: "",
      ListTestingBy: [],
      Condition: "",
      Size: "",
      CustomerProjectIDEncrypted: "",
      btnSubmitType: 1,
      ListOfParameter: [],
      IsNABLRangeChange: false,
      IsReTestTesting: false,
      TestName: "",
      TestingDateDisplay: "",
      TestingToDateDisplay: "",
      MachineName: "",
      UnitName: "",
      TestMethodName: "",
      ReferenceStandardName: "",
      AllowTestingEdit: 0,
      IsDefaultLoad: false,
      LocationType: 0,
      IsDefaultLoadCalculateAverage: false,
      ListOfTestDefineMoreRates: [],
      BasedOnMeasurementValue: "",
      BasedOnHrsValue: "",
      IsMixDesign: false,
      TestMixDesignDetail: {},
      ListOfMixDesignIncludedTest: [],
      IsMixDesignValidateFormulaExpression: false,
      ListOfMachines: [],
      TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData: {},
      ListOfMixDesignTargetStrengthForMixProportioning: [],
      ListOfMixDesignGroupParameters: [],
      ListOfMixDesignMixCalculation: [],
      ListOfMixDesignMixProportionsForTrial: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardMaterialIDEncrypt,
      TestMasterIDEncrypt,
      InwardMaterialTestDetailIDEncrypt,
      InwardNo,
      InwardDate,
      ExpectedDateOfDelivery,
      LetterRefNo,
      SampleNote,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      TCNo,
      DepartmentName,
      ProductGroupName,
      MaterialTypeName,
      searchTestingBy,
      ListTestingBy,
      CustomerProjectIDEncrypted,
      TestingQty,
      ListTestingResultImages,
      ListTestMasterImages,
      TestingStatus,
      //TestingStatusDDL,
      ParameterWith,
      IsMergeSameValue,
      ListOfParameter,
      ReferenceStandardIDEncrypted,
      IsNABLRangeChange,
      MachineIDEncrypt,
      IsReTestTesting,
      TestName,
      TestingDateDisplay,
      TestingToDateDisplay,
      MachineName,
      UnitName,
      TestMethodName,
      ReferenceStandardName,
      TestMethodIDEncrypt,
      TestingDate,
      TestingToDate,
      AllowTestingEdit,
      IsDefaultLoad,
      LocationType,
      IsDefaultLoadCalculateAverage,
      ListOfTestDefineMoreRates,
      BasedOnMeasurementValue,
      BasedOnHrsValue,
      IsMixDesign,
      TestMixDesignDetail,
      ListOfMixDesignIncludedTest,
      IsMixDesignValidateFormulaExpression,
      ListOfMachines,
      TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData,
      ListOfMixDesignTargetStrengthForMixProportioning,
      ListOfMixDesignGroupParameters,
      ListOfMixDesignMixCalculation,
      ListOfMixDesignMixProportionsForTrial,
    },
  } = formik;

  useEffect(() => {
    if (TestingToDate && TestingToDate < TestingDate) {
      formik.setFieldValue("TestingToDate", TestingDate);
    }
    getTestMethodDDLList();
  }, [TestingDate]);

  const getTestMethodDDLList = async () => {
    setIsLoading(true);
    post(POST_GetTestingDateWiseTestMethodDDLList, {
      InwardMaterialTestDetailIDEncrypted: InwardMaterialTestDetailIDEncrypt,
      TranDate: TestingDate
        ? moment(TestingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfTestMethod?.length > 0) {
            setTestMethodOptions(
              response?.ListOfTestMethod?.map((item) => ({
                label: item?.TestMethod,
                value: item?.TestMethodIDEncrypted,
                IsExpiredTestMethod: item?.IsExpiredTestMethod,
              }))
            );

            if (TestMethodIDEncrypt) {
              if (
                response?.ListOfTestMethod?.filter(
                  (x) => x.TestMethodIDEncrypted == TestMethodIDEncrypt
                )?.length == 0
              ) {
                formik.setFieldValue("TestMethodIDEncrypt", "");
              }
            }
          } else {
            setTestMethodOptions([]);
            formik.setFieldValue("TestMethodIDEncrypt", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterTestMethodDDLList = async (testingDate) => {
    setIsLoading(true);
    post(POST_GetTestingDateWiseParameterTestMethodDDLList, {
      InwardMaterialTestDetailIDEncrypted: InwardMaterialTestDetailIDEncrypt,
      TranDate: testingDate
        ? moment(testingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : moment(new Date()).format("YYYY-MM-DD").replace(/^\-/, ""),
      TestMasterIDEncrypted: TestMasterIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfParameterTestMethod?.length > 0) {
            ListOfParameter?.map((para, index) => {
              let paraTestMethodList =
                response?.ListOfParameterTestMethod?.filter(
                  (x) => x.ParameterIDEncrypted == para?.ParameterIDEncrypted
                );
              formik.setFieldValue(
                `ListOfParameter[${index}].testMethodOptions`,
                paraTestMethodList?.map((method) => ({
                  ...method,
                  label: method.NickName
                    ? `${method.TestMethod} (${method.NickName})`
                    : method.TestMethod,
                  value: method?.TestMethodIDEncrypted,
                }))
              );
              if (
                paraTestMethodList?.filter(
                  (x) => x.TestMethodIDEncrypted == para.TestMethodIDEncrypt
                )?.length == 0
              ) {
                formik.setFieldValue(
                  `ListOfParameter[${index}].TestMethodIDEncrypt`,
                  ""
                );
                formik.setFieldValue(
                  `ListOfParameter[${index}].NABLRangeFrom`,
                  ""
                );
                formik.setFieldValue(
                  `ListOfParameter[${index}].NABLRangeTo`,
                  ""
                );
              }
            });

            formik.setFieldValue("IsNABLRangeChange", true);
          } else {
            ListOfParameter?.map((para, index) => {
              formik.setFieldValue(
                `ListOfParameter[${index}].testMethodOptions`,
                []
              );
              formik.setFieldValue(
                `ListOfParameter[${index}].TestMethodIDEncrypt`,
                ""
              );
              formik.setFieldValue(
                `ListOfParameter[${index}].NABLRangeFrom`,
                ""
              );
              formik.setFieldValue(`ListOfParameter[${index}].NABLRangeTo`, "");

              //NABL Range From or To is blank or Non Numeric or Non Std. Para then result is not identified
              for (let i = 0; i < para?.ListOfResultValue?.length; i++) {
                formik.setFieldValue(
                  `ListOfParameter[${index}].ListOfResultValue[${i}].ConsiderNABLResult`,
                  -1
                );
              }
            });
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const handleValidSubmit = (values) => {
  //   if (
  //     ListTestingBy?.filter((e) => e.IsSelected == true)?.length == 0 &&
  //     values.btnSubmitType != 1
  //   ) {
  //     //warningMessage("Please select atleast one Testing By...");
  //     formik.setFieldError("ListTestingBy", "Testing By is required field");
  //     formik.setFieldTouched("ListTestingBy", true);
  //     return;
  //   }

  //   if (
  //     values?.btnSubmitType != 1 &&
  //     ReferenceStandardIDEncrypted &&
  //     values?.ListOfParameter?.filter(
  //       (x) => x.rangeOptions?.length > 0 && x.RangeValue
  //     )?.length == 0
  //   ) {
  //     formik.setFieldError("ListOfParameter", "Please select Range...");
  //     formik.setFieldTouched("ListOfParameter", true);
  //     return;
  //   }

  //   setIsLoading(true);
  //   let formData = new FormData();
  //   formData.append("TestingIDEncrypt", values?.TestingIDEncrypt);
  //   formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);
  //   formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
  //   formData.append(
  //     "InwardMaterialTestDetailIDEncrypt",
  //     values?.InwardMaterialTestDetailIDEncrypt
  //   );
  //   formData.append("InwardMaterialIDEncrypt", values?.InwardMaterialIDEncrypt);
  //   formData.append("InwardIDEncrypt", values?.InwardIDEncrypt);
  //   formData.append("TestMasterIDEncrypt", values?.TestMasterIDEncrypt);
  //   formData.append("TestMethodIDEncrypt", values?.TestMethodIDEncrypt);
  //   formData.append(
  //     "ReferenceStandardIDEncrypt",
  //     values?.ReferenceStandardIDEncrypted
  //   );
  //   formData.append("MachineIDEncrypt", values?.MachineIDEncrypt);
  //   formData.append(
  //     "TestingDate",
  //     values?.TestingDate
  //       ? moment(values?.TestingDate).format("YYYY-MM-DD").replace(/^\-/, "")
  //       : ""
  //   );
  //   formData.append(
  //     "TestingToDate",
  //     values?.TestingToDate
  //       ? moment(values?.TestingToDate).format("YYYY-MM-DD").replace(/^\-/, "")
  //       : ""
  //   );
  //   formData.append("TestingQty", values?.TestingQty);
  //   formData.append("InvoiceQty", values?.InvoiceQty);
  //   formData.append("UnitID", values?.UnitID);
  //   formData.append("ParameterWith", values?.ParameterWith);
  //   formData.append("MergeSameValue", values?.IsMergeSameValue);
  //   formData.append("ReferenceSubGroup", values?.ReferenceSubGroup);
  //   formData.append("Result", values?.Result);
  //   formData.append("Remarks", values?.Remarks);
  //   formData.append("ChangeNote", values?.ChangeNote);
  //   formData.append("TestingStatus", values?.btnSubmitType == 1 ? 2 : 3);
  //   formData.append("Size", values?.Size);
  //   formData.append("SampleDetail", values?.SampleDetail);
  //   formData.append("Conditione", values?.Condition);
  //   formData.append(
  //     "TestingByIDs",
  //     Array.from(
  //       ListTestingBy?.filter((e) => e.IsSelected == true),
  //       (x) => x.EmployeeIDEncrypt
  //     ).join(",")
  //   );
  //   formData.append(
  //     "CreatedByEncrypt",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );
  //   formData.append(
  //     "InwardDate",
  //     values?.InwardDate
  //       ? moment(new Date(values?.InwardDate))
  //           .format("YYYY-MM-DD")
  //           .replace(/^\-/, "")
  //       : ""
  //   );

  //   //formData.append("IsReTestTesting", values?.IsReTestTesting == true ? 1 : 0);

  //   //ListOfLetterRefDoc
  //   Promise.all(
  //     values?.ListOfLetterRefDoc?.map((x, i) => {
  //       formData.append(
  //         `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
  //         x.InwardLetterRefImageIDEncrypted
  //       );
  //       formData.append(
  //         `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
  //         x.LetterRefImageFile
  //       );
  //       formData.append(
  //         `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
  //         x.LetterRefImageFilePath
  //       );
  //       formData.append(`ListOfLetterRefDoc[${i}].IsDeleted`, x.IsDeleted);
  //     })
  //   );

  //   //ListOfTPIDetails
  //   Promise.all(
  //     values?.ListOfTPIDetails?.map((x, i) => {
  //       formData.append(
  //         `ListOfTPIDetails[${i}].InwardTPIDetailIDEncrypted`,
  //         x.TestingTPIIDEncrypt
  //       );
  //       formData.append(
  //         `ListOfTPIDetails[${i}].TPIIDEncrypted`,
  //         x.TPIIDEncrypted
  //       );
  //       formData.append(
  //         `ListOfTPIDetails[${i}].TPIContactPersonIDEncrypted`,
  //         x.TPIContactPersonIDEncrypted
  //       );
  //       formData.append(
  //         `ListOfTPIDetails[${i}].TPIExpectedDate`,
  //         x.TPIExpectedDate
  //           ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
  //           : ""
  //       );
  //       formData.append(`ListOfTPIDetails[${i}].IsDeleted`, x.IsDeleted);
  //     })
  //   );

  //   //ListOfTestResultImages
  //   Promise.all(
  //     values?.ListTestingResultImages?.map((x, i) => {
  //       formData.append(
  //         `ListOfTestResultImages[${i}].TestingResultImageIDEncrypted`,
  //         x.TestingResultImageIDEncrypted
  //       );
  //       formData.append(
  //         `ListOfTestResultImages[${i}].ResultImageFile`,
  //         x.TestingResultImageFile
  //       );
  //       formData.append(
  //         `ListOfTestResultImages[${i}].ResultImagePath`,
  //         x.ResultImagePath
  //       );
  //       formData.append(`ListOfTestResultImages[${i}].IsDeleted`, x.IsDeleted);
  //     })
  //   );
  //   //ListOfTestingResultList
  //   let rIndex = 0;
  //   Promise.all(
  //     values?.ListOfParameter?.map((p) => {
  //       Promise.all(
  //         p?.ListOfResultValue?.map((r) => {
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].TestingResultIDEncrypted`,
  //             r.TestingResultIDEncrypted
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].TestingIDEncrypted`,
  //             values?.TestingIDEncrypt
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].TestingCount`,
  //             r?.TestingCount
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].ParameterType`,
  //             p?.ParameterType
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].RefParameterIDEncrypted`,
  //             p?.TestMasterParameterIDEncrypted
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].ParameterName`,
  //             p?.ParameterName
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].DisplayCode`,
  //             p?.DisplayCode
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].IsNABLParameter`,
  //             p?.IsNABLParameter
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].MinValue`,
  //             p?.MinValue
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].MaxValue`,
  //             p?.MaxValue
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].RangeValue`,
  //             p?.RangeValue
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].NABLRangeFrom`,
  //             p?.NABLRangeFrom ?? ""
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].NABLRangeTo`,
  //             p?.NABLRangeTo ?? ""
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].Requirement`,
  //             p?.Requirement
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].ResultValue`,
  //             r?.ResultValue
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].ConsiderNABLResult`,
  //             r?.ConsiderNABLResult
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].ConsiderResult`,
  //             r?.ConsiderResult
  //           );
  //           formData.append(
  //             `ListOfTestingResultList[${rIndex}].IsDeleted`,
  //             false
  //           );
  //           rIndex = rIndex + 1;
  //         })
  //       );
  //     })
  //   );

  //   postFormData(POST_TestingSave, formData)
  //     .then((response) => {
  //       setIsLoading(true);
  //       if (response?.IsSuccess) {
  //         successMessage(response?.Message);
  //         setTimeout(() => {
  //           navigate("/testing-list");
  //         }, 1000);
  //       } else {
  //         errorMessage(response?.Message);
  //         setIsLoading(false);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const handleValidSubmit = (values) => {
    if (AllowTestingEdit != 1) {
      return;
    }

    if (
      testMethodOptions?.filter(
        (x) => x?.value == values?.TestMethodIDEncrypt
      )[0]?.IsExpiredTestMethod == true &&
      values.btnSubmitType != 1
    ) {
      warningMessage("Test Method is Expired..!");
      return;
    }

    if (
      values.btnSubmitType != 1 &&
      ReferenceStandardIDEncrypted &&
      referenceStandardOptions?.filter(
        (x) => x?.value == ReferenceStandardIDEncrypted
      )[0]?.IsExpiredReferenceStandard == true
    ) {
      warningMessage("Reference Standard is Expired..!");
      return;
    }

    if (values.btnSubmitType != 1) {
      if (parseInt(values?.TestingQty) < parseInt(values?.InvoiceQty)) {
        formik.setFieldError(
          "InvoiceQty",
          "Invoice Qty must be less then or equal to Testing Qty..."
        );
        formik.setFieldTouched("InvoiceQty", true);
        return;
      }

      Promise.all(
        values?.ListOfParameter?.map((p) => {
          if (
            p?.testMethodOptions?.filter(
              (x) => x?.value == p?.TestMethodIDEncrypt
            )[0]?.IsExpiredTestMethod == true
          ) {
            warningMessage(
              p?.testMethodOptions?.filter(
                (x) => x?.value == p?.TestMethodIDEncrypt
              )[0]?.TestMethod + " - Test Method is Expired..!"
            );
            return;
          }
        })
      );
    }

    if (
      ListTestingBy?.filter((e) => e.IsSelected == true)?.length == 0 &&
      values.btnSubmitType != 1
    ) {
      //warningMessage("Please select atleast one Testing By...");
      formik.setFieldError("ListTestingBy", "Testing By is required field");
      formik.setFieldTouched("ListTestingBy", true);
      return;
    }

    if (
      values?.btnSubmitType != 1 &&
      ReferenceStandardIDEncrypted &&
      values?.ListOfParameter?.filter(
        (x) => x.rangeOptions?.length > 0 && x.IsSelected == true
      )?.length > 0 &&
      values?.ListOfParameter?.filter(
        (x) =>
          x.rangeOptions?.length > 0 && !x.RangeValue && x.IsSelected == true
      )?.length > 0
    ) {
      formik.setFieldError("ListOfParameter", "Please select Range...");
      formik.setFieldTouched("ListOfParameter", true);
      return;
    }

    if (AuthUser?.Permissions?.Account == 1 && values?.btnSubmitType != 1) {
      if (
        ListOfTestDefineMoreRates?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 4 //Based On Measurement
        )?.length > 0
      ) {
        if (values?.UnitID == "") {
          formik.setFieldError("UnitID", "Please select Unit...");
          formik.setFieldTouched("UnitID", true);
          return;
        }

        if (values?.BasedOnMeasurementValue == "") {
          formik.setFieldError(
            "BasedOnMeasurementValue",
            "Based On Measurement Value is required field..."
          );
          formik.setFieldTouched("BasedOnMeasurementValue", true);
          return;
        }
      }

      if (
        ListOfTestDefineMoreRates?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 7 //Based On Hrs
        )?.length > 0 &&
        values?.BasedOnHrsValue == ""
      ) {
        formik.setFieldError(
          "BasedOnHrsValue",
          "Based On HrsValue is required field..."
        );
        formik.setFieldTouched("BasedOnHrsValue", true);
        return;
      }
    }

    setIsLoading(true);

    let ListOfTestingResultArray = [];
    Promise.all(
      values?.ListOfParameter?.map((p) => {
        p?.ListOfResultValue?.map((r, rIndex) =>
          ListOfTestingResultArray.push({
            ...r,
            TestingCount: rIndex + 1,
            TestingCountHeader: r?.TestingCountHeader,
            TestingIDEncrypted: values?.TestingIDEncrypt,
            ParameterType: p?.ParameterType,
            RefParameterIDEncrypted: p?.TestMasterParameterIDEncrypted,
            ParameterName: p?.ParameterName,
            DisplayCode: p?.DisplayCode,
            IsNABLParameter: p?.IsNABLParameter,
            MinValue: p?.MinValue,
            MaxValue: p?.MaxValue,
            RangeValue: p?.RangeValue,
            NABLRangeFrom: p?.NABLRangeFrom,
            NABLRangeTo: p?.NABLRangeTo,
            Requirement: p?.Requirement,
            IsDeleted: false,
            TestMethodIDEncrypted: p?.TestMethodIDEncrypt,
            IsSelected: p?.IsSelected,
            IsAverageRequired: p?.IsAverageRequired,
            AverageResultValue: p?.AverageResultValue,
            ParameterSequence: p?.Sequence,
          })
        );
      })
    );

    let ListOfParameterSequence = [];
    Promise.all(
      values?.ListOfParameter?.map((p) => {
        ListOfParameterSequence.push({
          ...p,
          ParameterIDEncrypted: p?.TestMasterParameterIDEncrypted,
        });
      })
    );

    let ListOfMixDesignSieveSizeParameters = [];
    let ListOfMixDesignSieveSizeParametersCriterias = [];
    if (values?.IsMixDesign == true) {
      let columnID = 1;
      Promise.all(
        values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList?.map(
          (item) => {
            item?.ParameterList?.forEach((para) => {
              ListOfMixDesignSieveSizeParameters.push({
                columnID: columnID,
                ReferenceStandardIDEncrypted:
                  values
                    ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                    .ReferenceStandardIDEncrypted,
                SieveSize: item?.SieveSize,
                ParameterColumnName: para.ParameterColumnName,
              });
              para.CriateriaList.forEach((c) => {
                ListOfMixDesignSieveSizeParametersCriterias.push({
                  columnID: columnID,
                  ...c,
                  InputColumnValueofX: c?.InputColumnValueofX
                    ? c?.InputColumnValueofX.toString()
                    : "",
                });
              });
              columnID = columnID + 1;
            });
          }
        )
      );
    }

    let ListOfMixDesignTargetStrengthMixProportioning =
      ListOfMixDesignTargetStrengthForMixProportioning?.map((x) => {
        return {
          ...x,
          VariableValue: x.VariableValue
            ? x.VariableValue.toString()
            : x.VariableValue,
        };
      });

    let payload = {
      ...values,
      UnitID: values?.UnitID ? values?.UnitID : 0,
      BasedOnMeasurementValue: values?.BasedOnMeasurementValue
        ? values?.BasedOnMeasurementValue.toString()
        : "",
      BasedOnHrsValue: values?.BasedOnHrsValue
        ? values?.BasedOnHrsValue.toString()
        : "",
      ReferenceStandardIDEncrypt: values?.ReferenceStandardIDEncrypted,
      TestingDate: values?.TestingDate
        ? moment(values?.TestingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      TestingToDate: values?.TestingToDate
        ? moment(values?.TestingToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      InwardDate: values?.InwardDate
        ? moment(new Date(values?.InwardDate))
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",
      MergeSameValue: values?.IsMergeSameValue,
      TestingStatus:
        values?.btnSubmitType == 1 ? 2 : values?.btnSubmitType == 3 ? 4 : 3,
      Conditione: values?.Condition,
      TestingByIDs: Array.from(
        ListTestingBy?.filter((e) => e.IsSelected == true),
        (x) => x.EmployeeIDEncrypt
      ).join(","),
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      ListOfTPIDetails: values?.ListOfTPIDetails?.map((x, i) => {
        return {
          ...x,
          InwardTPIDetailIDEncrypted: x.TestingTPIIDEncrypt,
          TPIExpectedDate: x.TPIExpectedDate
            ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        };
      }),
      ListOfTestingResultList: ListOfTestingResultArray,
      ListOfParameterSequence: ListOfParameterSequence,
      ListOfTestDefineMoreRates: ListOfTestDefineMoreRates?.filter(
        (e) => e?.IsSelected == true
      ),
      ...values?.TestMixDesignDetail,
      MinimumCementContent: values?.TestMixDesignDetail?.MinimumCementContent
        ? values?.TestMixDesignDetail?.MinimumCementContent.toString()
        : "",
      MaximumCementContent: values?.TestMixDesignDetail?.MaximumCementContent
        ? values?.TestMixDesignDetail?.MaximumCementContent.toString()
        : "",
      MaximumWaterCementRatio: values?.TestMixDesignDetail
        ?.MaximumWaterCementRatio
        ? values?.TestMixDesignDetail?.MaximumWaterCementRatio.toString()
        : "",
      RetentionTime:
        values?.TestMixDesignDetail?.RetentionTime != ""
          ? moment(values?.TestMixDesignDetail?.RetentionTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      TransportationTime:
        values?.TestMixDesignDetail?.TransportationTime != ""
          ? moment(values?.TestMixDesignDetail?.TransportationTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      FreeWaterCementRatio: values?.TestMixDesignDetail?.FreeWaterCementRatio
        ? values?.TestMixDesignDetail?.FreeWaterCementRatio.toString()
        : "",
      ListOfMixDesignSieveSizeParameters: ListOfMixDesignSieveSizeParameters,
      ListOfMixDesignSieveSizeParametersCriterias:
        ListOfMixDesignSieveSizeParametersCriterias,
      ListOfMixDesignTargetStrengthMixProportioning:
        ListOfMixDesignTargetStrengthMixProportioning,
      ListOfMixDesignGroupParameters:
        values.ListOfMixDesignGroupParameters?.map((item) => {
          return {
            ...item,
            ParameterValue: item?.ParameterValue
              ? item?.ParameterValue?.toString()
              : "",
            ResultValue: item?.ResultValue ? item?.ResultValue?.toString() : "",
          };
        }),
      CementContentKgPerM3FinalResult: values?.TestMixDesignDetail
        ?.CementContentKgPerM3FinalResult
        ? values?.TestMixDesignDetail?.CementContentKgPerM3FinalResult.toString()
        : "",
      CementitiousMaterialContentOfCementContentPercentage: values
        ?.TestMixDesignDetail
        ?.CementitiousMaterialContentOfCementContentPercentage
        ? values?.TestMixDesignDetail?.CementitiousMaterialContentOfCementContentPercentage.toString()
        : "",
      ListOfMixDesignMixProportionsForTrial:
        values?.ListOfMixDesignMixProportionsForTrial?.map((x) => {
          return {
            ...x,
            SrNo: x?.SrNo ? x?.SrNo : 0,
            CoarseAggregatePercentageOfFraction:
              x?.CoarseAggregatePercentageOfFraction
                ? x?.CoarseAggregatePercentageOfFraction.toString()
                : "",
            PerM3OfConcreteKg: x?.PerM3OfConcreteKg
              ? x?.PerM3OfConcreteKg.toString()
              : "",
            WaterAbsorptionPercentage: x?.WaterAbsorptionPercentage
              ? x?.WaterAbsorptionPercentage.toString()
              : "",
            WeightOfWaterAbsorptionKg: x?.WeightOfWaterAbsorptionKg
              ? x?.WeightOfWaterAbsorptionKg.toString()
              : "",
            PerM3OfConcreteKgAfterWaterAbsorptionCorrection:
              x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection
                ? x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection.toString()
                : "",
            MoistureContentPercentageOfAggregate:
              x?.MoistureContentPercentageOfAggregate
                ? x?.MoistureContentPercentageOfAggregate.toString()
                : "",
            MoistureContentWeightKg: x?.MoistureContentWeightKg
              ? x?.MoistureContentWeightKg.toString()
              : "",
            PerM3OfConcreteKgAfterMoistureContentCorrection:
              x?.PerM3OfConcreteKgAfterMoistureContentCorrection
                ? x?.PerM3OfConcreteKgAfterMoistureContentCorrection.toString()
                : "",
            LaboratoryMixTrialProportion: x?.LaboratoryMixTrialProportion
              ? x?.LaboratoryMixTrialProportion.toString()
              : "",
          };
        }),
    };

    delete payload[
      "TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData"
    ];
    delete payload["ListOfMixDesignIncludedTest"];
    delete payload["ListOfMixDesignTargetStrengthForMixProportioning"];

    // console.log("payload", payload);
    // return;

    post(POST_TestingSave, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          if (
            values?.ListOfLetterRefDoc?.length > 0 ||
            values?.ListTestingResultImages?.length > 0
          ) {
            let formData = new FormData();
            formData.append("InwardIDEncrypt", values?.InwardIDEncrypt);
            formData.append("TestingIDEncrypt", values?.TestingIDEncrypt);
            formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
            formData.append(
              "InwardDate",
              values?.InwardDate
                ? moment(new Date(values?.InwardDate))
                    .format("YYYY-MM-DD")
                    .replace(/^\-/, "")
                : ""
            );
            formData.append(
              "TestingDate",
              values?.TestingDate
                ? moment(values?.TestingDate)
                    .format("YYYY-MM-DD")
                    .replace(/^\-/, "")
                : ""
            );

            //ListOfLetterRefDoc
            Promise.all(
              values?.ListOfLetterRefDoc?.map((x, i) => {
                formData.append(
                  `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
                  x.InwardLetterRefImageIDEncrypted
                );
                formData.append(
                  `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
                  x.LetterRefImageFile
                );
                formData.append(
                  `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
                  x.LetterRefImageFilePath
                );
                formData.append(
                  `ListOfLetterRefDoc[${i}].IsDeleted`,
                  x.IsDeleted
                );
              })
            );

            //ListOfTestResultImages
            Promise.all(
              values?.ListTestingResultImages?.map((x, i) => {
                formData.append(
                  `ListOfTestResultImages[${i}].TestingResultImageIDEncrypted`,
                  x.TestingResultImageIDEncrypted
                );
                formData.append(
                  `ListOfTestResultImages[${i}].ResultImageFile`,
                  x.TestingResultImageFile
                );
                formData.append(
                  `ListOfTestResultImages[${i}].ResultImagePath`,
                  x.ResultImagePath
                );
                formData.append(
                  `ListOfTestResultImages[${i}].IsDeleted`,
                  x.IsDeleted
                );
                formData.append(
                  `ListOfTestResultImages[${i}].Remarks`,
                  x.Remarks
                );
              })
            );

            postFormData(POST_TestingFilesSave, formData)
              .then((res) => {
                if (res?.IsSuccess) {
                  successMessage(response?.Message); //show success message from main api response
                  if (
                    AuthUser?.Permissions?.TestingAfterSaveStayOnEntryScreen ==
                    true
                  ) {
                    setTimeout(() => {
                      //navigate(`/testing/${InwardMaterialIDParam}`);
                      window.location = `/testing/${InwardMaterialIDParam}`;
                    }, 800);
                  } else {
                    setTimeout(() => {
                      navigate(-1);
                    }, 1000);
                  }
                } else {
                  errorMessage(res?.Message);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
              });
          } else {
            successMessage(response?.Message);
            if (
              AuthUser?.Permissions?.TestingAfterSaveStayOnEntryScreen == true
            ) {
              setTimeout(() => {
                // navigate(`/testing/${InwardMaterialIDParam}`);
                window.location = `/testing/${InwardMaterialIDParam}`;
              }, 800);
            } else {
              setTimeout(() => {
                navigate(-1);
              }, 1000);
            }
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const AddNewParameter = () => {
  //   formikAddParameters.setFieldValue("ParameterIDEncrypted", "");

  //   if (ReferenceStandardIDEncrypted) {
  //     getParametersDDL();
  //     setShowAddParametersModal(true);
  //   } else {
  //     warningMessage("Please select Reference Standard first...");
  //   }
  // };

  useEffect(() => {
    getTestMasterDDLInwardMaterialWise();
    getUnitDDL();
    getCustomerDDL();
    getTestingRemarksList();

    if (InwardMaterialIDParam && !InwardMaterialTestDetailIDParam) {
      getTestingInwardMaterialDetailByID();
    }

    if (InwardMaterialTestDetailIDParam) {
      getTestingDetailByID(InwardMaterialTestDetailIDEncrypt);
    }
  }, []);

  const handleKeyDownDisable = (event) => {
    if (AllowTestingEdit != 1) {
      event.preventDefault(); // Prevent key action
    }
  };

  const getTestingInwardMaterialDetailByID = async () => {
    setIsLoading(true);
    await post(POST_GetTestingsInwardMaterialDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          //Set Details

          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypt);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypt
          );
          formik.setFieldValue("InwardNo", response?.InwardNo);
          formik.setFieldValue("InwardDate", response?.InwardDate);
          formik.setFieldValue(
            "ExpectedDateOfDelivery",
            response?.ExpectedDateOfDelivery
          );
          formik.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formik.setFieldValue("IsTPIRequired", response?.IsTPIRequired);
          formik.setFieldValue("LetterRefNo", response?.LetterRefNo);
          formik.setFieldValue("TCNo", response?.TCNo);
          // formik.setFieldValue(
          //   "DepartmentIDEncrypt",
          //   response?.DepartmentIDEncrypt
          // );
          // formik.setFieldValue("DepartmentName", response?.DepartmentName);
          // formik.setFieldValue(
          //   "ProductGroupIDEncrypt",
          //   response?.MaterialGroupIDEncrypt
          // );
          // formik.setFieldValue("ProductGroupName", response?.MaterialGroupName);
          // formik.setFieldValue(
          //   "MaterialTypeIDEncrypt",
          //   response?.MaterialTypeIDEncrypt
          // );

          // formik.setFieldValue("MaterialTypeName", response?.MaterialType);
          formik.setFieldValue("Size", response?.Size);
          formik.setFieldValue("Condition", response?.Condition);
          formik.setFieldValue("SampleDetail", response?.SampleDetail);
          // formik.setFieldValue("IsReTestTesting", response?.IsReTestTesting);

          formik.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ImagesList?.map((item) => ({
              InwardLetterRefImageIDEncrypted:
                item.InwardLetterRefImageIDEncrypt,
              LetterRefImageFile: "",
              viewFile: "",
              LetterRefImageFileName: item?.LetterRefImageFileName,
              LetterRefImageFilePath: item.LetterRefImageFilePath,
              IsDeleted: false,
            }))
          );

          formik.setFieldValue(
            "ListOfTPIDetails",
            response?.TPIList?.map((x) => {
              return {
                ...x,
                TPIIDEncrypted: x?.TPIIDEncrypt,
                TPIContactPersonIDEncrypted: x?.TPIContactPersonIDEncrypt,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            })
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (ReferenceStandardIDEncrypted) {
      //TestingStatus == 1 (Pending)
      if (TestingStatus == 1) {
        formik.setFieldValue("ParameterWith", 2); //set Print Min/Max
      }
    } else {
      formik.setFieldValue("ParameterWith", 1); //set None
    }
  }, [ReferenceStandardIDEncrypted]);

  const handleChangeTestingQty = (e) => {
    if (e?.target?.value < 1000) {
      formik.setFieldValue("TestingQty", e?.target?.value ?? "");
      let qty = e?.target?.value ?? 0;

      let resultCount = ListOfParameter[0]?.ListOfResultValue?.length;

      if (parseInt(qty) > parseInt(resultCount)) {
        let newAddCount = parseInt(qty) - parseInt(resultCount);
        let newValueList = [];
        for (let index = 0; index < newAddCount; index++) {
          newValueList.push({
            TestingResultIDEncrypted: "",
            TestingCount: resultCount + index + 1,
            TestingCountHeader:
              "Sample:" +
              (resultCount + index + 1 > 9
                ? resultCount + index + 1
                : "0" + (resultCount + index + 1)),
            ResultValue: "",
            ConsiderNABLResult: -1,
            ConsiderResult: -1,
          });
        }

        ListOfParameter?.map((para, iPara) => {
          formik.setFieldValue(`ListOfParameter[${iPara}].ListOfResultValue`, [
            ...para.ListOfResultValue,
            ...newValueList,
          ]);
        });
      } else {
        // let newValueList = [];
        // for (let index = 0; index < parseInt(qty); index++) {
        //   newValueList.push({
        //     TestingResultIDEncrypted: "",
        //     TestingCount: index + 1,
        //     TestingCountHeader:
        //       "Sample:" + (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
        //     ResultValue: "",
        //     ConsiderNABLResult: -1,
        //     ConsiderResult: -1,
        //   });
        // }

        // ListOfParameter?.map((para, iPara) => {
        //   formik.setFieldValue(`ListOfParameter[${iPara}].ListOfResultValue`, [
        //     ...newValueList,
        //   ]);
        //   formik.setFieldValue(
        //     `ListOfParameter[${iPara}].AverageResultValue`,
        //     ""
        //   );
        // });

        Promise.all(
          ListOfParameter?.map((para, iPara) => {
            formik.setFieldValue(
              `ListOfParameter[${iPara}].ListOfResultValue`,
              [...para.ListOfResultValue.slice(0, parseInt(qty))]
            );
          })
        );
        formik.setFieldValue("IsDefaultLoadCalculateAverage", true); //calculate average
      }
    }
  };

  const getTestingDetailByID = async (inwardMaterialTestDetailID) => {
    setIsLoading(true);
    await post(POST_GetTestingsDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      TranDate: "",
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // console.log("response", response);
          //Set Details
          formik.setFieldValue(
            "AllowTestingEdit",
            response?.AllowTestingEdit ?? 0
          );
          formik.setFieldValue(
            "TestMasterIDEncrypt",
            response?.TestMasterIDEncrypt
          );
          formik.setFieldValue("TestingIDEncrypt", response?.TestingIDEncrypt);
          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypt);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypt
          );
          formik.setFieldValue("InwardNo", response?.InwardNo);
          formik.setFieldValue("InwardDate", response?.InwardDate);
          formik.setFieldValue(
            "ExpectedDateOfDelivery",
            response?.ExpectedDateOfDelivery
          );
          formik.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formik.setFieldValue("IsTPIRequired", response?.IsTPIRequired);
          formik.setFieldValue("LetterRefNo", response?.LetterRefNo);
          formik.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ImagesList?.map((item) => ({
              InwardLetterRefImageIDEncrypted:
                item.InwardLetterRefImageIDEncrypt,
              LetterRefImageFile: "",
              viewFile: "",
              LetterRefImageFileName: item?.LetterRefImageFileName,
              // LetterRefImageFileName: item?.LetterRefImageFilePath
              //   ? (item?.LetterRefImageFilePath?.split("/"))[
              //       item?.LetterRefImageFilePath?.split("/").length - 1
              //     ]
              //   : "",
              LetterRefImageFilePath: item.LetterRefImageFilePath,
              IsDeleted: false,
            }))
          );
          formik.setFieldValue("TCNo", response?.TCNo);
          // formik.setFieldValue(
          //   "DepartmentIDEncrypt",
          //   response?.DepartmentIDEncrypt
          // );
          // formik.setFieldValue("DepartmentName", response?.DepartmentName);
          formik.setFieldValue(
            "DepartmentIDEncrypt",
            response?.TestDetails[0]?.DepartmentIDEncrypt
          );
          formik.setFieldValue(
            "DepartmentName",
            response?.TestDetails[0]?.DepartmentName
          );
          // formik.setFieldValue(
          //   "ProductGroupIDEncrypt",
          //   response?.MaterialGroupIDEncrypt
          // );
          // formik.setFieldValue("ProductGroupName", response?.MaterialGroupName);
          // formik.setFieldValue(
          //   "MaterialTypeIDEncrypt",
          //   response?.MaterialTypeIDEncrypt
          // );
          // formik.setFieldValue("MaterialTypeName", response?.MaterialType);
          formik.setFieldValue(
            "ProductGroupIDEncrypt",
            response?.TestDetails[0]?.MaterialGroupIDEncrypt
          );
          formik.setFieldValue(
            "ProductGroupName",
            response?.TestDetails[0]?.MaterialGroupName
          );
          formik.setFieldValue(
            "MaterialTypeIDEncrypt",
            response?.TestDetails[0]?.MaterialTypeIDEncrypt
          );
          formik.setFieldValue(
            "MaterialTypeName",
            response?.TestDetails[0]?.MaterialType
          );
          formik.setFieldValue(
            "SampleNote",
            response?.TestDetails[0]?.TestNote
          );
          formik.setFieldValue(
            "TestingDate",
            response?.TestingDate ? new Date(response?.TestingDate) : new Date()
          );
          formik.setFieldValue(
            "TestingToDate",
            response?.TestingToDate
              ? new Date(response?.TestingToDate)
              : new Date()
          );
          formik.setFieldValue(
            "TestingQty",
            response?.TestDetails[0]?.TestingQty
          );
          formik.setFieldValue(
            "InvoiceQty",
            response?.TestDetails[0]?.InvoiceQty
          );
          formik.setFieldValue("UnitID", response?.TestDetails[0]?.UnitID);
          formik.setFieldValue(
            "BasedOnMeasurementValue",
            response?.TestDetails[0]?.BasedOnMeasurementValue
              ? response?.TestDetails[0]?.BasedOnMeasurementValue
              : ""
          );
          formik.setFieldValue(
            "BasedOnHrsValue",
            response?.TestDetails[0]?.BasedOnHrsValue
              ? response?.TestDetails[0]?.BasedOnHrsValue
              : ""
          );

          formik.setFieldValue(
            "TestMethodIDEncrypt",
            response?.TestDetails[0]?.TestMethodIDEncrypt
          );
          formik.setFieldValue(
            "ReferenceStandardIDEncrypted",
            response?.TestDetails[0]?.ReferenceStandardIDEncrypt
          );
          formik.setFieldValue("MachineIDEncrypt", response?.MachineIDEncrypt);
          formik.setFieldValue("Size", response?.Size);
          formik.setFieldValue("Condition", response?.Condition);
          formik.setFieldValue("SampleDetail", response?.SampleDetail);
          formik.setFieldValue("IsReTestTesting", response?.IsReTestTesting);
          formik.setFieldValue("TestName", response?.TestName);
          formik.setFieldValue("TestingDateDisplay", response?.TestingDate);
          formik.setFieldValue("TestingToDateDisplay", response?.TestingToDate);
          formik.setFieldValue("MachineName", response?.MachineName);
          formik.setFieldValue("UnitName", response?.UnitName);
          formik.setFieldValue("TestMethodName", response?.TestMethodName);
          formik.setFieldValue(
            "ReferenceStandardName",
            response?.ReferenceStandardName
          );
          formik.setFieldValue(
            "IsMixDesign",
            response?.TestDetails[0]?.IsMixDesign
          );
          formik.setFieldValue(
            "TestMixDesignDetail",
            response?.TestMixDesignDetail
          );
          formik.setFieldValue(
            "ListOfMixDesignIncludedTest",
            response?.ListOfMixDesignIncludedTest
          );

          setTestMethodOptions(
            response?.ListOfTestMethod.map((item) => ({
              label: item.NickName
                ? `${item.TestMethod} (${item.NickName})`
                : item.TestMethod,
              value: item?.TestMethodIDEncrypted,
              IsExpiredTestMethod: item?.IsExpiredTestMethod,
            }))
          );
          setReferenceStandardOptions(
            response?.ListOfReferenceStandards?.map((item) => ({
              label: item.ReferenceStandard,
              value: item.ReferenceStandardIDEncrypted,
              IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
            }))
          );
          setProductGroupOptions(
            response?.ListOfProductGroup?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            }))
          );
          setMaterialTypeOptions(
            response?.ListOfMaterialType?.map((item) => ({
              label: item.MaterialTypeName,
              value: item.MaterialTypeIDEncrypted,
            }))
          );
          setMachineOptions(
            response?.ListOfMachines?.map((item) => ({
              label: item?.MachineName,
              value: item?.MachineIDEncrypted,
              IsCalibrationValidity: item?.IsCalibrationValidity,
              IsCalibrationValidityExpire: item?.IsCalibrationValidityExpire,
            }))
          );
          formik.setFieldValue(
            "ListTestingBy",
            response?.TestingByList?.map((item) => ({
              EmployeeIDEncrypt: item.EmployeeIDEncrypted,
              EmployeeName: item.EmployeeName,
              IsSelected: item.IsSelected,
              display: true,
            }))
          );
          formik.setFieldValue(
            "ListOfTPIDetails",
            response?.TPIList?.map((x) => {
              return {
                ...x,
                TPIIDEncrypted: x?.TPIIDEncrypt,
                TPIContactPersonIDEncrypted: x?.TPIContactPersonIDEncrypt,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            })
          );
          formik.setFieldValue(
            "ListTestMasterImages",
            response?.ListOfTestImage?.map((item) => ({
              ...item,
            }))
          );
          formik.setFieldValue(
            "ListTestingResultImages",
            response?.ListOfTestResultImages?.map((item) => ({
              ...item,
              TestingResultImageFile: "",
              viewFile: "",
              IsDeleted: false,
            }))
          );

          formik.setFieldValue("LocationType", response?.LocationType);
          formik.setFieldValue("Result", response?.Result);
          formik.setFieldValue("Remarks", response?.Remarks);
          formik.setFieldValue("ChangeNote", response?.ChangeNote);
          formik.setFieldValue("TestingStatus", response?.TestingStatus);
          //formik.setFieldValue("TestingStatusDDL", response?.TestingStatus);
          formik.setFieldValue(
            "ReferenceSubGroup",
            response?.TestingStatus != 1
              ? response?.ReferenceSubGroup
              : response?.TestDetails[0]?.RefStandardSubGroup
          );
          formik.setFieldValue(
            "ParameterWith",
            response?.ParameterWith == 0
              ? response?.TestDetails[0]?.ReferenceStandardIDEncrypt
                ? 2
                : 1
              : response?.ParameterWith
          );
          formik.setFieldValue("IsMergeSameValue", response?.MergeSameValue);
          let ResultValueList = [];
          if (response?.TestingStatus == 1) {
            if (response?.TestDetails[0]?.TestingQty > 0) {
              for (
                let index = 0;
                index < response?.TestDetails[0]?.TestingQty;
                index++
              ) {
                ResultValueList.push({
                  TestingResultIDEncrypted: "",
                  TestingCount: index + 1,
                  TestingCountHeader:
                    "Sample:" + (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
                  ResultValue: "",
                  ConsiderNABLResult: -1,
                  ConsiderResult: -1,
                });
              }
            } else {
              ResultValueList = [
                {
                  TestingResultIDEncrypted: "",
                  TestingCount: 1,
                  TestingCountHeader: "",
                  ResultValue: "",
                  ConsiderNABLResult: -1,
                  ConsiderResult: -1,
                },
              ];
            }
          }

          let selectedParaCount = response?.ListOfParameter?.filter(
            (x) => x.IsSelected == true
          )?.length;

          let newListOfParameter = response?.ListOfParameter?.map(
            (x, index) => ({
              IsSelected: selectedParaCount > 0 ? x?.IsSelected : true, //by default selected if there is no parameters selected (this is for Old records before parameter selection development)
              Sequence: index + 1,
              TestMasterParameterIDEncrypted: x?.TestMasterParameterIDEncrypted,
              ParameterIDEncrypted: x?.ParameterIDEncrypted,
              DisplayCode: x?.DisplayCode,
              ParameterName: x?.ParameterName,
              ParameterType: x?.ParameterType,
              IsNABLParameter: x?.IsNABLParameter,
              RangeValue: x?.RangeValue,
              MinValue: x?.MinValue
                ? x?.MinValue
                : x?.ListOfRange?.length == 1
                ? x?.ListOfRange[0]?.MinValue
                : "",
              MaxValue: x?.MaxValue
                ? x?.MaxValue
                : x?.ListOfRange?.length == 1
                ? x?.ListOfRange[0]?.MaxValue
                : "",
              //Requirement: x?.Requirement,
              Requirement:
                response?.TestingStatus != 1
                  ? x?.Requirement
                  : x?.ListOfRange?.length == 1
                  ? x?.ListOfRange[0]?.Requirement
                  : x?.Requirement,

              TestMethodIDEncrypt: x?.TestMethodIDEncrypted
                ? x?.ListOfParameterTestMethod?.filter(
                    (method) =>
                      method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                  )?.length == 0
                  ? ""
                  : x?.TestMethodIDEncrypted
                : "",
              testMethodOptions: x?.ListOfParameterTestMethod?.map(
                (method) => ({
                  ...method,
                  label: method.NickName
                    ? `${method.TestMethod} (${method.NickName})`
                    : method.TestMethod,
                  value: method?.TestMethodIDEncrypted,
                })
              ),

              // NABLRangeFrom: x?.NABLRangeFrom
              //   ? x?.NABLRangeFrom
              //   : x?.ParameterType == 1 &&
              //     response?.TestDetails[0]?.TestMethodIDEncrypt
              //   ? response?.ParametersNABLRangeList?.filter(
              //       (n) =>
              //         n.ParameterIDEncrypted == x.ParameterIDEncrypted &&
              //         n.TestMethodIDEncrypted ==
              //           response?.TestDetails[0]?.TestMethodIDEncrypt
              //     )[0]?.NABLRangeFrom ?? ""
              //   : "",
              // NABLRangeTo: x?.NABLRangeTo
              //   ? x?.NABLRangeTo
              //   : x?.ParameterType == 1 &&
              //     response?.TestDetails[0]?.TestMethodIDEncrypt
              //   ? response?.ParametersNABLRangeList?.filter(
              //       (n) =>
              //         n.ParameterIDEncrypted == x.ParameterIDEncrypted &&
              //         n.TestMethodIDEncrypted ==
              //           response?.TestDetails[0]?.TestMethodIDEncrypt
              //     )[0]?.NABLRangeTo ?? ""
              //   : "",
              NABLRangeFrom: x?.NABLRangeFrom
                ? x?.ListOfParameterTestMethod?.filter(
                    (method) =>
                      method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                  )?.length == 0
                  ? ""
                  : x?.NABLRangeFrom
                : "",
              NABLRangeTo: x?.NABLRangeTo
                ? x?.ListOfParameterTestMethod?.filter(
                    (method) =>
                      method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                  )?.length == 0
                  ? ""
                  : x?.NABLRangeTo
                : "",

              rangeOptions: x?.ListOfRange?.filter(
                (x) => x.RangeValue != ""
              )?.map((range) => ({
                label: range?.RangeValue,
                value: range?.RangeValue,
                MinValue: range?.MinValue,
                MaxValue: range?.MaxValue,
                Requirement: range?.Requirement,
                DefaultValue: range?.DefaultValue,
              })),

              ListOfResultValue: response?.IsReTestTesting
                ? x?.ListOfResultValue?.map((result, index) => ({
                    TestingResultIDEncrypted: result?.TestingResultIDEncrypted,
                    TestingCount: result?.TestingCount,
                    TestingCountHeader: result?.TestingCountHeader,
                    ResultValue: result?.ResultValue,
                    ConsiderNABLResult: result?.ConsiderNABLResult,
                    ConsiderResult: result?.ConsiderResult,
                  }))
                : response?.TestingStatus != 1
                ? x?.ListOfResultValue?.map((result, index) => ({
                    TestingResultIDEncrypted: result?.TestingResultIDEncrypted,
                    TestingCount: result?.TestingCount,
                    TestingCountHeader: result?.TestingCountHeader
                      ? result?.TestingCountHeader
                      : "Sample:" +
                        (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
                    ResultValue: result?.ResultValue,
                    ConsiderNABLResult: result?.ConsiderNABLResult,
                    ConsiderResult: result?.ConsiderResult,
                  }))
                : ResultValueList?.map((r) => ({
                    ...r,
                    //ResultValue: x?.ResultValue,
                    ResultValue:
                      x?.ListOfRange?.length == 1
                        ? x?.ListOfRange[0]?.DefaultValue
                        : x?.ResultValue,
                  })),

              // ListOfResultValue:
              //   response?.TestingStatus != 1
              //     ? x?.ListOfResultValue?.map((result) => ({
              //         TestingResultIDEncrypted:
              //           result?.TestingResultIDEncrypted,
              //         TestingCount: result?.TestingCount,
              //         ResultValue: result?.ResultValue,
              //         ConsiderNABLResult: result?.ConsiderNABLResult,
              //         ConsiderResult: result?.ConsiderResult,
              //       }))
              //     : ResultValueList?.map((r) => ({
              //         ...r,
              //         ResultValue: x?.ResultValue,
              //       })),

              ShortCode: x?.ShortCode,
              FormulaExpression: x?.FormulaExpression,
              FormulaVariables: x?.FormulaVariables,
              FormulaEvaluationStatus: x?.FormulaEvaluationStatus,
              IsAverageRequired: x?.IsAverageRequired,
              AverageResultValue: x?.AverageResultValue,
              ParameterResultType: x?.ParameterResultType,
            })
          );

          /*Reorder - Sequence, if All parameters are not selected*/
          if (
            selectedParaCount > 0 &&
            response?.ListOfParameter?.filter((x) => x.IsSelected == false)
              ?.length > 0
          ) {
            let newList = [];
            Promise.all(
              newListOfParameter
                ?.filter((para) => para?.IsSelected == true)
                ?.map((x, idx) => {
                  newList.push({
                    ...x,
                    Sequence: idx + 1,
                  });
                })
            );
            newList = [
              ...newList,
              ...newListOfParameter?.filter(
                (para) => para?.IsSelected == false
              ),
            ];

            newListOfParameter = newList;
          }

          formik.setFieldValue("ListOfParameter", newListOfParameter);

          setParametersNABLRangeList(response?.ParametersNABLRangeList);

          getRefSubGroupAndRangeDDL(
            response?.TestMasterIDEncrypt,
            response?.TestDetails[0]?.ReferenceStandardIDEncrypt,
            response?.TestingStatus
          );

          formikDefineMoreRates.setFieldValue(
            "MoreTestRatesList",
            response?.ListOfTestDefineMoreRates?.map((itemsubRate) => ({
              TestMasterDefineMoreRatesIDEncrypted:
                itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
              InwardMaterialTestDetailIDEncrypted:
                itemsubRate?.InwardMaterialTestDetailIDEncrypted,
              TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
              RateType: itemsubRate?.RateType,
              RateTypeName: itemsubRate?.RateTypeName,
              IsSelected: itemsubRate?.IsSelected,
            }))
          );

          formik.setFieldValue(
            "ListOfTestDefineMoreRates",
            response?.ListOfTestDefineMoreRates?.map((itemsubRate) => ({
              TestMasterDefineMoreRatesIDEncrypted:
                itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
              InwardMaterialTestDetailIDEncrypted:
                itemsubRate?.InwardMaterialTestDetailIDEncrypted,
              TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
              RateType: itemsubRate?.RateType,
              RateTypeName: itemsubRate?.RateTypeName,
              IsSelected: itemsubRate?.IsSelected,
            }))
          );

          if (response?.TestDetails[0]?.IsMixDesign == true) {
            getMixDesignMasterDDLAll(response?.TestMasterIDEncrypt, response);
            getMixDesignIncludedTestResultDetails(
              response?.ListOfMixDesignIncludedTest
            );
            formikTestPrameters.setFieldValue(
              "ParametersList",
              newListOfParameter
            );
            formikTestPrameters.setFieldValue(
              "selectAllPara",
              newListOfParameter?.filter((x) => x.IsSelected == false)?.length >
                0
                ? false
                : true
            );
            formik.setFieldValue(
              "TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData",
              response?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
            );
            formik.setFieldValue(
              "ListOfMixDesignTargetStrengthForMixProportioning",
              response?.ListOfMixDesignTargetStrengthForMixProportioning
            );
            formik.setFieldValue(
              "ListOfMixDesignGroupParameters",
              response?.ListOfMixDesignGroupParameters
            );
            formik.setFieldValue(
              "ListOfMixDesignMixCalculation",
              response?.ListOfMixDesignMixCalculation
            );
            formik.setFieldValue(
              "ListOfMixDesignMixProportionsForTrial",
              response?.ListOfMixDesignMixProportionsForTrial
            );
          }

          setDepartmentOptions(
            response?.DepartmentList?.map((item) => ({
              label: item?.DepartmentName,
              value: item?.DepartmentIDEncrypted,
              IsNABLScopeExpired: item?.IsNABLScopeExpired,
            }))
          );

          if (response?.TestDetails[0]?.DepartmentIDEncrypt) {
            response?.DepartmentList?.map((item) => {
              if (
                item?.DepartmentIDEncrypted ==
                response?.TestDetails[0]?.DepartmentIDEncrypt
              ) {
                if (item?.IsNABLScopeExpired == true) {
                  customConfirmDialog(
                    `${item?.DepartmentName} Scope is Expired`,
                    `Do you want to continue?`,
                    () => {
                      if (
                        AuthUser?.Permissions
                          ?.TestingAfterSaveStayOnEntryScreen == true
                      ) {
                        navigate("/testing-list");
                      } else {
                        navigate(-1);
                      }
                    },
                    false
                  );
                }
              }
            });
          }

          if (response?.TestingStatus == 1) {
            /* Comment below code b'coz parameter wise test method NABL range change on test method selection */
            // formik.setFieldValue("IsNABLRangeChange", true);
            if (response?.TestDetails[0]?.RefStandardSubGroup) {
              setSelectedSubGroup(true);
            }
            formik.setFieldValue("IsDefaultLoad", true);
            formik.setFieldValue("IsDefaultLoadCalculateAverage", true);
          }
        } else {
          //Reset Details
          formik.setFieldValue("AllowTestingEdit", 0);
          formik.setFieldValue("TestMasterIDEncrypt", "");
          formik.setFieldValue("TestingIDEncrypt", "");
          formik.setFieldValue("InwardIDEncrypt", "");
          formik.setFieldValue("CustomerProjectIDEncrypted", "");
          formik.setFieldValue("InwardNo", "");
          formik.setFieldValue("InwardDate", "");
          formik.setFieldValue("ExpectedDateOfDelivery", "");
          formik.setFieldValue("IsMaterialReturnable", false);
          formik.setFieldValue("IsTPIRequired", false);
          formik.setFieldValue("LetterRefNo", "");
          formik.setFieldValue("ListOfLetterRefDoc", []);
          formik.setFieldValue("TCNo", "");
          formik.setFieldValue("DepartmentIDEncrypt", "");
          formik.setFieldValue("DepartmentName", "");
          formik.setFieldValue("ProductGroupIDEncrypt", "");
          formik.setFieldValue("ProductGroupName", "");
          formik.setFieldValue("MaterialTypeIDEncrypt", "");
          formik.setFieldValue("MaterialTypeName", "");
          formik.setFieldValue("SampleNote", "");
          formik.setFieldValue("TestingDate", new Date());
          formik.setFieldValue("TestingToDate", new Date());
          formik.setFieldValue("TestingQty", "");
          formik.setFieldValue("InvoiceQty", "");
          formik.setFieldValue("UnitID", "");
          formik.setFieldValue("TestMethodIDEncrypt", "");
          formik.setFieldValue("ReferenceStandardIDEncrypted", "");
          formik.setFieldValue("MachineIDEncrypt", "");
          formik.setFieldValue("Size", "");
          formik.setFieldValue("Condition", "");
          formik.setFieldValue("SampleDetail", "");
          formik.setFieldValue("LocationType", 1);
          setTestMethodOptions([]);
          setReferenceStandardOptions([]);
          setProductGroupOptions([]);
          setMaterialTypeOptions([]);
          setMachineOptions([]);
          formik.setFieldValue("ListTestingBy", []);
          formik.setFieldValue("ListOfTPIDetails", []);
          formik.setFieldValue("ListTestMasterImages", []);
          formik.setFieldValue("ListTestingResultImages", []);
          formik.setFieldValue("Result", "");
          formik.setFieldValue("Remarks", "");
          formik.setFieldValue("ChangeNote", "");
          formik.setFieldValue("TestingStatus", "");
          formik.setFieldValue("ReferenceSubGroup", "");
          formik.setFieldValue("ParameterWith", 1);
          formik.setFieldValue("IsMergeSameValue", false);
          setRefSubGroupOptions([]);
          setParametersRangeList([]);
          setParametersNABLRangeList([]);
          formik.setFieldValue("ListOfParameter", []);
          formik.setFieldValue("BasedOnMeasurementValue", "");
          formik.setFieldValue("BasedOnHrsValue", "");
          formikDefineMoreRates.setFieldValue("MoreTestRatesList", []);
          formik.setFieldValue("IsMixDesign", false);
          formik.setFieldValue(
            "TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData",
            {}
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getParametersDDL = async () => {
  //   //setIsLoading(true);
  //   setParametersOptions([
  //     {
  //       value: "lrQ+Ao+IEjI=",
  //       label: "P1",
  //       DisplayName: "P-2",
  //     },
  //     {
  //       value: "lrQ+Ao+IEjJ=",
  //       label: "P2",
  //       DisplayName: "P-1",
  //     },
  //   ]);
  // };

  const getRefSubGroupAndRangeDDL = async (
    testMasterID,
    referenceStandardID,
    testingStatus
  ) => {
    if (testMasterID && referenceStandardID) {
      setIsLoading(true);
      await post(
        POST_DDLParametersRange_SubGroupByReferenceStandardID_TestMasterID,
        {
          TestMasterIDEncrypted: testMasterID,
          ReferenceStandardIDEncrypted: referenceStandardID,
        }
      )
        .then((response) => {
          if (response?.IsSuccess) {
            setRefSubGroupOptions(
              response?.SubGroupList?.map((item) => ({
                label: item.SubGroup,
                value: item.SubGroup,
              }))
            );
            setParametersRangeList(
              response?.RangeList?.map((item) => ({
                ...item,
              }))
            );

            /*select the value when there is only one option while insert only*/
            if (response?.SubGroupList?.length == 1 && testingStatus == 1) {
              setSingleSubGroupSelect(true);
            }
          } else {
            setRefSubGroupOptions([]);
            setParametersRangeList([]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setRefSubGroupOptions([]);
      setParametersRangeList([]);
    }
  };

  useEffect(() => {
    if (singleSubGroupSelect == true) {
      formik.setFieldValue(
        "ReferenceSubGroup",
        refSubGroupOptions[0]?.value ?? ""
      );
      handleChangeReferenceSubGroup(refSubGroupOptions[0]?.value ?? "");
      setSingleSubGroupSelect(false);
    }
  }, [singleSubGroupSelect]);

  useEffect(() => {
    if (selectedSubGroup == true && parametersRangeList?.length > 0) {
      handleChangeReferenceSubGroup(formik.values?.ReferenceSubGroup);
      setSelectedSubGroup(false);
    }
  }, [selectedSubGroup, parametersRangeList]);

  const handleChangeReferenceSubGroup = (subGroup) => {
    //set standard parameters rangeOptions from parametersRangeList on SubGroup change
    formik.setFieldValue(
      "ListOfParameter",
      ListOfParameter?.map((para) => ({
        ...para,
        RangeValue: para?.ParameterType == 1 ? "" : para.RangeValue,
        MinValue:
          para?.ParameterType == 1
            ? parametersRangeList?.filter(
                (x) =>
                  x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                  x.SubGroup == subGroup
              )?.length == 1
              ? parametersRangeList?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                )[0]?.MinValue
              : ""
            : para.MinValue,
        MaxValue:
          para?.ParameterType == 1
            ? parametersRangeList?.filter(
                (x) =>
                  x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                  x.SubGroup == subGroup
              )?.length == 1
              ? parametersRangeList?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                )[0]?.MaxValue
              : ""
            : para.MaxValue,
        rangeOptions:
          para?.ParameterType == 1
            ? parametersRangeList
                ?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup &&
                    x.RangeValue != ""
                )
                ?.map((range) => ({
                  label: range?.RangeValue,
                  value: range?.RangeValue,
                  MinValue: range?.MinValue,
                  MaxValue: range?.MaxValue,
                  Requirement: range?.Requirement,
                  DefaultValue: range?.DefaultValue,
                }))
            : para?.rangeOptions,
        Requirement:
          para?.ParameterType == 1
            ? parametersRangeList?.filter(
                (x) =>
                  x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                  x.SubGroup == subGroup
              )?.length == 1
              ? parametersRangeList?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                )[0]?.Requirement
              : ""
            : para?.Requirement,
        ListOfResultValue:
          TestingStatus == 1 && IsReTestTesting == false
            ? para?.ListOfResultValue?.map((result) => {
                return {
                  ...result,
                  ResultValue:
                    para?.ParameterType == 1
                      ? parametersRangeList?.filter(
                          (x) =>
                            x.ParameterIDEncrypted ==
                              para.ParameterIDEncrypted &&
                            x.SubGroup == subGroup
                        )?.length == 1
                        ? parametersRangeList?.filter(
                            (x) =>
                              x.ParameterIDEncrypted ==
                                para.ParameterIDEncrypted &&
                              x.SubGroup == subGroup
                          )[0]?.DefaultValue
                        : ""
                      : result?.ResultValue,
                };
              })
            : para.ListOfResultValue,
      }))
    );

    // //set parameters result to non identified
    // for (let p = 0; p < ListOfParameter?.length; p++) {
    //   for (let i = 0; i < ListOfParameter[p]?.ListOfResultValue?.length; i++) {
    //     formik.setFieldValue(
    //       `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderResult`,
    //       -1
    //     );
    //   }
    // }

    formik.setFieldValue("IsDefaultLoad", true); //Consider Result
  };

  const handleChangeTestMethod = async (testMethodID, IsExpiredTestMethod) => {
    // //set standard parameters NABL Range on TestMethod Change
    // formik.setFieldValue(
    //   "ListOfParameter",
    //   ListOfParameter?.map((para) => ({
    //     ...para,
    //     NABLRangeFrom:
    //       para?.ParameterType == 1
    //         ? parametersNABLRangeList?.filter(
    //             (x) =>
    //               x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
    //               x.TestMethodIDEncrypted == testMethodID
    //           )[0]?.NABLRangeFrom
    //         : para.NABLRangeFrom,
    //     NABLRangeTo:
    //       para?.ParameterType == 1
    //         ? parametersNABLRangeList?.filter(
    //             (x) =>
    //               x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
    //               x.TestMethodIDEncrypted == testMethodID
    //           )[0]?.NABLRangeTo
    //         : para.NABLRangeTo,
    //   }))
    // );

    // formik.setFieldValue("IsNABLRangeChange", true);

    if (IsExpiredTestMethod) {
      warningMessage("Test Method is Expired..!");
      formik.setFieldValue("TestMethodIDEncrypt", "");
      return;
    }
    formik.setFieldValue("TestMethodIDEncrypt", testMethodID);

    /*To set selected test method to all parameters test method which is having same method and not selected*/
    ListOfParameter?.map((x, i) => {
      if (x?.ParameterType == 1) {
        if (
          !x?.TestMethodIDEncrypt &&
          x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)
            ?.length > 0
        ) {
          formik.setFieldValue(
            `ListOfParameter[${i}].TestMethodIDEncrypt`,
            testMethodID
          );
          formik.setFieldValue(
            `ListOfParameter[${i}].NABLRangeFrom`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeFrom
          );
          formik.setFieldValue(
            `ListOfParameter[${i}].NABLRangeTo`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeTo
          );
        }
      }
    });

    formik.setFieldValue("IsNABLRangeChange", true);

    // if (!testMethodID) {
    //   formik.setFieldValue("TestMethodIDEncrypt", "");
    // }

    // if (
    //   testMethodID &&
    //   testMethodID != TestMethodIDEncrypt &&
    //   InwardMaterialIDEncrypt &&
    //   InwardMaterialTestDetailIDEncrypt
    // ) {
    //   swal({
    //     title: "Are you sure you want to change the Test Method?",
    //     text: "Testing parameters result value will be reset!",
    //     icon: "warning",
    //     buttons: true,
    //     dangerMode: true,
    //     //buttons: ["No", "Yes"],
    //     buttons: {
    //       cancel: {
    //         text: "No",
    //         value: false,
    //         visible: true,
    //         className: "btn-sm",
    //       },
    //       confirm: {
    //         text: "Yes",
    //         value: true,
    //         visible: true,
    //         className: "btn-sm",
    //         closeModal: true,
    //       },
    //     },
    //   }).then(async (willDo) => {
    //     if (willDo) {
    //       formik.setFieldValue("TestMethodIDEncrypt", testMethodID);

    //       setIsLoading(true);

    //       let ResultValueList = [];
    //       if (TestingQty > 0) {
    //         for (let index = 0; index < TestingQty; index++) {
    //           ResultValueList.push({
    //             TestingResultIDEncrypted: "",
    //             TestingCount: index + 1,
    //             ResultValue: "",
    //             ConsiderNABLResult: -1,
    //             ConsiderResult: -1,
    //           });
    //         }
    //       } else {
    //         ResultValueList = [
    //           {
    //             TestingResultIDEncrypted: "",
    //             TestingCount: 1,
    //             ResultValue: "",
    //             ConsiderNABLResult: -1,
    //             ConsiderResult: -1,
    //           },
    //         ];
    //       }

    //       await post(POST_GetTestingsParametersListOnTestMethodChange, {
    //         CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    //         BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    //         InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
    //         InwardMaterialTestDetailIDEncrypted:
    //           InwardMaterialTestDetailIDEncrypt,
    //         TestMethodIDEncrypted: testMethodID,
    //         ReferenceStandardIDEncrypted: ReferenceStandardIDEncrypted
    //           ? ReferenceStandardIDEncrypted
    //           : "",
    //       })
    //         .then((response) => {
    //           if (response?.IsSuccess) {
    //             formik.setFieldValue(
    //               "ListOfParameter",
    //               response?.ListOfParameter?.map((x, index) => ({
    //                 Sequence: index + 1,
    //                 TestMasterParameterIDEncrypted:
    //                   x?.TestMasterParameterIDEncrypted,
    //                 ParameterIDEncrypted: x?.ParameterIDEncrypted,
    //                 DisplayCode: x?.DisplayCode,
    //                 ParameterName: x?.ParameterName,
    //                 ParameterType: x?.ParameterType,
    //                 IsNABLParameter: x?.IsNABLParameter,
    //                 RangeValue: x?.RangeValue,
    //                 MinValue: x?.MinValue
    //                   ? x?.MinValue
    //                   : x?.ListOfRange?.length == 1
    //                   ? x?.ListOfRange[0]?.MinValue
    //                   : "",
    //                 MaxValue: x?.MaxValue
    //                   ? x?.MaxValue
    //                   : x?.ListOfRange?.length == 1
    //                   ? x?.ListOfRange[0]?.MaxValue
    //                   : "",
    //                 Requirement: x?.Requirement,
    //                 NABLRangeFrom: x?.NABLRangeFrom
    //                   ? x?.NABLRangeFrom
    //                   : x?.ParameterType == 1 && testMethodID
    //                   ? parametersNABLRangeList?.filter(
    //                       (n) =>
    //                         n.ParameterIDEncrypted == x.ParameterIDEncrypted &&
    //                         n.TestMethodIDEncrypted == testMethodID
    //                     )[0]?.NABLRangeFrom ?? ""
    //                   : "",
    //                 NABLRangeTo: x?.NABLRangeTo
    //                   ? x?.NABLRangeTo
    //                   : x?.ParameterType == 1 && testMethodID
    //                   ? parametersNABLRangeList?.filter(
    //                       (n) =>
    //                         n.ParameterIDEncrypted == x.ParameterIDEncrypted &&
    //                         n.TestMethodIDEncrypted == testMethodID
    //                     )[0]?.NABLRangeTo ?? ""
    //                   : "",
    //                 rangeOptions: x?.ListOfRange?.filter(
    //                   (x) => x.RangeValue != ""
    //                 )?.map((range) => ({
    //                   label: range?.RangeValue,
    //                   value: range?.RangeValue,
    //                   MinValue: range?.MinValue,
    //                   MaxValue: range?.MaxValue,
    //                 })),

    //                 ListOfResultValue: ResultValueList?.map((r) => ({
    //                   ...r,
    //                   ResultValue: x?.ResultValue,
    //                 })),
    //               }))
    //             );
    //           }
    //           setIsLoading(false);
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //           setIsLoading(false);
    //         });
    //     }
    //   });
    // }
  };

  const handleChangeTestMethodParameter = async (
    index,
    testMethodID,
    IsExpiredTestMethod
  ) => {
    if (IsExpiredTestMethod) {
      warningMessage("Test Method is Expired..!");
      formik.setFieldValue(`ListOfParameter[${index}].TestMethodIDEncrypt`, "");
      return;
    }
    formik.setFieldValue(
      `ListOfParameter[${index}].TestMethodIDEncrypt`,
      testMethodID
    );
    formik.setFieldValue(
      `ListOfParameter[${index}].NABLRangeFrom`,
      ListOfParameter[index]?.testMethodOptions?.filter(
        (opt) => opt.value == testMethodID
      )[0]?.NABLRangeFrom
    );
    formik.setFieldValue(
      `ListOfParameter[${index}].NABLRangeTo`,
      ListOfParameter[index]?.testMethodOptions?.filter(
        (opt) => opt.value == testMethodID
      )[0]?.NABLRangeTo
    );

    /*To set selected test method to all parameters test method which is having same method and not selected*/
    ListOfParameter?.map((x, i) => {
      if (index != i && x?.ParameterType == 1) {
        if (
          !x?.TestMethodIDEncrypt &&
          x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)
            ?.length > 0
        ) {
          formik.setFieldValue(
            `ListOfParameter[${i}].TestMethodIDEncrypt`,
            testMethodID
          );
          formik.setFieldValue(
            `ListOfParameter[${i}].NABLRangeFrom`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeFrom
          );
          formik.setFieldValue(
            `ListOfParameter[${i}].NABLRangeTo`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeTo
          );
        }
      }
    });

    formik.setFieldValue("IsNABLRangeChange", true);
  };

  useEffect(() => {
    if (IsNABLRangeChange) {
      OnNABLRangeChangeConsiderNABLResult();
    }
  }, [IsNABLRangeChange]);

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      //TPIFlag: -1, // -1 = All (Customer & TPI both)
      TPIFlag: 1, // 1 = TPI Only
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPICustomerOptions(
            response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
              (item) => ({
                label: item.CustomerName,
                value: item.CustomerIDEncrypted,
              })
            )
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  // const getTPIContactPersonDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerProjectContactPersonDDLList, {
  //     CustomerIDEncrypted: TPIIDEncrypted,
  //     CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setTPIContactPersonOptions(
  //           response?.ContactPersonDDLList?.map((item) => ({
  //             label: item.ContactPerson,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getTPIContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: TPIIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getUnitDDL = () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, // Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            }))
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  const handleChangeSearchTestingBy = (e) => {
    formik.setFieldValue("searchTestingBy", e?.target?.value);
    formik.setFieldValue(
      "ListTestingBy",
      ListTestingBy?.map((x) => {
        return {
          ...x,
          display: x.EmployeeName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const deleteTPI = (i) => {
    if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
      formik.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfTPIDetails",
        ListOfTPIDetails?.filter((x, ix) => ix != i)
      );
    }
  };

  const addNewTPI = () => {
    formikTPIDetail.resetForm();
    setShowAddTPIDetailModal(true);
  };

  const validationSchemaTPIDetail = Yup.object().shape({
    TPIIDEncrypted: Yup.string().required("TPI is required field"),
    TPIContactPersonIDEncrypted: Yup.string().required(
      "TPI Contact Person is required field"
    ),
  });

  const formikTPIDetail = useFormik({
    validationSchema: validationSchemaTPIDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIDetail(values, formikHelpers),
    initialValues: {
      TPIIDEncrypted: "",
      TPIContactPersonIDEncrypted: "",
      TPIExpectedDate: "",
      TPIName: "",
      TPIContactPersonName: "",
      displayTPIExpectedDate: "",
      editIndexTPI: "",
      actionFlagTPI: 0, // 0 = Add,  1 = edit
      IsDeleted: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { TPIIDEncrypted, actionFlagTPI },
  } = formikTPIDetail;

  useEffect(() => {
    if (TPIIDEncrypted) {
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
      getTPIContactPersonDDL();
    } else {
      setTPIContactPersonOptions([]);
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
    }
  }, [TPIIDEncrypted]);

  const handleValidSubmitTPIDetail = (values) => {
    if (values?.editIndexTPI !== "") {
      if (
        ListOfTPIDetails?.filter(
          (x, i) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false &&
            i != values?.editIndexTPI
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.map((x, idx) => {
            if (idx == values?.editIndexTPI) {
              return {
                ...x,
                TPIIDEncrypted: values?.TPIIDEncrypted,
                TPIContactPersonIDEncrypted:
                  values?.TPIContactPersonIDEncrypted,
                TPIExpectedDate: values?.TPIExpectedDate,
                TPIName: values?.TPIName,
                TPIContactPersonName: values?.TPIContactPersonName,
                displayTPIExpectedDate: values?.TPIExpectedDate
                  ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                  : "",
              };
            } else {
              return { ...x };
            }
          })
        );
      }
    } else {
      if (
        ListOfTPIDetails?.filter(
          (x) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue("ListOfTPIDetails", [
          ...ListOfTPIDetails,
          {
            ...values,
            displayTPIExpectedDate: values?.TPIExpectedDate
              ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
              : "",
          },
        ]);
      }
    }
    setShowAddTPIDetailModal(false);
  };

  const getTestMasterDDLInwardMaterialWise = async () => {
    setIsLoading(true);
    await post(POST_DDLGetTestMasterByInwardMaterialID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestMasterOptions(
            response?.List?.map((item) => ({
              label: item.TestName,
              value: item.InwardMaterialTestDetailIDEncrypted,
              //TestingStatusDDL: item.TestingStatus,
              AllowTestingEdit: item?.AllowTestingEdit,
            }))
          );

          // if (response?.List?.length == 1) {
          //   formik.setFieldValue(
          //     "InwardMaterialTestDetailIDEncrypt",
          //     response?.List[0].InwardMaterialTestDetailIDEncrypted
          //   );
          // }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  const handleChangeTest = (e) => {
    formik.setFieldValue("InwardMaterialTestDetailIDEncrypt", e?.value ?? "");
    formik.setFieldValue("AllowTestingEdit", e?.AllowTestingEdit ?? 0);
    //formik.setFieldValue("TestingStatusDDL", e?.TestingStatusDDL ?? "");

    getTestingDetailByID(e?.value ?? "");
  };

  // const validationSchemaAddParameters = Yup.object().shape({
  //   ParameterIDEncrypted: Yup.string().required("Parameter is required field"),
  // });

  // const formikAddParameters = useFormik({
  //   validationSchema: validationSchemaAddParameters,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidSubmitAddParameters(values, formikHelpers),
  //   initialValues: {
  //     ParameterIDEncrypted: "",
  //     ParameterName: "",
  //     DisplayName: "",
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: { ParameterIDEncrypted },
  // } = formikAddParameters;

  // const handleValidSubmitAddParameters = (values) => {
  //   formik.setFieldValue("ListOfParameter", [
  //     ...ListOfParameter,
  //     {
  //       InwardMaterialIDEncrypt: "",
  //       Code: values?.DisplayName,
  //       Name: values?.ParameterName,
  //       RangeID: "",
  //       RangeTitle: "",
  //       Min: "",
  //       Max: "",
  //       Requirement: "",
  //       Value: "",
  //       IsNABL: false,
  //       IsDeleted: false,
  //     },
  //   ]);

  //   getRangeDDL();
  //   setShowAddParametersModal(false);
  // };

  const uploadLetterRefDoc = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      //console.log(file);
      if (file) {
        formik.setFieldValue("ListOfLetterRefDoc", [
          ...ListOfLetterRefDoc,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);
      }
    }
  };

  const deleteLetterRefDoc = (i) => {
    if (ListOfLetterRefDoc[i]?.InwardLetterRefImageIDEncrypted) {
      formik.setFieldValue(`ListOfLetterRefDoc[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfLetterRefDoc",
        ListOfLetterRefDoc?.filter((x, ix) => ix != i)
      );
    }
  };

  const uploadCSVFile = (event, index) => {
    if (TestMasterIDEncrypt) {
      if (MachineIDEncrypt) {
        if (event.target.files.length === 1) {
          var pattern = /csv-*/;
          if (event.target.files[0].type.match(pattern)) {
            event.preventDefault();
            let file;
            if (event.dataTransfer) {
              file = event.dataTransfer.files[0];
            } else if (event.target) {
              file = event.target.files[0];
            }
            setIsLoading(true);
            let formData = new FormData();
            formData.append("MachineIDEncrypted", MachineIDEncrypt);
            formData.append("TestMasterIDEncrypted", TestMasterIDEncrypt);
            formData.append("csvFile", file);
            postFormData(POST_TestingCSVFileImport, formData)
              .then((response) => {
                if (response?.IsSuccess) {
                  //successMessage(response?.Message);
                  if (response?.csvParameterResultList?.length > 0) {
                    Promise.all(
                      ListOfParameter?.map((para, pIndex) => {
                        // if (para.ParameterType == 1) {
                        if (
                          response?.csvParameterResultList?.filter(
                            (x) =>
                              x.ParameterIDEncrypted ==
                                para.ParameterIDEncrypted &&
                              x.ParameterType == para.ParameterType
                          )?.length > 0
                        ) {
                          formik.setFieldValue(
                            `ListOfParameter[${pIndex}].ListOfResultValue[${index}].ResultValue`,
                            response?.csvParameterResultList?.filter(
                              (x) =>
                                x.ParameterIDEncrypted ==
                                  para.ParameterIDEncrypted &&
                                x.ParameterType == para.ParameterType
                            )[0]?.csvParameterResultValue
                          );
                          OnResultValueChangeConsiderResult(
                            pIndex,
                            index,
                            para?.MinValue,
                            para?.MaxValue,
                            response?.csvParameterResultList?.filter(
                              (x) =>
                                x.ParameterIDEncrypted ==
                                  para.ParameterIDEncrypted &&
                                x.ParameterType == para.ParameterType
                            )[0]?.csvParameterResultValue,
                            para?.ParameterType,
                            para?.NABLRangeFrom,
                            para?.NABLRangeTo,
                            para?.ParameterResultType,
                            para?.IsNABLParameter
                          );
                        } else {
                          // formik.setFieldValue(
                          //   `ListOfParameter[${pIndex}].ListOfResultValue[${index}].ResultValue`,
                          //   ""
                          // );
                          // OnResultValueChangeConsiderResult(
                          //   pIndex,
                          //   index,
                          //   para?.MinValue,
                          //   para?.MaxValue,
                          //   "",
                          //   para?.ParameterType,
                          //   para?.NABLRangeFrom,
                          //   para?.NABLRangeTo
                          // );
                        }
                        // } else {
                        //   // formik.setFieldValue(
                        //   //   `ListOfParameter[${pIndex}].ListOfResultValue[${index}].ResultValue`,
                        //   //   ""
                        //   // );
                        //   // OnResultValueChangeConsiderResult(
                        //   //   pIndex,
                        //   //   index,
                        //   //   para?.MinValue,
                        //   //   para?.MaxValue,
                        //   //   "",
                        //   //   para?.ParameterType,
                        //   //   para?.NABLRangeFrom,
                        //   //   para?.NABLRangeTo
                        //   // );
                        // }
                      })
                    );
                    formik.setFieldValue("IsDefaultLoadCalculateAverage", true); //calculate average
                  } else {
                    // Promise.all(
                    //   ListOfParameter?.map((para, pIndex) => {
                    //     formik.setFieldValue(
                    //       `ListOfParameter[${pIndex}].ListOfResultValue[${index}].ResultValue`,
                    //       ""
                    //     );
                    //     OnResultValueChangeConsiderResult(
                    //       pIndex,
                    //       index,
                    //       para?.MinValue,
                    //       para?.MaxValue,
                    //       "",
                    //       para?.ParameterType,
                    //       para?.NABLRangeFrom,
                    //       para?.NABLRangeTo
                    //     );
                    //   })
                    // );
                  }
                  setIsLoading(false);
                } else {
                  errorMessage(response?.Message);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
              });
          } else {
            warningMessage("Select valid CSV file!");
          }
        }
      } else {
        warningMessage("Select Machine!");
      }
    } else {
      warningMessage("Select Test!");
    }
    setFileKeyCSVFile(Math.random().toString(9).substring(2, 9));
  };

  const uploadTestingResultImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        warningMessage("Select valid image file!");
      } else {
        formik.setFieldValue("ListTestingResultImages", [
          ...ListTestingResultImages,
          {
            TestingResultImageIDEncrypted: "",
            TestingID: "",
            TestingResultImageFile: file,
            viewFile: URL.createObjectURL(file),
            TestingResultImageFileName: file?.name,
            ResultImagePath: "",
            IsDeleted: false,
            Remarks: "",
          },
        ]);
      }
    }
  };

  const deleteTestingResultImage = (i) => {
    formik.setFieldValue(
      "ListTestingResultImages",
      ListTestingResultImages?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );
  };

  const OnResultValueChangeConsiderResult = (
    pIndex,
    rIndex,
    minValue,
    maxValue,
    resultValue,
    pType,
    minValueNABL,
    maxValueNABL,
    ParameterResultType,
    IsNABLParameter
  ) => {
    if (resultValue && isNaN(resultValue) == false) {
      /*Consider minValue blank = 0, maxValue blank = infinite*/
      if (
        // minValue &&
        // maxValue &&
        // isNaN(minValue) == false &&
        // isNaN(maxValue) == false
        (minValue || maxValue) &&
        isNaN(minValue ? minValue : 0) == false &&
        isNaN(maxValue ? maxValue : 0) == false
      ) {
        if (
          // parseFloat(resultValue) >= parseFloat(minValue) &&
          // parseFloat(resultValue) <= parseFloat(maxValue)
          parseFloat(resultValue) >= parseFloat(minValue ? minValue : 0) &&
          ((maxValue && parseFloat(resultValue) <= parseFloat(maxValue)) ||
            (!maxValue && 1 == 1))
        ) {
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
            1
          );
        } else {
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
            0
          );
        }
      } else {
        //minValue or maxValue is not available then result is not identified
        formik.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
          -1
        );
        // formik.setFieldValue(
        //   `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
        //   -1
        // );
        formik.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          IsNABLParameter ? (ParameterResultType == 2 ? 1 : -1) : -1
        );
      }
      //set NABL Result
      /*Consider minValue blank = 0, maxValue blank = infinite*/
      if (
        pType == 1 &&
        // minValueNABL &&
        // maxValueNABL &&
        // isNaN(minValueNABL) == false &&
        // isNaN(maxValueNABL) == false
        (minValueNABL || maxValueNABL) &&
        isNaN(minValueNABL ? minValueNABL : 0) == false &&
        isNaN(maxValueNABL ? maxValueNABL : 0) == false
      ) {
        if (
          // parseFloat(resultValue) >= parseFloat(minValueNABL) &&
          // parseFloat(resultValue) <= parseFloat(maxValueNABL)
          parseFloat(resultValue) >=
            parseFloat(minValueNABL ? minValueNABL : 0) &&
          ((maxValueNABL &&
            parseFloat(resultValue) <= parseFloat(maxValueNABL)) ||
            (!maxValueNABL && 1 == 1))
        ) {
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            1
          );
        } else {
          // formik.setFieldValue(
          //   `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          //   0
          // );
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            IsNABLParameter ? (ParameterResultType == 2 ? 1 : 0) : 0
          );
        }
      } else {
        //parameter is non standard then NABL result consider as not identified
        if (pType == 1 && ListOfParameter[pIndex].TestMethodIDEncrypt) {
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            IsNABLParameter ? (ParameterResultType == 2 ? 1 : -1) : -1
          );
        } else {
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            -1
          );
        }
      }
    } else {
      //result Value is blank then result is not identified
      formik.setFieldValue(
        `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
        -1
      );
      if (resultValue && ListOfParameter[pIndex].TestMethodIDEncrypt) {
        formik.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          IsNABLParameter ? (ParameterResultType == 2 ? 1 : -1) : -1
        );
      } else {
        formik.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          -1
        );
      }
    }
  };

  const OnMinMaxValueChangeConsiderResult = (pIndex, minValue, maxValue) => {
    /*Consider minValue blank = 0, maxValue blank = infinite*/
    if (
      // minValue &&
      // maxValue &&
      // isNaN(minValue) == false &&
      // isNaN(maxValue) == false
      (minValue || maxValue) &&
      isNaN(minValue ? minValue : 0) == false &&
      isNaN(maxValue ? maxValue : 0) == false
    ) {
      for (
        let i = 0;
        i < ListOfParameter[pIndex]?.ListOfResultValue?.length;
        i++
      ) {
        if (
          ListOfParameter[pIndex].ListOfResultValue[i].ResultValue &&
          isNaN(ListOfParameter[pIndex].ListOfResultValue[i].ResultValue) ==
            false
        ) {
          if (
            // parseFloat(
            //   ListOfParameter[pIndex].ListOfResultValue[i].ResultValue
            // ) >= parseFloat(minValue) &&
            //   parseFloat(
            //     ListOfParameter[pIndex].ListOfResultValue[i].ResultValue
            //   ) <= parseFloat(maxValue)
            parseFloat(
              ListOfParameter[pIndex].ListOfResultValue[i].ResultValue
            ) >= parseFloat(minValue ? minValue : 0) &&
            ((maxValue &&
              parseFloat(
                ListOfParameter[pIndex].ListOfResultValue[i].ResultValue
              ) <= parseFloat(maxValue)) ||
              (!maxValue && 1 == 1))
          ) {
            formik.setFieldValue(
              `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
              1
            );
          } else {
            formik.setFieldValue(
              `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
              0
            );
          }
        } else {
          //result Value is blank then result is not identified
          formik.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
            -1
          );
        }
      }
    } else {
      //minValue or maxValue is not available then result is not identified
      for (
        let i = 0;
        i < ListOfParameter[pIndex]?.ListOfResultValue?.length;
        i++
      ) {
        formik.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
          -1
        );
      }
    }
  };

  const OnLoadConsiderResultBasedOnDefaultValue = () => {
    ListOfParameter?.map((para, index) =>
      OnMinMaxValueChangeConsiderResult(index, para?.MinValue, para?.MaxValue)
    );
  };

  useEffect(() => {
    if (IsDefaultLoad) {
      OnLoadConsiderResultBasedOnDefaultValue();
      formik.setFieldValue("IsDefaultLoad", false);
    }
  }, [IsDefaultLoad]);

  const OnNABLRangeChangeConsiderNABLResult = () => {
    /*Consider minValue blank = 0, maxValue blank = infinite*/
    for (let p = 0; p < ListOfParameter?.length; p++) {
      if (
        ListOfParameter[p]?.ParameterType == 1 &&
        // ListOfParameter[p]?.NABLRangeFrom &&
        // ListOfParameter[p]?.NABLRangeTo &&
        // isNaN(ListOfParameter[p]?.NABLRangeFrom) == false &&
        // isNaN(ListOfParameter[p]?.NABLRangeTo) == false
        (ListOfParameter[p]?.NABLRangeFrom ||
          ListOfParameter[p]?.NABLRangeTo) &&
        isNaN(
          ListOfParameter[p]?.NABLRangeFrom
            ? ListOfParameter[p]?.NABLRangeFrom
            : 0
        ) == false &&
        isNaN(
          ListOfParameter[p]?.NABLRangeTo ? ListOfParameter[p]?.NABLRangeTo : 0
        ) == false
      ) {
        for (
          let i = 0;
          i < ListOfParameter[p]?.ListOfResultValue?.length;
          i++
        ) {
          if (
            ListOfParameter[p].ListOfResultValue[i].ResultValue &&
            isNaN(ListOfParameter[p].ListOfResultValue[i].ResultValue) == false
          ) {
            if (
              // parseFloat(ListOfParameter[p].ListOfResultValue[i].ResultValue) >=
              //   parseFloat(ListOfParameter[p]?.NABLRangeFrom) &&
              // parseFloat(ListOfParameter[p].ListOfResultValue[i].ResultValue) <=
              //   parseFloat(ListOfParameter[p]?.NABLRangeTo)
              parseFloat(ListOfParameter[p].ListOfResultValue[i].ResultValue) >=
                parseFloat(
                  ListOfParameter[p]?.NABLRangeFrom
                    ? ListOfParameter[p]?.NABLRangeFrom
                    : 0
                ) &&
              ((ListOfParameter[p]?.NABLRangeTo &&
                parseFloat(
                  ListOfParameter[p].ListOfResultValue[i].ResultValue
                ) <= parseFloat(ListOfParameter[p]?.NABLRangeTo)) ||
                (!ListOfParameter[p]?.NABLRangeTo && 1 == 1))
            ) {
              formik.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                1
              );
            } else {
              // formik.setFieldValue(
              //   `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
              //   0
              // );
              formik.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                ListOfParameter[p]?.IsNABLParameter
                  ? ListOfParameter[p]?.ParameterResultType == 2
                    ? 1
                    : 0
                  : 0
              );
            }
          } else {
            //Result Value is blank or Non Numeric then result is not identified
            if (ListOfParameter[p].ListOfResultValue[i].ResultValue) {
              formik.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                ListOfParameter[p]?.IsNABLParameter
                  ? ListOfParameter[p]?.ParameterResultType == 2
                    ? 1
                    : -1
                  : -1
              );
            } else {
              formik.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                -1
              );
            }
          }
        }
      } else {
        //NABL Range From or To is blank or Non Numeric or Non Std. Para then result is not identified
        for (
          let i = 0;
          i < ListOfParameter[p]?.ListOfResultValue?.length;
          i++
        ) {
          formik.setFieldValue(
            `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
            -1
          );
        }
      }
    }
    formik.setFieldValue("IsNABLRangeChange", false);
  };

  const handleChangeMachine = (e) => {
    // alert(e?.IsCalibrationValidityExpire);
    formik.setFieldValue("MachineIDEncrypt", e?.value ?? "");
    if (e?.IsCalibrationValidityExpire) {
      // warningMessage(e?.label + " Calibration Validity Expired!");
      // formik.setFieldValue("MachineIDEncrypt", "");

      customConfirmDialog(
        e?.label + " Calibration Validity Expired!",
        "Do you want to continue?",
        fnCallbackChangeMachine,
        false
      );
    }
  };

  const fnCallbackChangeMachine = () => {
    formik.setFieldValue("MachineIDEncrypt", "");
  };

  const reorder = (list, startIndex, endIndex) => {
    //console.log("List", list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      ListOfParameter,
      result.source.index,
      result.destination.index
    );

    let newList = [];
    Promise.all(
      items?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: idx + 1,
        });
      })
    );

    formik.setFieldValue("ListOfParameter", newList);
  };

  const formikTestingRemarks = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestingRemarks(values, formikHelpers),
    initialValues: {
      TestingRemarksList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { TestingRemarksList },
  } = formikTestingRemarks;

  const handleValidSubmitTestingRemarks = (values) => {
    formik.setFieldValue(
      "Remarks",
      values?.TestingRemarksList?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.TestingRemarks;
        })
        .join(" ")
    );
    setShowTestingRemarksModal(false);
  };

  const getTestingRemarksList = async () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 9, //Testing Remarks
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikTestingRemarks.setFieldValue(
            "TestingRemarksList",
            response?.List?.map((item) => ({
              TestingRemarks: item.CategoryName,
              CategoryID: item.CategoryID,
              IsSelected: false,
            }))
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
      });
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formik.setFieldValue("ListOfLetterRefDoc", [
      ...ListOfLetterRefDoc,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  const [showTestParametersModal, setShowTestParametersModal] = useState(false);

  const validationTestParameters = Yup.object().shape({});

  const formikTestPrameters = useFormik({
    validationSchema: validationTestParameters,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestParameters(values, formikHelpers),
    initialValues: {
      ParametersList: [],
      selectAllPara: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { ParametersList, selectAllPara },
  } = formikTestPrameters;

  const handleValidSubmitTestParameters = (values) => {
    let testingParametersShortCodes = values?.ParametersList?.filter(
      (para) => para?.IsSelected == true && para?.ShortCode != ""
    )
      ?.map((x) => x.ShortCode)
      ?.join(",");

    if (IsMixDesign == true) {
      let shortCodes = [];

      ListOfMixDesignIncludedTest.forEach((test) => {
        if (test.TestDetails && test.TestDetails.ListOfParameter) {
          test.TestDetails.ListOfParameter.forEach((param) => {
            if (param.ShortCode) {
              shortCodes.push(param.ShortCode);
            }
          });
        }
      });

      let mixDesignIncludedTestParametersShortCodes = shortCodes.join(", ");

      if (mixDesignIncludedTestParametersShortCodes) {
        testingParametersShortCodes = testingParametersShortCodes
          ? testingParametersShortCodes +
            ", " +
            mixDesignIncludedTestParametersShortCodes
          : mixDesignIncludedTestParametersShortCodes;
      }
    }

    let newList = [];
    Promise.all(
      values?.ParametersList?.filter((para) => para?.IsSelected == true)?.map(
        (x, idx) => {
          newList.push({
            ...x,
            Sequence: idx + 1,
            FormulaEvaluationStatus:
              x.FormulaEvaluationStatus > 0
                ? checkFormulaEvaluationStatus(
                    testingParametersShortCodes,
                    x.FormulaVariables
                  ) == true
                  ? 1
                  : 2
                : 0,
          });
        }
      )
    );
    newList = [
      ...newList,
      ...values?.ParametersList?.filter((para) => para?.IsSelected == false),
    ];

    formik.setFieldValue("ListOfParameter", newList);
    setShowTestParametersModal(false);
  };

  const handleChangeSelectAllPara = (isChecked) => {
    formikTestPrameters.setFieldValue("selectAllPara", isChecked);
    formikTestPrameters.setFieldValue(
      "ParametersList",
      ParametersList?.map((x) => {
        return { ...x, IsSelected: isChecked };
      })
    );
  };

  const checkFormulaEvaluationStatus = (
    testingParametersShortCodes,
    formulaVariables
  ) => {
    // Split the testingAllParametersShortCodes and trim whitespace
    const testingParametersShortCodesArray = testingParametersShortCodes
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    // Find formulaVariables that do not exist in testingParametersShortCodes
    const notExists = variablesArray.filter(
      (variable) => !testingParametersShortCodesArray.includes(variable)
    );

    // Return true if all variables exist, otherwise false
    return notExists.length === 0;
  };

  const [
    showParameterFormulaExpressionModal,
    setShowParameterFormulaExpressionModal,
  ] = useState(false);

  const validationSchemaParameterFormula = Yup.object().shape({});

  const formikParameterFormula = useFormik({
    validationSchema: validationSchemaParameterFormula,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitParameterFormula(values, formikHelpers),
    initialValues: {
      ParameterName: "",
      FormulaExpression: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitParameterFormula,
    values: {},
  } = formikParameterFormula;

  const showFormula = (parameterName, formula) => {
    formikParameterFormula.setFieldValue("ParameterName", parameterName);
    formikParameterFormula.setFieldValue("FormulaExpression", formula);
    setShowParameterFormulaExpressionModal(true);
  };

  const calculateFormula = (paraIndex, formulaExpression, formulaVariables) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    Promise.all(
      ListOfParameter[paraIndex]?.ListOfResultValue?.map((item, itemIndex) => {
        let variablesValueList = [];

        Promise.all(
          variablesArray?.map((x) => {
            let xValue = "";
            xValue =
              ListOfParameter?.filter(
                (p) => p.ShortCode == x
              )[0]?.ListOfResultValue?.filter((r, i) => i == itemIndex)[0]
                ?.ResultValue ?? "";

            if (!xValue && IsMixDesign == true) {
              ListOfMixDesignIncludedTest?.forEach((test) => {
                if (test.TestDetails && test.TestDetails.ListOfParameter) {
                  test.TestDetails.ListOfParameter.forEach((param) => {
                    if (param.ShortCode == x) {
                      if (param.ListOfTestingResult.length > itemIndex) {
                        xValue =
                          param.ListOfTestingResult[itemIndex].ResultValue;
                      } else {
                        if (param.ListOfTestingResult.length > 0) {
                          xValue = param.ListOfTestingResult[0].ResultValue;
                        }
                      }
                    }
                  });
                }
              });
            }

            variablesValueList.push({
              VariableName: x,
              VariableValue: xValue,
            });
          })
        );

        parameterResultVariablesValueList.push({
          ResultIndex: itemIndex,
          ListOfVariableValues: variablesValueList,
        });
      })
    );

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            formik.setFieldValue(
              `ListOfParameter[${paraIndex}].ListOfResultValue[${result.ResultIndex}].ResultValue`,
              result.ResultValue.includes(".")
                ? parseFloat(result.ResultValue).toFixed(2)
                : result.ResultValue
            );
            if (ListOfParameter[paraIndex].IsAverageRequired == true) {
              calculateResultAverage(
                paraIndex,
                result.ResultIndex,
                result.ResultValue.includes(".")
                  ? parseFloat(result.ResultValue).toFixed(2)
                  : result.ResultValue
              );
            }
          });
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const calculateResultAverage = (paraIndex, resultIndex, resultValue) => {
    let averageResultValue = 0,
      resultCount = 0;
    resultCount = ListOfParameter[paraIndex].ListOfResultValue?.filter(
      (x, i) => i != resultIndex && x.ResultValue
    ).length;
    if (resultValue) {
      resultCount = resultCount + 1;
    }
    if (resultCount > 0) {
      let resultValueTotal = resultValue
        ? isNaN(resultValue) == false
          ? parseFloat(resultValue)
          : 0
        : 0;
      ListOfParameter[paraIndex].ListOfResultValue?.filter(
        (x, i) => i != resultIndex && x.ResultValue
      )?.map((item) => {
        resultValueTotal =
          resultValueTotal +
          (isNaN(item.ResultValue) == false ? parseFloat(item.ResultValue) : 0);
      });
      averageResultValue = parseFloat(resultValueTotal / resultCount).toFixed(
        2
      );
    } else {
      averageResultValue = resultValue;
    }
    if (isNaN(averageResultValue) == true) {
      averageResultValue = "";
    }
    formik.setFieldValue(
      `ListOfParameter[${paraIndex}].AverageResultValue`,
      averageResultValue
    );
  };

  useEffect(() => {
    if (IsDefaultLoadCalculateAverage) {
      ListOfParameter?.map((para, index) => {
        if (para.IsAverageRequired == true) {
          calculateResultAverage(index, -1, "");
        }
      });
      formik.setFieldValue("IsDefaultLoadCalculateAverage", false);
    }
  }, [IsDefaultLoadCalculateAverage]);

  const fetchMachineResults = async () => {
    if (TestingQty == 0) {
      warningMessage("Testing Qty is required...!");
      return;
    }
    if (MachineIDEncrypt == "") {
      warningMessage("Machine is required...!");
      return;
    }
    if (TCNo == "") {
      warningMessage("TC No is required...!");
      return;
    }

    setIsLoading(true);

    await post(POST_TestingFetchMachineParameterResults, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      MachineIDEncrypted: MachineIDEncrypt,
      TestMasterIDEncrypted: TestMasterIDEncrypt,
      TCNo: TCNo,
      TestCount: TestingQty,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfResults?.length > 0) {
            Promise.all(
              ListOfParameter?.map((para, pIndex) => {
                // if (para.ParameterType == 1) {
                // if (
                //   response?.ListOfResults?.filter(
                //     (x) => x.ParameterIDEncrypted == para.ParameterIDEncrypted
                //   )?.length > 0
                // ) {
                const matchingResults = response?.ListOfResults?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.ParameterType == para.ParameterType
                );
                if (matchingResults?.length > 0) {
                  // Loop through each TestCount
                  matchingResults.forEach((result, index) => {
                    // Assuming you have TestCount-related data in the 'result' object
                    const resultValue = result?.csvParameterResultValue;
                    const resultIndex = result.TestCount - 1;

                    // Set the ResultValue for each TestCount dynamically
                    formik.setFieldValue(
                      `ListOfParameter[${pIndex}].ListOfResultValue[${resultIndex}].ResultValue`,
                      resultValue
                    );

                    // Call the function to handle changes based on ResultValue
                    OnResultValueChangeConsiderResult(
                      pIndex,
                      resultIndex,
                      para?.MinValue,
                      para?.MaxValue,
                      resultValue,
                      para?.ParameterType,
                      para?.NABLRangeFrom,
                      para?.NABLRangeTo,
                      para?.ParameterResultType,
                      para?.IsNABLParameter
                    );
                  });
                  //successMessage("Parameter Results Fetch Successfully!");
                } else {
                }
                // }
                // } else {
                // }
              })
            );
            formik.setFieldValue("IsDefaultLoadCalculateAverage", true); //calculate average
          } else {
            warningMessage("Parameter Results not found...!");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeTestingCountHeaderText = (headerText, resultIndex) => {
    ListOfParameter?.map((para, pIndex) => {
      formik.setFieldValue(
        `ListOfParameter[${pIndex}].ListOfResultValue[${resultIndex}].TestingCountHeader`,
        headerText
      );
    });
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const getDefineMoreRatesModal = async () => {
    formikDefineMoreRates.setFieldValue(
      "MoreTestRatesList",
      ListOfTestDefineMoreRates?.map((itemsubRate) => ({
        TestMasterDefineMoreRatesIDEncrypted:
          itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
        InwardMaterialTestDetailIDEncrypted:
          itemsubRate?.InwardMaterialTestDetailIDEncrypted,
        TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
        RateType: itemsubRate?.RateType,
        RateTypeName: itemsubRate?.RateTypeName,
        IsSelected: itemsubRate?.IsSelected,
      }))
    );

    setShowDefineMoreRatesModal(true);
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    formik.setFieldValue("ListOfTestDefineMoreRates", "");
    formik.setFieldValue(
      "ListOfTestDefineMoreRates",
      values?.MoreTestRatesList
    );

    if (
      values?.MoreTestRatesList?.filter(
        (e) => e?.IsSelected == true && e?.RateType == 4 //Based On Measurement
      )?.length == 0
    ) {
      formik.setFieldValue("BasedOnMeasurementValue", "");
    }

    if (
      values?.MoreTestRatesList?.filter(
        (e) => e?.IsSelected == true && e?.RateType == 7 //Based On Hrs
      )?.length == 0
    ) {
      formik.setFieldValue("BasedOnHrsValue", "");
    }

    setShowDefineMoreRatesModal(false);
  };

  const validationMixDesignTestDetail = Yup.object().shape({});

  const formikMixDesignTestDetails = useFormik({
    validationSchema: validationMixDesignTestDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMixDesignTestDetail(values, formikHelpers),
    initialValues: {
      optionsTypeOfCement: [],
      optionsTypeOfMineralAdmixture: [],
      optionsMaximumNominalSizeofAggregate: [],
      optionsEnvironmentralExposureConditions: [],
      optionsTypeOfAggregateFine: [],
      optionsChemicalAdmixtureType: [],
      optionsChemicalAdmixtureBrandBatchMarkId: [],
      optionsFineAggregateReferenceStandardWithTable: [],
      ListOfConcreteExposureReferenceStandardTable: [],
      optionsReferenceStandardConcreteExposure: [],
      optionsReferenceStandardTableConcreteExposure: [],
      optionsTypeOfConcrete: [],
      optionsTypeOfConcreteGrade: [],
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitMixDesignTestDetail,
    values: {
      optionsTypeOfCement,
      optionsTypeOfMineralAdmixture,
      optionsMaximumNominalSizeofAggregate,
      optionsEnvironmentralExposureConditions,
      optionsTypeOfAggregateFine,
      optionsChemicalAdmixtureType,
      optionsChemicalAdmixtureBrandBatchMarkId,
      optionsFineAggregateReferenceStandardWithTable,
      ListOfConcreteExposureReferenceStandardTable,
      optionsReferenceStandardConcreteExposure,
      optionsReferenceStandardTableConcreteExposure,
      optionsTypeOfConcrete,
      optionsTypeOfConcreteGrade,
    },
  } = formikMixDesignTestDetails;

  const getMixDesignMasterDDLAll = async (testMasterID, resMain) => {
    await post(POST_GetMixDesignMasterDropDownListAll, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfCement",
            response.TypeofCementList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfMineralAdmixture",
            response.TypeofMineralAdmixtureList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsMaximumNominalSizeofAggregate",
            response.MaximumNominalSizeofAggregateList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsEnvironmentralExposureConditions",
            response.EnvironmentalExposureConditionsList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfAggregateFine",
            response.TypeofAggregateFineList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureType",
            response.ChemicalAdmixtureTypeList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureBrandBatchMarkId",
            response.ChemicalAdmixtureBrandBatchandIDMarkList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsFineAggregateReferenceStandardWithTable",
            response.ListOfFineAggregateReferenceStandardWithTableName?.map(
              (item) => ({
                value: item.ReferenceStandardWithTableName,
                label: item.ReferenceStandardWithTableName,
              })
            )
          );
          formikMixDesignTestDetails.setFieldValue(
            "ListOfConcreteExposureReferenceStandardTable",
            response.ListOfConcreteExposureReferenceStandardTable
          );

          const distinctReferenceStandardNames = [
            ...new Set(
              response.ListOfConcreteExposureReferenceStandardTable.map(
                (item) => item.ReferenceStandardName
              )
            ),
          ];
          formikMixDesignTestDetails.setFieldValue(
            "optionsReferenceStandardConcreteExposure",
            distinctReferenceStandardNames?.map((item) => ({
              value: item,
              label: item,
            }))
          );

          if (
            resMain?.TestMixDesignDetail
              ?.SelectionOfWaterCementRatioReferenceStandardName
          ) {
            const distinctReferenceStandardTableNames = [
              ...new Set(
                response.ListOfConcreteExposureReferenceStandardTable?.filter(
                  (x) =>
                    x.ReferenceStandardName ==
                    resMain?.TestMixDesignDetail
                      ?.SelectionOfWaterCementRatioReferenceStandardName
                )?.map((item) => item.ReferenceStandardTableName)
              ),
            ];

            formikMixDesignTestDetails.setFieldValue(
              "optionsReferenceStandardTableConcreteExposure",
              distinctReferenceStandardTableNames?.map((item) => ({
                value: item,
                label: item,
              }))
            );

            if (
              resMain?.TestMixDesignDetail
                ?.SelectionOfWaterCementRatioReferenceStandardTableName
            ) {
              formikMixDesignTestDetails.setFieldValue(
                "optionsTypeOfConcrete",
                [
                  {
                    value: "Plain Concrete",
                    label: "Plain Concrete",
                  },
                  {
                    value: "Reinforced Concrete",
                    label: "Reinforced Concrete",
                  },
                ]
              );
              if (resMain?.TestMixDesignDetail?.ConcreteType) {
                if (
                  resMain?.TestMixDesignDetail?.ConcreteType == "Plain Concrete"
                ) {
                  formikMixDesignTestDetails.setFieldValue(
                    "optionsTypeOfConcreteGrade",
                    response.ListOfConcreteExposureReferenceStandardTable?.filter(
                      (x) =>
                        x.ReferenceStandardName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardName &&
                        x.ReferenceStandardTableName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardTableName
                    )?.map((item) => ({
                      label: item.PlainConcreteMinGradeOfConcrete,
                      value: item.PlainConcreteMinGradeOfConcrete,
                      MaxFreeWaterCementRatio:
                        item.PlainConcreteMaxFreeWaterCementRatio,
                    }))
                  );
                } else if (
                  resMain?.TestMixDesignDetail?.ConcreteType ==
                  "Reinforced Concrete"
                ) {
                  formikMixDesignTestDetails.setFieldValue(
                    "optionsTypeOfConcreteGrade",
                    response.ListOfConcreteExposureReferenceStandardTable?.filter(
                      (x) =>
                        x.ReferenceStandardName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardName &&
                        x.ReferenceStandardTableName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardTableName
                    )?.map((item) => ({
                      label: item.ReinforcedConcreteMinGradeOfConcrete,
                      value: item.ReinforcedConcreteMinGradeOfConcrete,
                      MaxFreeWaterCementRatio:
                        item.ReinforcedConcreteMaxFreeWaterCementRatio,
                    }))
                  );
                }
              }
            }
          }
        } else {
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMixDesignIncludedTestResultDetails = async (listofIncludedTests) => {
    await post(POST_GetTestingsApprovalDetailByID, {
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let newListOfIncludedTests = [];
          listofIncludedTests?.map((test) => {
            if (
              response?.ListOfMaterialTests?.filter(
                (x) => x.TestMasterIDEncrypt == test.TestMasterIDEncrypted
              ).length > 0
            ) {
              newListOfIncludedTests.push({
                ...test,
                TestDetails: response?.ListOfMaterialTests?.filter(
                  (x) => x.TestMasterIDEncrypt == test.TestMasterIDEncrypted
                )[0],
              });
            }
          });
          formik.setFieldValue(
            "ListOfMixDesignIncludedTest",
            newListOfIncludedTests
          );
          formik.setFieldValue("IsMixDesignValidateFormulaExpression", true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (IsMixDesignValidateFormulaExpression == true) {
      formikTestPrameters.submitForm();
      formik.setFieldValue("IsMixDesignValidateFormulaExpression", false);
    }
  }, [IsMixDesignValidateFormulaExpression]);

  const [showMachineListModal, setShowMachineListModal] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);

  const [machineCalibrationDocumentsList, setMachineCalibrationDocumentsList] =
    useState([]);

  const fetchMachineList = async () => {
    formik.setFieldValue("ListOfMachines", "");
    if (MachineIDEncrypt) {
      await post(POST_TestingMachineList, {
        MachineIDEncrypted: MachineIDEncrypt,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue("ListOfMachines", response?.ListOfMachines);
          } else {
            formik.setFieldValue("ListOfMachines", "");
          }
        })
        .catch((error) => {
          console.log(error);
        });

      setShowMachineListModal(true);
    }
  };

  const calculateFormulaMixDesignSieveAnalysisCoarseAggregate = (
    cIndex,
    paraIndex,
    formulaExpression,
    formulaVariables
  ) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    Promise.all(
      TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList?.map(
        (item, itemIndex) => {
          let variablesValueList = [];

          Promise.all(
            variablesArray?.map((x) => {
              let xValue = "";
              if (
                `${TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0]?.ParameterList[paraIndex]?.CriateriaList[cIndex].ColumnShortCode}X` ==
                x
              ) {
                xValue =
                  TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                    .SieveSizeList[0]?.ParameterList[paraIndex]?.CriateriaList[
                    cIndex
                  ].InputColumnValueofX;
              } else {
                item?.ParameterList?.forEach((para) => {
                  para.CriateriaList.forEach((c) => {
                    if (c.ColumnShortCode == x) {
                      xValue = c.ColumnValue ?? "";
                    }
                  });
                });
              }
              variablesValueList.push({
                VariableName: x,
                VariableValue: xValue.toString(),
              });
            })
          );

          parameterResultVariablesValueList.push({
            ResultIndex: itemIndex,
            ListOfVariableValues: variablesValueList,
          });
        }
      )
    );

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            formik.setFieldValue(
              `TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[${result.ResultIndex}]ParameterList[${paraIndex}].CriateriaList[${cIndex}].ColumnValue`,
              result.ResultValue.includes(".")
                ? parseFloat(result.ResultValue).toFixed(2)
                : result.ResultValue
            );
          });
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // Group the data by Formula
  const objMixDesignTargetStrength =
    ListOfMixDesignTargetStrengthForMixProportioning?.reduce(
      (acc, item, index) => {
        if (!acc[item.Formula]) {
          acc[item.Formula] = [];
        }
        acc[item.Formula].push({ ...item, originalIndex: index }); // Add the original index
        return acc;
      },
      {}
    );

  const calculateFormulaMixDesignTargetStrength = (
    tIndex,
    formulaGroup,
    formulaExpression,
    formulaVariables
  ) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    let variablesValueList = [];

    Promise.all(
      variablesArray?.map((x) => {
        let xValue = "";
        xValue =
          ListOfMixDesignTargetStrengthForMixProportioning?.filter(
            (t) =>
              t.Formula == formulaGroup &&
              t.VariableName == x &&
              t.IsResultRow == false
          )[0]?.VariableValue ?? "";
        variablesValueList.push({
          VariableName: x,
          VariableValue: xValue.toString(),
        });
      })
    );

    parameterResultVariablesValueList.push({
      ResultIndex: 0,
      ListOfVariableValues: variablesValueList,
    });

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            formik.setFieldValue(
              `ListOfMixDesignTargetStrengthForMixProportioning[${tIndex}].VariableValue`,
              result.ResultValue.includes(".")
                ? parseFloat(result.ResultValue).toFixed(2)
                : result.ResultValue
            );
          });
          SetCalcFinalResultTargetStrength(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [calcFinalResultTargetStrength, SetCalcFinalResultTargetStrength] =
    useState(false);

  useEffect(() => {
    if (calcFinalResultTargetStrength) {
      let resultList = [];
      ListOfMixDesignTargetStrengthForMixProportioning?.map((item) => {
        if (
          item.IsResultRow == false &&
          item.FormulaExpression &&
          item.VariableValue
        ) {
          resultList.push(item.VariableValue);
        }
      });

      // Sort in descending order (greatest first)
      const sortedNumbers = resultList.sort(
        (a, b) => parseFloat(b) - parseFloat(a)
      );
      const index = ListOfMixDesignTargetStrengthForMixProportioning.findIndex(
        (item) => item.IsResultRow === true
      );
      formik.setFieldValue(
        `ListOfMixDesignTargetStrengthForMixProportioning[${index}].FormulaVariables`,
        sortedNumbers.join(" > ")
      );
      formik.setFieldValue(
        `ListOfMixDesignTargetStrengthForMixProportioning[${index}].VariableValue`,
        sortedNumbers[0] ?? ""
      );
      SetCalcFinalResultTargetStrength(false);
    }
  }, [calcFinalResultTargetStrength]);

  useEffect(() => {
    if (
      TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted &&
      !TestMixDesignDetail.ApproximateAirContentResultValue
    ) {
      formik.setFieldValue(
        "TestMixDesignDetail.ApproximateAirContentResultValue",
        optionsMaximumNominalSizeofAggregate?.filter(
          (x) =>
            x.value ==
            TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
        )[0]?.ApproximateAirContent ?? ""
      );
    }
  }, [optionsMaximumNominalSizeofAggregate]);

  // useEffect(() => {}, [ListOfConcreteExposureReferenceStandardTable]);

  const handleChangeSelectionOfWaterCementRatioReferenceStandardName = (e) => {
    if (
      e?.value !==
      TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName
    ) {
      formik.setFieldValue(
        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName",
        e?.value ?? ""
      );
      if (e?.value) {
        const distinctReferenceStandardTableNames = [
          ...new Set(
            ListOfConcreteExposureReferenceStandardTable?.filter(
              (x) => x.ReferenceStandardName == e?.value
            )?.map((item) => item.ReferenceStandardTableName)
          ),
        ];

        formikMixDesignTestDetails.setFieldValue(
          "optionsReferenceStandardTableConcreteExposure",
          distinctReferenceStandardTableNames?.map((item) => ({
            value: item,
            label: item,
          }))
        );
      } else {
        formikMixDesignTestDetails.setFieldValue(
          "optionsReferenceStandardTableConcreteExposure",
          []
        );
      }
      formikMixDesignTestDetails.setFieldValue("optionsTypeOfConcrete", []);
      formikMixDesignTestDetails.setFieldValue(
        "optionsTypeOfConcreteGrade",
        []
      );
      formik.setFieldValue(
        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName",
        ""
      );
      formik.setFieldValue("TestMixDesignDetail.ConcreteType", "");
      formik.setFieldValue("TestMixDesignDetail.ConcreteGrade", "");
      formik.setFieldValue("TestMixDesignDetail.MaxFreeWaterCementRatio", "");
    }
  };

  const handleChangeSelectionOfWaterCementRatioReferenceStandardTableName = (
    e
  ) => {
    if (
      e?.value !==
      TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName
    ) {
      formik.setFieldValue(
        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName",
        e?.value ?? ""
      );
      if (e?.value) {
        formikMixDesignTestDetails.setFieldValue("optionsTypeOfConcrete", [
          {
            value: "Plain Concrete",
            label: "Plain Concrete",
          },
          {
            value: "Reinforced Concrete",
            label: "Reinforced Concrete",
          },
        ]);
      } else {
        formikMixDesignTestDetails.setFieldValue("optionsTypeOfConcrete", []);
      }
      formikMixDesignTestDetails.setFieldValue(
        "optionsTypeOfConcreteGrade",
        []
      );
      formik.setFieldValue("TestMixDesignDetail.ConcreteType", "");
      formik.setFieldValue("TestMixDesignDetail.ConcreteGrade", "");
      formik.setFieldValue("TestMixDesignDetail.MaxFreeWaterCementRatio", "");
    }
  };

  const handleChangeSelectionOfWaterCementRatioTypeOfConcrete = (e) => {
    if (e?.value !== TestMixDesignDetail.ConcreteType) {
      formik.setFieldValue("TestMixDesignDetail.ConcreteType", e?.value ?? "");

      if (e?.value == "Plain Concrete") {
        formikMixDesignTestDetails.setFieldValue(
          "optionsTypeOfConcreteGrade",
          ListOfConcreteExposureReferenceStandardTable?.filter(
            (x) =>
              x.ReferenceStandardName ==
                TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName &&
              x.ReferenceStandardTableName ==
                TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName
          )?.map((item) => ({
            label: item.PlainConcreteMinGradeOfConcrete,
            value: item.PlainConcreteMinGradeOfConcrete,
            MaxFreeWaterCementRatio: item.PlainConcreteMaxFreeWaterCementRatio,
          }))
        );
      } else if (e?.value == "Reinforced Concrete") {
        formikMixDesignTestDetails.setFieldValue(
          "optionsTypeOfConcreteGrade",
          ListOfConcreteExposureReferenceStandardTable?.filter(
            (x) =>
              x.ReferenceStandardName ==
                TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName &&
              x.ReferenceStandardTableName ==
                TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName
          )?.map((item) => ({
            label: item.ReinforcedConcreteMinGradeOfConcrete,
            value: item.ReinforcedConcreteMinGradeOfConcrete,
            MaxFreeWaterCementRatio:
              item.ReinforcedConcreteMaxFreeWaterCementRatio,
          }))
        );
      } else {
        formikMixDesignTestDetails.setFieldValue(
          "optionsTypeOfConcreteGrade",
          []
        );
      }
      formik.setFieldValue("TestMixDesignDetail.ConcreteGrade", "");
      formik.setFieldValue("TestMixDesignDetail.MaxFreeWaterCementRatio", "");
    }
  };

  const handleChangeSelectionOfWaterCementRatioTypeOfConcreteGrade = (e) => {
    formik.setFieldValue("TestMixDesignDetail.ConcreteGrade", e?.value ?? "");
    if (e?.value) {
      formik.setFieldValue(
        "TestMixDesignDetail.MaxFreeWaterCementRatio",
        e?.MaxFreeWaterCementRatio ?? ""
      );
    } else {
      formik.setFieldValue("TestMixDesignDetail.MaxFreeWaterCementRatio", "");
    }
  };

  const calculateFormulaMixDesignGroupParameters = (
    pIndex,
    formulaExpression,
    formulaVariables,
    groupName
  ) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    let variablesValueList = [];

    Promise.all(
      variablesArray?.map((x) => {
        let xValue = "";
        xValue =
          ListOfMixDesignGroupParameters?.filter((t) => t.ShortCode == x)[0]
            ?.ParameterValue ?? "";
        variablesValueList.push({
          VariableName: x,
          VariableValue: xValue.toString(),
        });
      })
    );

    parameterResultVariablesValueList.push({
      ResultIndex: 0,
      ListOfVariableValues: variablesValueList,
    });

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            if (
              ListOfMixDesignGroupParameters[pIndex].IsResultValueBasedOnFormula
            ) {
              formik.setFieldValue(
                `ListOfMixDesignGroupParameters[${pIndex}].ResultValue`,
                result.ResultValue.includes(".")
                  ? parseFloat(result.ResultValue).toFixed(3)
                  : result.ResultValue
              );
            } else {
              formik.setFieldValue(
                `ListOfMixDesignGroupParameters[${pIndex}].ParameterValue`,
                result.ResultValue.includes(".")
                  ? parseFloat(result.ResultValue).toFixed(3)
                  : result.ResultValue
              );

              if (groupName == "A-6") {
                const maxDisplaySequenceElement =
                  ListOfMixDesignGroupParameters?.filter(
                    (x) => x.GroupName === "A-6"
                  )?.reduce(
                    (max, current) =>
                      current.DisplaySequence >
                      (max?.DisplaySequence || -Infinity)
                        ? current
                        : max,
                    null
                  );

                const index = ListOfMixDesignGroupParameters.indexOf(
                  maxDisplaySequenceElement
                );
                if (pIndex == index) {
                  formik.setFieldValue(
                    "TestMixDesignDetail.WaterContentKgPerM3",
                    result.ResultValue.includes(".")
                      ? parseFloat(result.ResultValue).toFixed(2)
                      : result.ResultValue
                  );

                  SetCalculateCementContent(true);
                }
              }
            }
          });
          SetCalcFinalResultTargetStrength(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [calculateCementContent, SetCalculateCementContent] = useState(false);

  useEffect(() => {
    if (calculateCementContent == true) {
      const maxDisplaySequenceElement = ListOfMixDesignGroupParameters?.filter(
        (x) => x.GroupName === "A-6"
      )?.reduce(
        (max, current) =>
          current.DisplaySequence > (max?.DisplaySequence || -Infinity)
            ? current
            : max,
        null
      );
      const index = ListOfMixDesignGroupParameters.indexOf(
        maxDisplaySequenceElement
      );

      const waterContent =
        ListOfMixDesignGroupParameters[index]?.ParameterValue;
      const waterCementRatio = TestMixDesignDetail?.WaterCementRatio;
      if (waterContent && waterCementRatio) {
        formik.setFieldValue(
          "TestMixDesignDetail.CementContentKgPerM3FormulaValue",
          `${waterContent}/${waterCementRatio}`
        );
        const resultValue =
          parseFloat(waterContent) / parseFloat(waterCementRatio);
        const finalResultValue = Math.round(resultValue, 0.1);
        formik.setFieldValue(
          "TestMixDesignDetail.CementContentKgPerM3ResultValue",
          resultValue.toFixed(2)
        );
        formik.setFieldValue(
          "TestMixDesignDetail.CementContentKgPerM3FinalResult",
          finalResultValue
        );
        let WaterCementRatioCementitiousMaterial =
          parseFloat(waterContent) / parseFloat(finalResultValue);
        formik.setFieldValue(
          "TestMixDesignDetail.WaterCementRatioCementitiousMaterial",
          WaterCementRatioCementitiousMaterial.toFixed(2)
        );
      }
      SetCalculateCementContent(false);
    }
  }, [calculateCementContent]);

  const calculateFormulaMixCalculation = (indx, parameterShortCode) => {
    let resultValue = "";
    let formulaValue = "";
    if (parameterShortCode == "b") {
      let a =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      formulaValue = "1%";
      resultValue = ((parseFloat(a ? a : 0) * 1) / 100).toFixed(2);
    } else if (parameterShortCode == "c") {
      let massCement = 0;
      let specificGravityOfCement = 0;
      if (TestMixDesignDetail?.TypeofMineralAdmixtureIDEncrypted) {
        massCement = TestMixDesignDetail.CementContentKgPerM3;
      } else {
        massCement = TestMixDesignDetail.CementContentKgPerM3FinalResult;
      }
      specificGravityOfCement =
        ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "Specific gravity of cement".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massCement} / ${specificGravityOfCement}) * (1 / 1000)`;
      resultValue = (
        (parseFloat(massCement) / parseFloat(specificGravityOfCement)) *
        (1 / 1000)
      ).toFixed(4);
    } else if (parameterShortCode == "d") {
      let massCement =
        TestMixDesignDetail.CementitiousMaterialContentKgPerM3 ?? 0;
      let specificGravityOfCement = 1;
      // specificGravityOfCement =
      //   ListOfParameter?.find((x) =>
      //     x.ParameterName?.toLowerCase().includes(
      //       "Specific gravity of cement".toLowerCase()
      //     )
      //   )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massCement} / ${specificGravityOfCement}) * (1 / 1000)`;
      if (specificGravityOfCement > 0) {
        resultValue = (
          (parseFloat(massCement) / parseFloat(specificGravityOfCement)) *
          (1 / 1000)
        ).toFixed(3);
      }
    } else if (parameterShortCode == "e") {
      let massWater = TestMixDesignDetail.WaterContentKgPerM3;
      let specificGravityOfWater = 0;
      specificGravityOfWater =
        ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "Specific gravity of water".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massWater} / ${specificGravityOfWater}) * (1 / 1000)`;
      if (specificGravityOfWater > 0) {
        resultValue = (
          (parseFloat(massWater) / parseFloat(specificGravityOfWater)) *
          (1 / 1000)
        ).toFixed(3);
      }
    } else if (parameterShortCode == "f.") {
      let massAdmixture =
        TestMixDesignDetail.CementitiousMaterialContentKgPerM3 ?? 0;
      let sgMineralAdmixture =
        ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of mineral admixture".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massAdmixture} / ${sgMineralAdmixture}) * (1 / 1000)`;
      if (sgMineralAdmixture > 0) {
        resultValue = (massAdmixture / sgMineralAdmixture) * (1 / 1000);
      }
    } else if (parameterShortCode == "f") {
      let cementContent = TestMixDesignDetail.CementContentKgPerM3FinalResult;
      let massChemicalAdmixure = (
        (parseFloat(cementContent) * 1) /
        100
      ).toFixed(3);
      let specificGravityOfChemicalAdmixture =
        ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of chemical admixture".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massChemicalAdmixure} / ${specificGravityOfChemicalAdmixture}) * (1 / 1000)`;
      if (specificGravityOfChemicalAdmixture > 0) {
        resultValue = (
          (parseFloat(massChemicalAdmixure) /
            parseFloat(specificGravityOfChemicalAdmixture)) *
          (1 / 1000)
        ).toFixed(6);
      }
    } else if (parameterShortCode == "g") {
      let a =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      let b =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "b"
        )[0]?.ParameterResultValue ?? 0;
      let c =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "c"
        )[0]?.ParameterResultValue ?? 0;
      let d =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "d"
        )[0]?.ParameterResultValue ?? 0;
      let e =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "e"
        )[0]?.ParameterResultValue ?? 0;
      let f =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "f"
        )[0]?.ParameterResultValue ?? 0;
      formulaValue = ` [(${a ? a : 0}-${b ? b : 0})-(${c ? c : 0}+${
        d ? d : 0
      }+${e ? e : 0}+${f ? f : 0})]`;
      resultValue = (
        [parseFloat(a ? a : 0) - parseFloat(b ? b : 0)] -
        (parseFloat(c ? c : 0) +
          parseFloat(d ? d : 0) +
          parseFloat(e ? e : 0) +
          parseFloat(f ? f : 0))
      ).toFixed(4);
    } else if (parameterShortCode == "h") {
      let a =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      let b =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "b"
        )[0]?.ParameterResultValue ?? 0;
      let c =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "c"
        )[0]?.ParameterResultValue ?? 0;
      let d =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "d"
        )[0]?.ParameterResultValue ?? 0;
      let e =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "e"
        )[0]?.ParameterResultValue ?? 0;
      let f =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "f"
        )[0]?.ParameterResultValue ?? 0;
      let g = (
        [parseFloat(a ? a : 0) - parseFloat(b ? b : 0)] -
        (parseFloat(c ? c : 0) +
          parseFloat(d ? d : 0) +
          parseFloat(e ? e : 0) +
          parseFloat(f ? f : 0))
      ).toFixed(4);
      let volumeOfCourseAggregate = ListOfMixDesignGroupParameters.filter(
        (x) => x.ShortCode == "PCWCR" && x.GroupName == "A-8."
      )[0]?.ParameterValue;
      let specificGravityOfCoarseAggregate = 0;
      let coarseAggregate = 0;
      let coarseAggregateList = ListOfParameter?.filter((x) =>
        x.ParameterName?.toLowerCase().includes(
          "specific gravity of Coarse Aggregate".toLowerCase()
        )
      );
      coarseAggregateList?.map((item) => {
        coarseAggregate =
          parseFloat(coarseAggregate) +
          parseFloat(
            item?.ListOfResultValue?.[0]?.ResultValue
              ? item?.ListOfResultValue?.[0]?.ResultValue
              : 0
          );
      });
      specificGravityOfCoarseAggregate =
        coarseAggregateList.length > 0
          ? (parseFloat(coarseAggregate) / coarseAggregateList.length).toFixed(
              3
            )
          : 0;
      formulaValue = `${g ? g : 0} * ${
        volumeOfCourseAggregate ? volumeOfCourseAggregate : 0
      } * ${
        specificGravityOfCoarseAggregate ? specificGravityOfCoarseAggregate : 0
      } * 1000`;
      resultValue = (
        parseFloat(g ? g : 0) *
        parseFloat(volumeOfCourseAggregate ? volumeOfCourseAggregate : 0) *
        parseFloat(
          specificGravityOfCoarseAggregate
            ? specificGravityOfCoarseAggregate
            : 0
        ) *
        1000
      ).toFixed(2);
    } else if (parameterShortCode == "j") {
      let a =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      let b =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "b"
        )[0]?.ParameterResultValue ?? 0;
      let c =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "c"
        )[0]?.ParameterResultValue ?? 0;
      let d =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "d"
        )[0]?.ParameterResultValue ?? 0;
      let e =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "e"
        )[0]?.ParameterResultValue ?? 0;
      let f =
        ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "f"
        )[0]?.ParameterResultValue ?? 0;
      let g = (
        [parseFloat(a ? a : 0) - parseFloat(b ? b : 0)] -
        (parseFloat(c ? c : 0) +
          parseFloat(d ? d : 0) +
          parseFloat(e ? e : 0) +
          parseFloat(f ? f : 0))
      ).toFixed(4);
      let volumeOfFineAggregate = ListOfMixDesignGroupParameters.filter(
        (x) => x.ShortCode == "VFAC" && x.GroupName == "A-8"
      )[0]?.ResultValue;
      let specificGravityOfFineAggregate =
        ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of Fine Aggregate".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `${g ? g : 0} * ${
        volumeOfFineAggregate ? volumeOfFineAggregate : 0
      } * ${
        specificGravityOfFineAggregate ? specificGravityOfFineAggregate : 0
      } * 1000`;
      resultValue = (
        parseFloat(g ? g : 0) *
        parseFloat(volumeOfFineAggregate ? volumeOfFineAggregate : 0) *
        parseFloat(
          specificGravityOfFineAggregate ? specificGravityOfFineAggregate : 0
        ) *
        1000
      ).toFixed(2);
    } else {
      let cementContent = TestMixDesignDetail.CementContentKgPerM3FinalResult;
      formulaValue = `1.0%  * ${cementContent ? cementContent : 0}`;
      resultValue = (
        (parseFloat(cementContent ? cementContent : 0) * 1) /
        100
      ).toFixed(3);
    }
    formik.setFieldValue(
      `ListOfMixDesignMixCalculation[${indx}].ParameterFormulaValue`,
      formulaValue
    );
    formik.setFieldValue(
      `ListOfMixDesignMixCalculation[${indx}].ParameterResultValue`,
      resultValue
    );
  };

  const calculateMixProportionsForTrial = (columnName) => {
    let cementContent,
      cementitiousMaterial,
      waterContent,
      fineAggreagte,
      percentage20mm,
      coarseAggreagte,
      courseAggreagte20mm,
      percentage10mm,
      courseAggreagte10mm,
      chemicalAdmixture,
      mineralAdmixture,
      wcRatio,
      Total = 0;
    if (columnName == "PerM3OfConcreteKg") {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          if (TestMixDesignDetail?.TypeofMineralAdmixtureIDEncrypted) {
            cementContent = TestMixDesignDetail.CementContentKgPerM3;
          } else {
            cementContent = TestMixDesignDetail.CementContentKgPerM3FinalResult;
          }
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            cementContent
          );
        } else if (x?.MaterialShortCode == "CM") {
          cementitiousMaterial =
            TestMixDesignDetail.CementitiousMaterialContentKgPerM3 ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            cementitiousMaterial
          );
        } else if (x?.MaterialShortCode == "W") {
          waterContent = TestMixDesignDetail.WaterContentKgPerM3 ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            waterContent
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "j"
            )[0]?.ParameterResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          percentage20mm =
            TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
              ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[0]
              ?.InputColumnValueofX ?? 0;
          coarseAggreagte =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "h"
            )[0]?.ParameterResultValue ?? 0;
          courseAggreagte20mm = (
            (parseFloat(coarseAggreagte) * parseFloat(percentage20mm)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].CoarseAggregatePercentageOfFraction`,
            `${percentage20mm}%`
          );
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          percentage10mm =
            TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
              ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[1]
              ?.InputColumnValueofX ?? 0;
          coarseAggreagte =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "h"
            )[0]?.ParameterResultValue ?? 0;
          courseAggreagte10mm = (
            (parseFloat(coarseAggreagte) * parseFloat(percentage10mm)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].CoarseAggregatePercentageOfFraction`,
            `${percentage10mm}%`
          );
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          chemicalAdmixture =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == ""
            )[0]?.ParameterResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            chemicalAdmixture
          );
        } else if (x?.MaterialShortCode == "MAD") {
          mineralAdmixture =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "f."
            )[0]?.ParameterResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            mineralAdmixture
          );
        } else if (x?.MaterialShortCode == "WCR") {
          wcRatio = TestMixDesignDetail.WaterCementRatioCementitiousMaterial;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            wcRatio
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          Total = (
            parseFloat(cementContent ? cementContent : 0) +
            parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
            parseFloat(waterContent ? waterContent : 0) +
            parseFloat(fineAggreagte ? fineAggreagte : 0) +
            parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
            parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
            parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
            parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
            parseFloat(wcRatio ? wcRatio : 0)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
            Total
          );
        }
      });
    } else if (columnName == "WaterAbsorptionPercentage") {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            "-"
          );
        } else if (x?.MaterialShortCode == "CM") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            "-"
          );
        } else if (x?.MaterialShortCode == "W") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            "-"
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Water Absorption".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Fine Aggregate".toLowerCase()
                )
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          courseAggreagte20mm =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Water Absorption".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Coarse Aggregate".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes("20".toLowerCase())
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          courseAggreagte10mm =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Water Absorption".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Coarse Aggregate".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes("10".toLowerCase())
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            "-"
          );
        } else if (x?.MaterialShortCode == "MAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            "-"
          );
        } else if (x?.MaterialShortCode == "WCR") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            "-"
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
            ""
          );
        }
      });
    } else if (columnName == "WeightOfWaterAbsorptionKg") {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "CM") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "W") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "FA") {
          let fineAggreagteConcrete =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "j"
            )[0]?.ParameterResultValue ?? 0;
          let fineAggreagteWaterAbsorptionPercentage =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Water Absorption".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Fine Aggregate".toLowerCase()
                )
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          fineAggreagte = (
            (parseFloat(fineAggreagteConcrete) *
              parseFloat(fineAggreagteWaterAbsorptionPercentage)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          percentage20mm =
            TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
              ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[0]
              ?.InputColumnValueofX ?? 0;
          coarseAggreagte =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "h"
            )[0]?.ParameterResultValue ?? 0;
          let courseAggreagte20mmConcrete = (
            (parseFloat(coarseAggreagte) * parseFloat(percentage20mm)) /
            100
          ).toFixed(2);
          let courseAggreagte20mmWAPercentage =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Water Absorption".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Coarse Aggregate".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes("20".toLowerCase())
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          courseAggreagte20mm = (
            (parseFloat(courseAggreagte20mmConcrete) *
              parseFloat(courseAggreagte20mmWAPercentage)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          percentage10mm =
            TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
              ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[1]
              ?.InputColumnValueofX ?? 0;
          coarseAggreagte =
            ListOfMixDesignMixCalculation?.filter(
              (m) => m.ParameterShortCode == "h"
            )[0]?.ParameterResultValue ?? 0;
          let courseAggreagte10mmConcrete = (
            (parseFloat(coarseAggreagte) * parseFloat(percentage10mm)) /
            100
          ).toFixed(2);
          let courseAggreagte10mmWAPercentage =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Water Absorption".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Coarse Aggregate".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes("10".toLowerCase())
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          courseAggreagte10mm = (
            (parseFloat(courseAggreagte10mmConcrete) *
              parseFloat(courseAggreagte10mmWAPercentage)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "MAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "WCR") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
            ""
          );
        }
      });
    } else if (
      columnName == "PerM3OfConcreteKgAfterWaterAbsorptionCorrection"
    ) {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          if (TestMixDesignDetail?.TypeofMineralAdmixtureIDEncrypted) {
            cementContent = TestMixDesignDetail.CementContentKgPerM3;
          } else {
            cementContent = TestMixDesignDetail.CementContentKgPerM3FinalResult;
          }
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            cementContent
          );
        } else if (x?.MaterialShortCode == "CM") {
          cementitiousMaterial =
            TestMixDesignDetail.CementitiousMaterialContentKgPerM3 ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            cementitiousMaterial
          );
        } else if (x?.MaterialShortCode == "W") {
          waterContent = TestMixDesignDetail.WaterContentKgPerM3 ?? 0;
          let waFineAggregate =
            ListOfMixDesignMixProportionsForTrial?.filter(
              (m) => m.MaterialShortCode == "FA"
            )[0]?.WeightOfWaterAbsorptionKg ?? 0;
          let waCoarseAggregate20mm =
            ListOfMixDesignMixProportionsForTrial?.filter(
              (m) => m.MaterialShortCode == "CA20"
            )[0]?.WeightOfWaterAbsorptionKg ?? 0;
          let waCoarseAggregate10mm =
            ListOfMixDesignMixProportionsForTrial?.filter(
              (m) => m.MaterialShortCode == "CA10"
            )[0]?.WeightOfWaterAbsorptionKg ?? 0;
          waterContent = (
            parseFloat(waterContent) +
            parseFloat(waFineAggregate) +
            parseFloat(waCoarseAggregate20mm) +
            parseFloat(waCoarseAggregate10mm)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            waterContent
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte = (
            parseFloat(x?.PerM3OfConcreteKg ?? 0) -
            parseFloat(x?.WeightOfWaterAbsorptionKg ?? 0)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          courseAggreagte20mm = (
            parseFloat(x?.PerM3OfConcreteKg ?? 0) -
            parseFloat(x?.WeightOfWaterAbsorptionKg ?? 0)
          ).toFixed(2);

          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          courseAggreagte10mm = (
            parseFloat(x?.PerM3OfConcreteKg ?? 0) -
            parseFloat(x?.WeightOfWaterAbsorptionKg ?? 0)
          ).toFixed(2);

          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          chemicalAdmixture = x?.PerM3OfConcreteKg;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            chemicalAdmixture
          );
        } else if (x?.MaterialShortCode == "MAD") {
          mineralAdmixture = x?.PerM3OfConcreteKg;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            mineralAdmixture
          );
        } else if (x?.MaterialShortCode == "WCR") {
          wcRatio = x?.PerM3OfConcreteKg;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            wcRatio
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          Total = (
            parseFloat(cementContent ? cementContent : 0) +
            parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
            parseFloat(waterContent ? waterContent : 0) +
            parseFloat(fineAggreagte ? fineAggreagte : 0) +
            parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
            parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
            parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
            parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
            parseFloat(wcRatio ? wcRatio : 0)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
            Total
          );
        }
      });
    } else if (columnName == "MoistureContentPercentageOfAggregate") {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            "-"
          );
        } else if (x?.MaterialShortCode == "CM") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            "-"
          );
        } else if (x?.MaterialShortCode == "W") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            "-"
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Moisture Content".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Fine Aggregate".toLowerCase()
                )
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          courseAggreagte20mm =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Moisture Content".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Coarse Aggregate".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes("20".toLowerCase())
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          courseAggreagte10mm =
            ListOfParameter?.find(
              (x) =>
                x.ParameterName?.toLowerCase().includes(
                  "Moisture Content".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes(
                  "Coarse Aggregate".toLowerCase()
                ) &&
                x.ParameterName?.toLowerCase().includes("10".toLowerCase())
            )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            "-"
          );
        } else if (x?.MaterialShortCode == "MAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            "-"
          );
        } else if (x?.MaterialShortCode == "WCR") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            "-"
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
            ""
          );
        }
      });
    } else if (columnName == "MoistureContentWeightKg") {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "CM") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "W") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte = (
            (parseFloat(x?.MoistureContentPercentageOfAggregate) *
              parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          courseAggreagte20mm = (
            (parseFloat(x?.MoistureContentPercentageOfAggregate) *
              parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          courseAggreagte10mm = (
            (parseFloat(x?.MoistureContentPercentageOfAggregate) *
              parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection)) /
            100
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "MAD") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "WCR") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            "-"
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
            ""
          );
        }
      });
    } else if (
      columnName == "PerM3OfConcreteKgAfterMoistureContentCorrection"
    ) {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          cementContent = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            cementContent
          );
        } else if (x?.MaterialShortCode == "CM") {
          cementitiousMaterial =
            x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            cementitiousMaterial
          );
        } else if (x?.MaterialShortCode == "W") {
          waterContent = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
          let mcwFineAggregate =
            ListOfMixDesignMixProportionsForTrial?.filter(
              (m) => m.MaterialShortCode == "FA"
            )[0]?.MoistureContentWeightKg ?? 0;
          let mcwCoarseAggregate20mm =
            ListOfMixDesignMixProportionsForTrial?.filter(
              (m) => m.MaterialShortCode == "CA20"
            )[0]?.MoistureContentWeightKg ?? 0;
          let mcwCoarseAggregate10mm =
            ListOfMixDesignMixProportionsForTrial?.filter(
              (m) => m.MaterialShortCode == "CA10"
            )[0]?.MoistureContentWeightKg ?? 0;
          waterContent = (
            parseFloat(waterContent) -
            parseFloat(mcwFineAggregate) -
            parseFloat(mcwCoarseAggregate20mm) -
            parseFloat(mcwCoarseAggregate10mm)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            waterContent
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte = (
            parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection) +
            parseFloat(x?.MoistureContentWeightKg)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          courseAggreagte20mm = (
            parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection) +
            parseFloat(x?.MoistureContentWeightKg)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          courseAggreagte10mm = (
            parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection) +
            parseFloat(x?.MoistureContentWeightKg)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          chemicalAdmixture =
            x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            chemicalAdmixture
          );
        } else if (x?.MaterialShortCode == "MAD") {
          mineralAdmixture = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            mineralAdmixture
          );
        } else if (x?.MaterialShortCode == "WCR") {
          wcRatio = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            wcRatio
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          Total = (
            parseFloat(cementContent ? cementContent : 0) +
            parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
            parseFloat(waterContent ? waterContent : 0) +
            parseFloat(fineAggreagte ? fineAggreagte : 0) +
            parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
            parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
            parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
            parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
            parseFloat(wcRatio ? wcRatio : 0)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
            Total
          );
        }
      });
    } else if (columnName == "LaboratoryMixTrialProportion") {
      ListOfMixDesignMixProportionsForTrial?.map((x, ix) => {
        if (x?.MaterialShortCode == "C") {
          cementContent = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            cementContent
          );
        } else if (x?.MaterialShortCode == "CM") {
          cementitiousMaterial = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            cementitiousMaterial
          );
        } else if (x?.MaterialShortCode == "W") {
          waterContent = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            waterContent
          );
        } else if (x?.MaterialShortCode == "FA") {
          fineAggreagte = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            fineAggreagte
          );
        } else if (x?.MaterialShortCode == "CA20") {
          courseAggreagte20mm = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            courseAggreagte20mm
          );
        } else if (x?.MaterialShortCode == "CA10") {
          courseAggreagte10mm = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            courseAggreagte10mm
          );
        } else if (x?.MaterialShortCode == "CAD") {
          chemicalAdmixture = (
            parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
            parseFloat(0.027)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            chemicalAdmixture
          );
        } else if (x?.MaterialShortCode == "MAD") {
          mineralAdmixture =
            x?.PerM3OfConcreteKgAfterMoistureContentCorrection > 0
              ? (
                  parseFloat(
                    x?.PerM3OfConcreteKgAfterMoistureContentCorrection
                  ) * parseFloat(0.027)
                ).toFixed(2)
              : "-";
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            mineralAdmixture
          );
        } else if (x?.MaterialShortCode == "WCR") {
          wcRatio = 0;
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            "-"
          );
        } else if (x?.MaterialShortCode == "TOTAL") {
          Total = (
            parseFloat(cementContent ? cementContent : 0) +
            parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
            parseFloat(waterContent ? waterContent : 0) +
            parseFloat(fineAggreagte ? fineAggreagte : 0) +
            parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
            parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
            parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
            parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
            parseFloat(wcRatio ? wcRatio : 0)
          ).toFixed(2);
          formik.setFieldValue(
            `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
            Total
          );
        }
      });
    }
  };

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const getDepartmentDDLForScopeValidityCheck = async (testingDate) => {
    // setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TransactionDate: testingDate
        ? moment(testingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : moment(new Date()).format("YYYY-MM-DD").replace(/^\-/, ""),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item?.DepartmentName,
              value: item?.DepartmentIDEncrypted,
              IsNABLScopeExpired: item?.IsNABLScopeExpired,
            }))
          );

          if (formik.values.DepartmentIDEncrypt) {
            response?.List?.map((item) => {
              if (
                item?.DepartmentIDEncrypted == formik.values.DepartmentIDEncrypt
              ) {
                if (item?.IsNABLScopeExpired == true) {
                  customConfirmDialog(
                    `${item?.DepartmentName} Scope is Expired`,
                    `Do you want to continue?`,
                    () => {
                      if (
                        AuthUser?.Permissions
                          ?.TestingAfterSaveStayOnEntryScreen == true
                      ) {
                        navigate("/testing-list");
                      } else {
                        navigate(-1);
                      }
                    },
                    false
                  );
                }
              }
            });
          }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <div className="tbl-caption p-2">
                  <Row>
                    <Col lg={1}>
                      <h4 className="heading">Testing</h4>
                    </Col>
                    <Col lg={5}>
                      {/* {IsReTestTesting ? (
                        <Field
                          name="TestName"
                          component={CustomInput}
                          required
                          disabled={true}
                        />
                      ) : ( */}
                      <Field
                        name="InwardMaterialTestDetailIDEncrypt"
                        placeholder={"Select Test Name"}
                        component={CustomSelect}
                        options={testMasterOptions}
                        onChange={handleChangeTest}
                        isClearable={false}
                        noMarginBottom={true}
                        autoFocus
                      />
                      {/* )} */}
                    </Col>
                  </Row>
                </div>

                <hr className="mt-0 mb-1"></hr>
                <label>Inward Information</label>
                <Row>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={12}>
                            <div className="col-xl-12 col-lg-12">
                              <div className="row">
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">
                                          Inward No :
                                        </label>
                                        <span className="ms-1">{InwardNo}</span>
                                      </li>

                                      <li>
                                        <label className="mb-1">
                                          Inward Date :
                                        </label>
                                        <span className="ms-1">
                                          {InwardDate}
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">EDD :</label>
                                        <span className="ms-1">
                                          {ExpectedDateOfDelivery}
                                        </span>
                                      </li>
                                      {AuthUser?.Permissions
                                        ?.DispatchMaterial == 1 ? (
                                        <li>
                                          <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1 mb-1">
                                            <label className="mb-1">
                                              Sample Returnable :
                                            </label>
                                            <span className="ms-1">
                                              {IsMaterialReturnable === true
                                                ? "Yes"
                                                : "No"}
                                            </span>
                                          </text>
                                        </li>
                                      ) : (
                                        ""
                                      )}
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">
                                          Letter Ref No :
                                        </label>
                                        <span className="ms-1">
                                          {LetterRefNo}&nbsp;&nbsp;
                                        </span>
                                        {/* {LetterRefNo ? ( */}
                                        {AllowTestingEdit == 1 &&
                                        IsReTestTesting == false ? (
                                          ListOfLetterRefDoc?.length > 0 ? (
                                            <Link
                                              to="#"
                                              title="Letter Ref Doc"
                                              className="text-primary"
                                              onClick={() => {
                                                setShowLetterRefDocModal(true);
                                              }}
                                            >
                                              View
                                            </Link>
                                          ) : (
                                            ""
                                          )
                                        ) : (
                                          ""
                                        )}
                                        {/* ) : (
                                          ""
                                        )} */}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1">
                                          <label className="mb-1">
                                            TPI Required :
                                          </label>
                                          <span className="ms-1">
                                            {IsTPIRequired === true
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                        </text>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          {/* <Col lg={12}>
                            <div className="col-xl-12 col-lg-12">
                              <div className="row"> */}
                          <div className="col-xl-6 col-lg-4">
                            <div className="">
                              <ul>
                                <li>
                                  <label className="mb-1">TC No :</label>
                                  <span className="ms-1">{TCNo}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-xl-6 col-lg-4">
                            <div className="">
                              <ul>
                                <li>
                                  <label className="mb-1">Department :</label>
                                  <span className="ms-1">{DepartmentName}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          {/* <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">
                                          Material Group :
                                        </label>
                                        <span className="ms-1">
                                          {ProductGroupName}
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-4">
                                  <div className="">
                                    <ul>
                                      <li>
                                        <label className="mb-1">
                                          Material Type :
                                        </label>
                                        <span className="ms-1">
                                          {MaterialTypeName}&nbsp;&nbsp;
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div> */}
                          <div className="col-xl-12 col-lg-12">
                            <div className="">
                              <ul>
                                <li>
                                  <label className="mb-1">Sample Note :</label>
                                  <span className="ms-1">
                                    {SampleNote}
                                  </span>{" "}
                                </li>
                              </ul>
                            </div>
                          </div>
                          {/* </div>
                            </div>
                          </Col> */}
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
                {InwardMaterialTestDetailIDEncrypt && (
                  <div
                    className={AllowTestingEdit == 1 ? "" : "disableDiv"}
                    onKeyDown={handleKeyDownDisable}
                  >
                    <hr className="mt-0 mb-1"></hr>
                    <Row>
                      <Col lg={6}>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>Testing Details</label>
                          </div>
                        </div>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <Row>
                              <Col lg={12}>
                                <div className="col-xl-12 col-lg-12">
                                  <div className="row">
                                    <Col lg={6}>
                                      {IsReTestTesting ? (
                                        <Field
                                          label="Testing From Date"
                                          name="TestingDateDisplay"
                                          component={CustomInput}
                                          required
                                          disabled={true}
                                        />
                                      ) : (
                                        <Field
                                          label="Testing From Date"
                                          name="TestingDate"
                                          placeholder={
                                            "Select Testing From Date"
                                          }
                                          component={CustomFlatpickr}
                                          options={{
                                            altInput: true,
                                            altFormat: "j-M-Y",
                                            dateFormat: "d-m-Y",
                                            minDate: InwardDate
                                              ? new Date(InwardDate)
                                              : "",
                                            maxDate: new Date(),
                                          }}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              "TestingDate",
                                              e
                                            );
                                            getParameterTestMethodDDLList(e);
                                            getDepartmentDDLForScopeValidityCheck(
                                              e
                                            );
                                          }}
                                        />
                                      )}
                                    </Col>
                                    <Col lg={6}>
                                      {IsReTestTesting ? (
                                        <Field
                                          label="Testing To Date"
                                          name="TestingToDateDisplay"
                                          component={CustomInput}
                                          required
                                          disabled={true}
                                        />
                                      ) : (
                                        <Field
                                          label="Testing To Date"
                                          name="TestingToDate"
                                          placeholder={"Select Testing To Date"}
                                          component={CustomFlatpickr}
                                          options={{
                                            altInput: true,
                                            altFormat: "j-M-Y",
                                            dateFormat: "d-m-Y",
                                            minDate: TestingDate
                                              ? new Date(TestingDate)
                                              : "",
                                          }}
                                        />
                                      )}
                                    </Col>
                                    <Col lg={6}>
                                      {IsReTestTesting == false ? (
                                        <Field
                                          label="Material Group"
                                          name="ProductGroupIDEncrypt"
                                          placeholder={"Select Material Group"}
                                          component={CustomSelect}
                                          options={productGroupOptions}
                                          isClearable={false}
                                          required
                                        />
                                      ) : (
                                        <Field
                                          label="Material Group"
                                          name="ProductGroupName"
                                          component={CustomInput}
                                          required
                                          disabled={true}
                                        />
                                      )}
                                    </Col>
                                    <Col lg={6}>
                                      {IsReTestTesting == false ? (
                                        <Field
                                          label="Material Type"
                                          name="MaterialTypeIDEncrypt"
                                          placeholder={"Select Material Type"}
                                          component={CustomSelect}
                                          options={materialTypeOptions}
                                          isClearable={false}
                                          required
                                        />
                                      ) : (
                                        <Field
                                          label="Material Type"
                                          name="MaterialTypeName"
                                          component={CustomInput}
                                          required
                                          disabled={true}
                                        />
                                      )}
                                    </Col>
                                  </div>
                                  <div className="row">
                                    <Col lg={6}>
                                      <Field
                                        type="number"
                                        label={"Testing Qty"}
                                        name="TestingQty"
                                        placeholder={"Enter Testing Qty"}
                                        component={CustomInput}
                                        onChange={handleChangeTestingQty}
                                        // disabled={
                                        //   IsReTestTesting ? true : false
                                        // }
                                        numberTypeWithoutDot={true}
                                        required
                                      />
                                    </Col>
                                    <Col lg={6}>
                                      <Field
                                        type="number"
                                        label={"Invoice Qty"}
                                        name="InvoiceQty"
                                        placeholder={"Enter Invoice Qty"}
                                        component={CustomInput}
                                        maxLength={20}
                                        // disabled={
                                        //   IsReTestTesting ? true : false
                                        // }
                                        numberTypeWithoutDot={true}
                                        required
                                      />
                                    </Col>

                                    {/* </div>
                              <div className="row"> */}

                                    <Col lg={6}>
                                      {/* {IsReTestTesting == false ? ( */}
                                      <Field
                                        label="Test Method"
                                        name="TestMethodIDEncrypt"
                                        placeholder={"Select Test Method"}
                                        component={CustomSelect}
                                        options={testMethodOptions}
                                        //isClearable={false}
                                        //required
                                        onChange={(e) => {
                                          // formik.setFieldValue(
                                          //   "TestMethodIDEncrypt",
                                          //   e?.value ?? ""
                                          // );
                                          handleChangeTestMethod(
                                            e?.value ?? "",
                                            e?.IsExpiredTestMethod
                                          );
                                        }}
                                      />
                                      {/* ) : (
                                        <Field
                                          label="Test Method"
                                          name="TestMethodName"
                                          component={CustomInput}
                                          required
                                          disabled={true}
                                        />
                                      )} */}
                                    </Col>
                                    <Col lg={6}>
                                      {IsReTestTesting == false ? (
                                        <Field
                                          label="Unit"
                                          name="UnitID"
                                          placeholder={"Select Unit"}
                                          options={unitOptions}
                                          component={CustomSelect}
                                          // isClearable={false}
                                          // required
                                        />
                                      ) : (
                                        <Field
                                          label="Unit"
                                          name="UnitName"
                                          component={CustomInput}
                                          required
                                          disabled={true}
                                        />
                                      )}
                                    </Col>
                                  </div>

                                  <div className="row">
                                    <Col lg={6}>
                                      <Row>
                                        {/* <Col lg={12}>
                                          {IsReTestTesting == false ? (
                                            <Field
                                              label="Unit"
                                              name="UnitID"
                                              placeholder={"Select Unit"}
                                              options={unitOptions}
                                              component={CustomSelect}
                                              // isClearable={false}
                                              // required
                                            />
                                          ) : (
                                            <Field
                                              label="Unit"
                                              name="UnitName"
                                              component={CustomInput}
                                              required
                                              disabled={true}
                                            />
                                          )}
                                        </Col> */}
                                        <Col lg={12}>
                                          {IsReTestTesting == false ? (
                                            <Field
                                              label="Reference Standard"
                                              name="ReferenceStandardIDEncrypted"
                                              placeholder={
                                                "Select Reference Standard"
                                              }
                                              component={CustomSelect}
                                              options={referenceStandardOptions}
                                              // isClearable={false}
                                              // required
                                              onChange={(e) => {
                                                if (
                                                  e?.IsExpiredReferenceStandard ==
                                                  true
                                                ) {
                                                  warningMessage(
                                                    "Reference Standard is Expired..!"
                                                  );
                                                  formik.setFieldValue(
                                                    "ReferenceStandardIDEncrypted",
                                                    ""
                                                  );
                                                  formik.setFieldValue(
                                                    "ReferenceSubGroup",
                                                    ""
                                                  );
                                                  setRefSubGroupOptions([]);
                                                  setParametersRangeList([]);
                                                } else {
                                                  formik.setFieldValue(
                                                    "ReferenceStandardIDEncrypted",
                                                    e?.value ?? ""
                                                  );
                                                  formik.setFieldValue(
                                                    "ReferenceSubGroup",
                                                    ""
                                                  );
                                                  getRefSubGroupAndRangeDDL(
                                                    TestMasterIDEncrypt,
                                                    e?.value ?? "",
                                                    TestingStatus
                                                  );
                                                  handleChangeReferenceSubGroup(
                                                    ""
                                                  );
                                                }
                                              }}
                                            />
                                          ) : (
                                            <Field
                                              label="Reference Standard"
                                              name="ReferenceStandardName"
                                              component={CustomInput}
                                              required
                                              disabled={true}
                                            />
                                          )}
                                        </Col>
                                        <Col lg={12}>
                                          {IsReTestTesting == false ? (
                                            <>
                                              {AuthUser?.Permissions
                                                ?.TestResultFromFile == 1 &&
                                              MachineIDEncrypt ? (
                                                <Link
                                                  to="#"
                                                  className="text-primary"
                                                  title="Machine Results"
                                                  style={{ float: "right" }}
                                                  onClick={fetchMachineResults}
                                                >
                                                  Fetch Parameter Results
                                                </Link>
                                              ) : (
                                                ""
                                              )}

                                              {MachineIDEncrypt &&
                                              AuthUser?.Permissions
                                                ?.MachineMaintenance == 1 ? (
                                                <Link
                                                  to="#"
                                                  className="icon-box icon-box-md bg-primary-light mb-1"
                                                  title="View Machine Calibration"
                                                  style={{
                                                    position: "absolute",
                                                    left: "70px",
                                                  }}
                                                  onClick={fetchMachineList}
                                                >
                                                  {SVGICON.Certificate}
                                                </Link>
                                              ) : (
                                                ""
                                              )}
                                              <Field
                                                label="Machine"
                                                name="MachineIDEncrypt"
                                                placeholder={"Select Machine"}
                                                component={CustomSelect}
                                                options={machineOptions}
                                                isClearable={false}
                                                //required
                                                onChange={handleChangeMachine}
                                                // onChange={(e) => {
                                                //   formik.setFieldValue(
                                                //     "MachineIDEncrypt",
                                                //     e?.value
                                                //   );
                                                // }}
                                              />
                                            </>
                                          ) : (
                                            <Field
                                              label="Machine"
                                              name="MachineName"
                                              component={CustomInput}
                                              required
                                              disabled={true}
                                            />
                                          )}
                                        </Col>
                                        <Col lg={12}>
                                          <Field
                                            label="Location"
                                            name="LocationType"
                                            placeholder={"Select Location Type"}
                                            component={CustomSelect}
                                            options={locationTypeOptions}
                                            isClearable={false}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg={6} className="mb-2">
                                      <label className="mb-1">
                                        Testing By{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div
                                        className="card mb-0 w-100"
                                        style={{ height: "180px" }}
                                      >
                                        <div className="card-header p-0">
                                          <input
                                            type="text"
                                            name="searchTestingBy"
                                            placeholder={"Search here..."}
                                            className="form-control form-control-sm"
                                            value={searchTestingBy}
                                            onChange={
                                              handleChangeSearchTestingBy
                                            }
                                            style={{
                                              borderBottomLeftRadius: "0",
                                              borderBottomRightRadius: "0",
                                            }}
                                          ></input>
                                        </div>
                                        <div
                                          className="card-body p-0 table-responsive"
                                          style={{
                                            maxHeight: "135px",
                                            overflow: "auto",
                                          }}
                                        >
                                          <table className="table table-hover header-border no-footer">
                                            <tbody>
                                              {ListTestingBy?.filter(
                                                (x) => x.display == true
                                              )?.length > 0 ? (
                                                ListTestingBy?.map(
                                                  (item, indx) => (
                                                    <tr
                                                      key={indx}
                                                      style={{
                                                        display:
                                                          item.display == true
                                                            ? ""
                                                            : "none",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "0.5rem",
                                                          width: "15%",
                                                        }}
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          id={`chkTestingBy${indx}`}
                                                          name={`chkTestingBy${indx}`}
                                                          checked={
                                                            item.IsSelected
                                                          }
                                                          onChange={(e) => {
                                                            formik.setFieldValue(
                                                              `ListTestingBy[${indx}].IsSelected`,
                                                              e.target.checked
                                                            );
                                                          }}
                                                          disabled={
                                                            IsReTestTesting
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "left",
                                                          padding: "0.5rem",
                                                          width: "85%",
                                                        }}
                                                      >
                                                        {item.EmployeeName}
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={2}
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <div>{"No options"}</div>
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name={"ListTestingBy"}
                                        component="div"
                                        className="invalid-feedback animated fadeInUp"
                                        style={{ display: "block" }}
                                      />
                                    </Col>
                                  </div>
                                  <div className="row">
                                    {AuthUser?.Permissions?.Account == 1 ? (
                                      <Col lg={6}>
                                        <div className="mb-2">
                                          <label className="mb-1">
                                            Define More Rates
                                          </label>
                                          <div className="input-group">
                                            <span className="form-control form-control-sm ps-2">
                                              <Link
                                                to="#"
                                                className="text-primary"
                                                onClick={() => {
                                                  getDefineMoreRatesModal();
                                                }}
                                              >
                                                Set Define More Rates
                                              </Link>
                                            </span>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                    {/* </div>
                                  <div className="row"> */}
                                    {ListOfTestDefineMoreRates?.filter(
                                      (e) =>
                                        e.IsSelected == true && e.RateType == 4 //Based On Measurement
                                    )?.length > 0 ? (
                                      <Col lg={6}>
                                        <Field
                                          type="number"
                                          label={"Based On Measurement Value"}
                                          name="BasedOnMeasurementValue"
                                          placeholder={
                                            "Enter Based On Measurement Value"
                                          }
                                          component={CustomInput}
                                          maxLength={20}
                                          disabled={
                                            IsReTestTesting ? true : false
                                          }
                                          //numberTypeWithoutDot={true}
                                        />
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                    {ListOfTestDefineMoreRates?.filter(
                                      (e) =>
                                        e.IsSelected == true && e.RateType == 7 //Based On Hrs
                                    )?.length > 0 ? (
                                      <Col lg={6}>
                                        <Field
                                          type="number"
                                          label={"Based On Hrs Value"}
                                          name="BasedOnHrsValue"
                                          placeholder={
                                            "Enter Based On Hrs Value"
                                          }
                                          component={CustomInput}
                                          maxLength={20}
                                          disabled={
                                            IsReTestTesting ? true : false
                                          }
                                          //numberTypeWithoutDot={true}
                                        />
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <Row>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <div className="d-flex justify-content-between mb-0">
                                    <div className="d-flex mb-0">
                                      <label className="text-warning fs-12 mb-1">
                                        [Note: Changes to Sample Detail,
                                        Condition, or Size will affect
                                        previously completed tests of this
                                        sample (TC). Therefore, you will need to
                                        reprint the report for any tests that
                                        have already been printed.]
                                      </label>
                                    </div>
                                  </div>
                                  <Col lg={12}>
                                    <Field
                                      label="Sample Detail"
                                      name="SampleDetail"
                                      placeholder={"Enter Sample Detail"}
                                      component={CustomTextArea}
                                      rows={4}
                                      maxLength={2000}
                                      disabled={IsReTestTesting ? true : false}
                                      required
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Condition"
                                      name="Condition"
                                      placeholder={"Enter Condition"}
                                      component={CustomInput}
                                      maxLength={500}
                                      disabled={IsReTestTesting ? true : false}
                                      required
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Size"
                                      name="Size"
                                      placeholder={"Enter Size"}
                                      component={CustomInput}
                                      maxLength={500}
                                      disabled={IsReTestTesting ? true : false}
                                      required
                                    />
                                  </Col>
                                </Row>
                                {IsTPIRequired === true ? (
                                  <Row>
                                    <Col lg={12}>
                                      <hr className="mt-0 mb-1"></hr>
                                      <div className="d-flex justify-content-between mb-0">
                                        <div className="d-flex mb-0">
                                          <label>TPI Details</label>
                                        </div>
                                        <div>
                                          {IsReTestTesting == false ? (
                                            <Link
                                              to="#"
                                              className="text-primary"
                                              onClick={() => {
                                                addNewTPI();
                                              }}
                                            >
                                              + Add TPI
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      {/* <hr className="mt-0 mb-1"></hr> */}
                                    </Col>
                                    <Col lg={12}>
                                      <div className="row">
                                        <div className="table-responsive active-projects style-1 shorting mb-2">
                                          <div
                                            id="TPIdetail-tbl_wrapper"
                                            className="dataTables_wrapper no-footer"
                                          >
                                            <table
                                              id="TPIdetail-tbl"
                                              className="table dataTable no-footer mb-0"
                                            >
                                              <thead>
                                                <tr>
                                                  <th width="2%"></th>
                                                  <th width="40%">TPI</th>
                                                  <th width="38%">
                                                    TPI Contact Person
                                                  </th>
                                                  <th
                                                    width="20%"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    TPI Expected Date
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {ListOfTPIDetails?.filter(
                                                  (x) => x.IsDeleted == false
                                                )?.length > 0 ? (
                                                  ListOfTPIDetails?.map(
                                                    (item, indx) => (
                                                      <tr
                                                        key={indx}
                                                        style={{
                                                          display:
                                                            item.IsDeleted ==
                                                            true
                                                              ? "none"
                                                              : "",
                                                        }}
                                                      >
                                                        <td>
                                                          {IsReTestTesting ==
                                                          false ? (
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-danger-light"
                                                              className="icon-box icon-box-md me-1"
                                                              title="Delete"
                                                              onClick={() => {
                                                                //deleteTPI(indx);
                                                                delete_RecordWithoutApi(
                                                                  deleteTPI,
                                                                  indx
                                                                );
                                                              }}
                                                            >
                                                              {
                                                                SVGICON.DeleteDanger
                                                              }
                                                            </Link>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </td>
                                                        <td>{item.TPIName}</td>
                                                        <td>
                                                          {
                                                            item.TPIContactPersonName
                                                          }
                                                        </td>
                                                        <td
                                                          style={{
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          {
                                                            item.displayTPIExpectedDate
                                                          }
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td
                                                      colSpan={4}
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <div>
                                                        {"No Record Found..."}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={6}>
                                    <div className="mb-2">
                                      <label className="mb-1">
                                        Test Master Images
                                      </label>
                                      <div className="input-group">
                                        <span className="form-control form-control-sm ps-2">
                                          <Link
                                            to="#"
                                            className="text-primary"
                                            onClick={() => {
                                              setShowTestMasterImagesModal(
                                                true
                                              );
                                            }}
                                          >
                                            View Test Master Images
                                          </Link>
                                        </span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <div className="mb-2">
                                      <label className="mb-1">
                                        Testing Images
                                      </label>
                                      <div className="input-group">
                                        <span className="form-control form-control-sm ps-2">
                                          <Link
                                            to="#"
                                            className="text-primary"
                                            onClick={() => {
                                              setShowTestingImagesModal(true);
                                            }}
                                          >
                                            View Testing Images
                                          </Link>
                                        </span>
                                        {/* {IsReTestTesting == false ? ( */}
                                        <div
                                          className="input-group-text"
                                          title="Add Testing Images"
                                          style={{
                                            borderRadius:
                                              "0 0.375rem 0.375rem 0",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setShowTestingImagesModal(true);
                                          }}
                                        >
                                          <i className="fa fa-plus" />
                                        </div>
                                        {/* ) : (
                                          ""
                                        )} */}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {IsMixDesign == true && (
                      <>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <Col lg={6}>
                            <div className="d-flex justify-content-between mb-0">
                              <div className="d-flex mb-0">
                                <label>
                                  Mix Design (STIPULATIONS FOR PROPORTIONING)
                                </label>
                              </div>
                            </div>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={6}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.GradeDesignation"
                                      }
                                      label={"Grade Designation"}
                                      placeholder={"Grade Designation"}
                                      component={CustomInput}
                                      maxLength={200}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Type of Cement"
                                      name="TestMixDesignDetail.TypeofCementIDEncrypted"
                                      placeholder={"Select Type of Cement"}
                                      options={optionsTypeOfCement}
                                      component={CustomSelect}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <div className="mb-2">
                                      <label className="mb-1">
                                        Method of Concrete Placing &nbsp;
                                      </label>
                                      <div className="form-control form-control-sm">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                                          name={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                                          checked={
                                            TestMixDesignDetail?.MethodofConcretePlacingIsChute_NonPumpable
                                          }
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              "TestMixDesignDetail.MethodofConcretePlacingIsChute_NonPumpable",
                                              !TestMixDesignDetail?.MethodofConcretePlacingIsChute_NonPumpable
                                            );
                                          }}
                                        />
                                        <label className="mb-1 ms-1 me-2 mt-1">
                                          Chute (Non pumpable) &nbsp;
                                        </label>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkMethodofConcretePlacingIsPumping`}
                                          name={`chkMethodofConcretePlacingIsPumping`}
                                          checked={
                                            TestMixDesignDetail?.MethodofConcretePlacingIsPumping
                                          }
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              "TestMixDesignDetail.MethodofConcretePlacingIsPumping",
                                              !TestMixDesignDetail?.MethodofConcretePlacingIsPumping
                                            );
                                          }}
                                        />
                                        <label className="mb-1 ms-1 mt-1">
                                          Pumping &nbsp;
                                        </label>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Type of Mineral Admixture"
                                      name="TestMixDesignDetail.TypeofMineralAdmixtureIDEncrypted"
                                      placeholder={
                                        "Select Type of Mineral Admixture"
                                      }
                                      options={optionsTypeOfMineralAdmixture}
                                      component={CustomSelect}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.DegreeofSiteControl"
                                      }
                                      label={"Degree of Site Control"}
                                      placeholder={"Degree of Site Control"}
                                      component={CustomInput}
                                      maxLength={200}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Maximum Nominal Size of Aggregate"
                                      name="TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted"
                                      placeholder={
                                        "Select Maximum Nominal Size of Aggregate"
                                      }
                                      options={
                                        optionsMaximumNominalSizeofAggregate
                                      }
                                      component={CustomSelect}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted",
                                          e?.value ?? ""
                                        );
                                        formik.setFieldValue(
                                          "TestMixDesignDetail.ApproximateAirContentResultValue",
                                          e?.ApproximateAirContent ?? ""
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.TypeofAggregateFineCoarse"
                                      }
                                      label={"Type of Aggregate Coarse"}
                                      placeholder={"Type of Aggregate Coarse"}
                                      component={CustomInput}
                                      maxLength={200}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Type of Aggregate Fine"
                                      name="TestMixDesignDetail.TypeofAggregateFineIDEncrypted"
                                      placeholder={
                                        "Select Type of Aggregate Fine"
                                      }
                                      options={optionsTypeOfAggregateFine}
                                      component={CustomSelect}
                                    />
                                  </Col>

                                  <Col lg={6}>
                                    <Field
                                      label="Environmental Exposure Conditions"
                                      name="TestMixDesignDetail.EnvironmentalExposureConditionsIDEncrypted"
                                      placeholder={
                                        "Select Environmental Exposure Conditions"
                                      }
                                      options={
                                        optionsEnvironmentralExposureConditions
                                      }
                                      component={CustomSelect}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      type="number"
                                      name={
                                        "TestMixDesignDetail.MaximumCementContent"
                                      }
                                      label={"Maximum Cement Content (kg/m3)"}
                                      placeholder={
                                        "Maximum Cement Content (kg/m3)"
                                      }
                                      component={CustomInput}
                                      maxLength={200}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      type="number"
                                      name={
                                        "TestMixDesignDetail.MinimumCementContent"
                                      }
                                      label={"Minimum Cement Content (kg/m3)"}
                                      placeholder={
                                        "Minimum Cement Content (kg/m3)"
                                      }
                                      component={CustomInput}
                                      maxLength={200}
                                    />
                                  </Col>

                                  <Col lg={6}>
                                    <Field
                                      type="number"
                                      name={
                                        "TestMixDesignDetail.MaximumWaterCementRatio"
                                      }
                                      label={"Maximum Water Cement Ratio"}
                                      placeholder={"Maximum Water Cement Ratio"}
                                      component={CustomInput}
                                      maxLength={200}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      name={"TestMixDesignDetail.Workability"}
                                      label={"Workability"}
                                      placeholder={"Workability"}
                                      component={CustomInput}
                                      maxLength={200}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "TestMixDesignDetail.Workability",
                                          e?.target?.value ?? ""
                                        );
                                        formik.setFieldValue(
                                          "TestMixDesignDetail.EstimatedWaterContentFor",
                                          e?.target?.value ?? ""
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Chemical Admixture Type"
                                      name="TestMixDesignDetail.ChemicalAdmixtureTypeIDEncrypted"
                                      placeholder={
                                        "Select Chemical Admixture Type"
                                      }
                                      options={optionsChemicalAdmixtureType}
                                      component={CustomSelect}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Chemical Admixture Brand/Batch/ID Mark"
                                      name="TestMixDesignDetail.ChemicalAdmixtureBrandBatchandMarkIDEncrypted"
                                      placeholder={
                                        "Chemical Admixture Brand/Batch/ID Mark"
                                      }
                                      options={
                                        optionsChemicalAdmixtureBrandBatchMarkId
                                      }
                                      component={CustomSelect}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      name="TestMixDesignDetail.TransportationTime"
                                      label={"Transportation Time"}
                                      placeholder={"hh:mm"}
                                      component={CustomFlatpickr}
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                                        time_24hr: true, // Enforces 24-hour format
                                        //allowInput: true, // Allows typing
                                        minuteIncrement: 1, // Allows setting minutes with up/down arrows
                                      }}
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      name="TestMixDesignDetail.RetentionTime"
                                      label={"Retention Time"}
                                      placeholder={"hh:mm"}
                                      component={CustomFlatpickr}
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                                        time_24hr: true, // Enforces 24-hour format
                                        //allowInput: true, // Allows typing
                                        minuteIncrement: 1, // Allows setting minutes with up/down arrows
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="d-flex justify-content-between mb-0">
                              <div className="d-flex mb-0">
                                <label>Mix Design Included Tests</label>
                              </div>
                            </div>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Accordion
                                  className="accordion accordion-primary"
                                  defaultActiveKey="0"
                                >
                                  {ListOfMixDesignIncludedTest?.length > 0 &&
                                    ListOfMixDesignIncludedTest?.map(
                                      (item, index) => (
                                        <Accordion.Item
                                          className="accordion-item"
                                          key={index}
                                          eventKey={index}
                                        >
                                          <Accordion.Header className="accordion-header rounded-lg">
                                            {item?.TestName}
                                          </Accordion.Header>
                                          <Accordion.Collapse eventKey={index}>
                                            <div className="accordion-body ps-0 pe-0 pb-0">
                                              {item?.TestDetails
                                                ?.TestingStatus <= 2 ? (
                                                <>
                                                  Testing Status: &nbsp;
                                                  <label className="mb-0">
                                                    {
                                                      item?.TestDetails
                                                        ?.TestingStatusName
                                                    }
                                                  </label>
                                                </>
                                              ) : (
                                                <MixDesignIncludedTestResultDetail
                                                  test={item.TestDetails}
                                                  testIndex={index}
                                                />
                                              )}
                                            </div>
                                          </Accordion.Collapse>
                                        </Accordion.Item>
                                      )
                                    )}
                                </Accordion>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                    <hr className="mt-0 mb-1"></hr>
                    <Row>
                      <div className="d-flex justify-content-between mb-0">
                        <div className="d-flex mb-0">
                          <label>Testing Parameters</label>
                        </div>
                      </div>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <Row>
                              {/* <Col lg={2} style={{ width: "125px" }}>
                            <Link
                              to="#"
                              className="badge-primary light badge mb-2"
                              onClick={() => {
                                AddNewParameter();
                              }}
                            >
                              Add Parameter
                            </Link>
                          </Col> */}
                              {ReferenceStandardIDEncrypted &&
                              refSubGroupOptions?.filter((x) => x.value != "")
                                ?.length > 0 ? (
                                <Col lg={2}>
                                  <Field
                                    name="ReferenceSubGroup"
                                    placeholder={"Select Group"}
                                    component={CustomSelect}
                                    options={refSubGroupOptions}
                                    isClearable={false}
                                    menuPosition="fixed"
                                    // noMarginBottom={true}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "ReferenceSubGroup",
                                        e?.value ?? ""
                                      );
                                      handleChangeReferenceSubGroup(
                                        e?.value ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                              ) : (
                                ""
                              )}
                              <Col lg={2} style={{ width: "125px" }}>
                                <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id="None"
                                    name="ParameterWith"
                                    title="None"
                                    style={{ cursor: "pointer" }}
                                    checked={ParameterWith == 1}
                                    onChange={() => {
                                      formik.setFieldValue("ParameterWith", 1);
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="None"
                                  >
                                    None
                                  </label>
                                </div>
                              </Col>
                              {ReferenceStandardIDEncrypted && (
                                <Col lg={2}>
                                  <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="PrintMinMax"
                                      name="ParameterWith"
                                      title="Print Min-Max"
                                      style={{ cursor: "pointer" }}
                                      checked={ParameterWith == 2}
                                      onChange={() => {
                                        formik.setFieldValue(
                                          "ParameterWith",
                                          2
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="PrintMinMax"
                                    >
                                      Print Min/Max
                                    </label>
                                  </div>
                                </Col>
                              )}
                              {IsMixDesign == false && (
                                <Col lg={2}>
                                  <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="PrintRequirement"
                                      name="ParameterWith"
                                      title="Print Requirement"
                                      style={{ cursor: "pointer" }}
                                      checked={ParameterWith == 3}
                                      onChange={() => {
                                        formik.setFieldValue(
                                          "ParameterWith",
                                          3
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="PrintRequirement"
                                    >
                                      Print Requirement
                                    </label>
                                  </div>
                                </Col>
                              )}
                              <Col lg={2}>
                                <div className="d-flex mb-2">
                                  <label className="mb-1">
                                    Merge Same Value &nbsp;
                                  </label>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="flexSwitchCheckIsMergeSameValue"
                                      title={
                                        IsMergeSameValue == true ? "Yes" : "No"
                                      }
                                      checked={IsMergeSameValue}
                                      onChange={() => {
                                        formik.setFieldValue(
                                          "IsMergeSameValue",
                                          !IsMergeSameValue
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    ></input>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <hr className="mt-0 mb-1"></hr>
                            <Row>
                              <Col lg={12}>
                                <div>
                                  <Row>
                                    {ReferenceStandardIDEncrypted ? (
                                      <Col lg={4}>
                                        <div className="d-flex ">
                                          <div style={{ width: "170px" }}>
                                            <label>
                                              Ref. Standard Indication :{" "}
                                            </label>
                                          </div>
                                          <div>
                                            <i
                                              className="fa fa-circle"
                                              style={{ color: "green" }}
                                            ></i>
                                            &nbsp; Valid &nbsp;&nbsp;
                                            <i
                                              className="fa fa-circle"
                                              style={{ color: "red" }}
                                            ></i>
                                            &nbsp; Invalid &nbsp;&nbsp;
                                            <i
                                              className="fa fa-circle"
                                              style={{ color: "orange" }}
                                            ></i>
                                            &nbsp; Unidentified
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                    <Col lg={4}>
                                      <div className="d-flex ">
                                        <div style={{ width: "160px" }}>
                                          <label>NABL Range Indication :</label>
                                        </div>
                                        <div>
                                          <i
                                            className="fa fa-certificate"
                                            style={{ color: "green" }}
                                          ></i>
                                          &nbsp; Valid &nbsp;&nbsp;
                                          <i
                                            className="fa fa-certificate"
                                            style={{ color: "red" }}
                                          ></i>
                                          &nbsp; Invalid &nbsp;&nbsp;
                                          <i
                                            className="fa fa-certificate"
                                            style={{ color: "orange" }}
                                          ></i>
                                          &nbsp; Unidentified
                                        </div>
                                      </div>
                                    </Col>
                                    <Col lg={4}>
                                      <div className="d-flex ">
                                        <div style={{ width: "160px" }}>
                                          <label>Parameter Result Type :</label>
                                        </div>
                                        <div>
                                          &nbsp; QN - Quantitative &nbsp;&nbsp;
                                          &nbsp; QL - Qualitative &nbsp;&nbsp;
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <DragDropContext onDragEnd={onDragEnd}>
                                  <div className="table-responsive active-projects style-1 shorting mb-2">
                                    <div
                                      id="ParameterDetail-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="ParameterDetail-tbl"
                                        className="table table-bordered no-footer mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th width="2%">
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-primary-light"
                                                title="Parameters Selection"
                                                onClick={() => {
                                                  formikTestPrameters.setFieldValue(
                                                    "ParametersList",
                                                    ListOfParameter
                                                  );
                                                  formikTestPrameters.setFieldValue(
                                                    "selectAllPara",
                                                    ListOfParameter?.filter(
                                                      (x) =>
                                                        x.IsSelected == false
                                                    )?.length > 0
                                                      ? false
                                                      : true
                                                  );
                                                  setShowTestParametersModal(
                                                    true
                                                  );
                                                }}
                                              >
                                                {SVGICON.EditSquare}
                                              </Link>
                                            </th>
                                            <th width="2%">#</th>
                                            {/* <th width="16%">Code</th> */}
                                            <th width="16%">Parameter</th>
                                            <th width="16%">Test Method</th>
                                            {ReferenceStandardIDEncrypted && (
                                              <th width="15%">Range</th>
                                            )}
                                            {ParameterWith == 2 && (
                                              <>
                                                <th width="9%">Min</th>
                                                <th width="9%">Max</th>
                                              </>
                                            )}
                                            {/* {ParameterWith == 3 && (
                                              <th width="15%">Requirement</th>
                                            )} */}
                                            {IsMixDesign == true ? (
                                              <th width="15%">
                                                Printing Group
                                              </th>
                                            ) : (
                                              ParameterWith == 3 && (
                                                <th width="15%">Requirement</th>
                                              )
                                            )}
                                            <th width="5%">NABL</th>
                                            {ListOfParameter[0]?.ListOfResultValue?.map(
                                              (result, rIdx) => (
                                                <th
                                                  key={rIdx}
                                                  width="15%"
                                                  style={{
                                                    textAlign: "left",
                                                    width: "150px",
                                                  }}
                                                >
                                                  {/* Value */}
                                                  {ListOfParameter[0]
                                                    ?.ListOfResultValue
                                                    ?.length > 1 ? (
                                                    <Field
                                                      // type="number"
                                                      name={`ListOfParameter[0].ListOfResultValue[${rIdx}].TestingCountHeader`}
                                                      component={CustomInput}
                                                      placeholder="Header Text"
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                      onChange={(e) => {
                                                        // formik.setFieldValue(
                                                        //   `ListOfParameter[0].ListOfResultValue[${rIdx}].TestingCountHeader`,
                                                        //   e?.target?.value ?? ""
                                                        // );
                                                        handleChangeTestingCountHeaderText(
                                                          e?.target?.value ??
                                                            "",
                                                          rIdx
                                                        );
                                                      }}
                                                    />
                                                  ) : (
                                                    "Value"
                                                  )}
                                                  {/* {AuthUser?.Permissions
                                                    ?.TestResultFromFile ==
                                                  1 ? (
                                                    <>
                                                      &nbsp;&nbsp;
                                                      <div className="input-group">
                                                        <div
                                                          className="open-file"
                                                          style={{
                                                            marginTop: "-26px",
                                                            marginLeft: "35px",
                                                          }}
                                                          title="Add CSV File"
                                                        >
                                                          <input
                                                            type="file"
                                                            id={`valuesUploadCSVFile${rIdx}`}
                                                            accept=".csv"
                                                            onChange={(e) => {
                                                              uploadCSVFile(
                                                                e,
                                                                rIdx
                                                              );
                                                            }}
                                                            key={
                                                              fileKeyCSVFile ||
                                                              ""
                                                            }
                                                            // title="Add CSV File"
                                                          />

                                                          <label
                                                            htmlFor={`valuesUploadCSVFile${rIdx}`}
                                                            name=""
                                                          ></label>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )} */}
                                                </th>
                                              )
                                            )}
                                            {TestingQty &&
                                            parseInt(TestingQty) > 1 ? (
                                              ListOfParameter?.filter(
                                                (x) =>
                                                  x.IsSelected == true &&
                                                  x.IsAverageRequired == true
                                              )?.length > 0 ? (
                                                <th
                                                  width="5%"
                                                  style={{ textAlign: "left" }}
                                                >
                                                  Average
                                                </th>
                                              ) : (
                                                ""
                                              )
                                            ) : (
                                              ""
                                            )}
                                          </tr>
                                        </thead>
                                        <Droppable droppableId="droppable">
                                          {(provided, _) => (
                                            <tbody
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {ListOfParameter?.length > 0 ? (
                                                ListOfParameter?.map(
                                                  (item, indx) =>
                                                    item?.IsSelected == true ? (
                                                      <Draggable
                                                        key={`id_${indx}`}
                                                        draggableId={`id_${indx}`}
                                                        index={indx}
                                                      >
                                                        {(provided, _) => (
                                                          <tr
                                                            key={indx}
                                                            role="row"
                                                            ref={
                                                              provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            //{...provided.dragHandleProps}  /* this sentence shifted to td level because select control not work properly */
                                                            className={`sub-card draggable-handle draggable`}
                                                          >
                                                            <td
                                                              className="p-1 text-center"
                                                              {...provided.dragHandleProps}
                                                              tabIndex={-1}
                                                            >
                                                              {SVGICON.Dotes}
                                                            </td>
                                                            <td
                                                              className="p-1 text-center"
                                                              {...provided.dragHandleProps}
                                                              tabIndex={-1}
                                                            >
                                                              {item?.Sequence}
                                                            </td>
                                                            {/* <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth: "100px",
                                                              }}
                                                            >
                                                              {item.DisplayCode}
                                                            </td> */}
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "100px",
                                                              }}
                                                              {...provided.dragHandleProps}
                                                              tabIndex={-1}
                                                            >
                                                              {
                                                                item.ParameterName
                                                              }
                                                              {item.ShortCode ? (
                                                                <>
                                                                  &nbsp;(
                                                                  <span className="text-primary">
                                                                    <b>
                                                                      {
                                                                        item.ShortCode
                                                                      }
                                                                    </b>
                                                                  </span>
                                                                  )
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                              {item.FormulaEvaluationStatus >
                                                                0 && (
                                                                <Link
                                                                  to="#"
                                                                  className={`icon-box icon-box-md ms-1 ${
                                                                    item.FormulaEvaluationStatus ==
                                                                    1
                                                                      ? "bg-success"
                                                                      : item.FormulaEvaluationStatus ==
                                                                        2
                                                                      ? "bg-danger"
                                                                      : "bg-secondary-light"
                                                                  }`}
                                                                  title={
                                                                    item.FormulaExpression
                                                                  }
                                                                  onClick={() => {
                                                                    showFormula(
                                                                      item.ParameterName,
                                                                      item.FormulaExpression
                                                                    );
                                                                  }}
                                                                  tabIndex={-1}
                                                                >
                                                                  {
                                                                    SVGICON.Formula
                                                                  }
                                                                </Link>
                                                              )}
                                                              {item.FormulaEvaluationStatus ==
                                                                1 && (
                                                                <Link
                                                                  to="#"
                                                                  className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                                  title="Calculate Formula"
                                                                  onClick={() => {
                                                                    calculateFormula(
                                                                      indx,
                                                                      item.FormulaExpression,
                                                                      item.FormulaVariables
                                                                    );
                                                                  }}
                                                                  tabIndex={-1}
                                                                >
                                                                  {
                                                                    SVGICON.Calculator
                                                                  }
                                                                </Link>
                                                              )}
                                                            </td>
                                                            {item?.ParameterType ==
                                                            1 ? (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "130px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfParameter[${indx}].TestMethodIDEncrypt`}
                                                                  placeholder={
                                                                    "Test Method"
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  options={
                                                                    item?.testMethodOptions
                                                                  }
                                                                  // isClearable={
                                                                  //   false
                                                                  // }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleChangeTestMethodParameter(
                                                                      indx,
                                                                      e?.value ??
                                                                        "",
                                                                      e?.IsExpiredTestMethod
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                            ) : (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "130px",
                                                                }}
                                                                {...provided.dragHandleProps}
                                                                tabIndex={-1}
                                                              ></td>
                                                            )}
                                                            {ReferenceStandardIDEncrypted ? (
                                                              item.rangeOptions
                                                                ?.length > 0 ? (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "130px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfParameter[${indx}].RangeValue`}
                                                                    placeholder={
                                                                      "Range"
                                                                    }
                                                                    options={
                                                                      item.rangeOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      formik.setFieldValue(
                                                                        `ListOfParameter[${indx}].RangeValue`,
                                                                        e?.label ??
                                                                          ""
                                                                      );
                                                                      formik.setFieldValue(
                                                                        `ListOfParameter[${indx}].MinValue`,
                                                                        e?.MinValue ??
                                                                          ""
                                                                      );
                                                                      formik.setFieldValue(
                                                                        `ListOfParameter[${indx}].MaxValue`,
                                                                        e?.MaxValue ??
                                                                          ""
                                                                      );
                                                                      formik.setFieldValue(
                                                                        `ListOfParameter[${indx}].Requirement`,
                                                                        e?.Requirement ??
                                                                          ""
                                                                      );
                                                                      if (
                                                                        TestingStatus ==
                                                                          1 &&
                                                                        IsReTestTesting ==
                                                                          false
                                                                      ) {
                                                                        formik.setFieldValue(
                                                                          `ListOfParameter[${indx}].ListOfResultValue`,
                                                                          item?.ListOfResultValue?.map(
                                                                            (
                                                                              result
                                                                            ) => {
                                                                              return {
                                                                                ...result,
                                                                                ResultValue:
                                                                                  item?.ParameterType ==
                                                                                  1
                                                                                    ? e?.DefaultValue ??
                                                                                      ""
                                                                                    : result?.ResultValue,
                                                                              };
                                                                            }
                                                                          )
                                                                        );
                                                                      }
                                                                      OnMinMaxValueChangeConsiderResult(
                                                                        indx,
                                                                        e?.MinValue ??
                                                                          "",
                                                                        e?.MaxValue ??
                                                                          ""
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                              ) : (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "130px",
                                                                  }}
                                                                  {...provided.dragHandleProps}
                                                                  tabIndex={-1}
                                                                ></td>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}

                                                            {ParameterWith ==
                                                              2 && (
                                                              <>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "80px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    // type="number"
                                                                    name={`ListOfParameter[${indx}].MinValue`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Min"
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      formik.setFieldValue(
                                                                        `ListOfParameter[${indx}].MinValue`,
                                                                        e
                                                                          ?.target
                                                                          ?.value ??
                                                                          ""
                                                                      );
                                                                      OnMinMaxValueChangeConsiderResult(
                                                                        indx,
                                                                        e
                                                                          ?.target
                                                                          ?.value ??
                                                                          "",
                                                                        item?.MaxValue
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "80px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    // type="number"
                                                                    name={`ListOfParameter[${indx}].MaxValue`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Max"
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      formik.setFieldValue(
                                                                        `ListOfParameter[${indx}].MaxValue`,
                                                                        e
                                                                          ?.target
                                                                          ?.value ??
                                                                          ""
                                                                      );
                                                                      OnMinMaxValueChangeConsiderResult(
                                                                        indx,
                                                                        item?.MinValue,
                                                                        e
                                                                          ?.target
                                                                          ?.value ??
                                                                          ""
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                              </>
                                                            )}
                                                            {/* {ParameterWith ==
                                                              3 && (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                <Field
                                                                  type="text"
                                                                  name={`ListOfParameter[${indx}].Requirement`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  placeholder="Requirement"
                                                                  maxLength={
                                                                    500
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                />
                                                              </td>
                                                            )} */}
                                                            {IsMixDesign ==
                                                            true ? (
                                                              <td
                                                                {...provided.dragHandleProps}
                                                                tabIndex={-1}
                                                              >
                                                                <label>
                                                                  {
                                                                    item.Requirement
                                                                  }
                                                                </label>
                                                              </td>
                                                            ) : (
                                                              ParameterWith ==
                                                                3 && (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "100px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    type="text"
                                                                    name={`ListOfParameter[${indx}].Requirement`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Requirement"
                                                                    maxLength={
                                                                      500
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                  />
                                                                </td>
                                                              )
                                                            )}
                                                            <td
                                                              {...provided.dragHandleProps}
                                                              tabIndex={-1}
                                                            >
                                                              <label
                                                                title={
                                                                  item.NABLRangeFrom
                                                                    ? item.NABLRangeFrom +
                                                                      " - " +
                                                                      item.NABLRangeTo
                                                                    : ""
                                                                }
                                                              >
                                                                {item.IsNABLParameter
                                                                  ? "Yes"
                                                                  : "No"}{" "}
                                                                &nbsp;
                                                                {item?.ParameterType ==
                                                                1
                                                                  ? item?.ParameterResultType ==
                                                                    2
                                                                    ? "(QL)"
                                                                    : "(QN)"
                                                                  : ""}
                                                              </label>
                                                            </td>
                                                            {item?.ListOfResultValue?.map(
                                                              (
                                                                result,
                                                                rIdx
                                                              ) => (
                                                                <td
                                                                  key={rIdx}
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    minWidth:
                                                                      "100px",
                                                                  }}
                                                                >
                                                                  <div className="d-flex justify-content-between">
                                                                    <div
                                                                      className="pe-1"
                                                                      style={{
                                                                        width:
                                                                          "90%",
                                                                      }}
                                                                    >
                                                                      <Field
                                                                        type="text"
                                                                        name={`ListOfParameter[${indx}].ListOfResultValue[${rIdx}].ResultValue`}
                                                                        component={
                                                                          CustomInput
                                                                        }
                                                                        placeholder="Value"
                                                                        maxLength={
                                                                          500
                                                                        }
                                                                        noMarginBottom={
                                                                          true
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          formik.setFieldValue(
                                                                            `ListOfParameter[${indx}].ListOfResultValue[${rIdx}].ResultValue`,
                                                                            e
                                                                              ?.target
                                                                              ?.value ??
                                                                              ""
                                                                          );

                                                                          OnResultValueChangeConsiderResult(
                                                                            indx,
                                                                            rIdx,
                                                                            item?.MinValue,
                                                                            item?.MaxValue,
                                                                            e
                                                                              ?.target
                                                                              ?.value ??
                                                                              "",
                                                                            item?.ParameterType,
                                                                            item?.NABLRangeFrom,
                                                                            item?.NABLRangeTo,
                                                                            item?.ParameterResultType,
                                                                            item?.IsNABLParameter
                                                                          );

                                                                          if (
                                                                            item.IsAverageRequired ==
                                                                            true
                                                                          ) {
                                                                            calculateResultAverage(
                                                                              indx,
                                                                              rIdx,
                                                                              e
                                                                                ?.target
                                                                                ?.value ??
                                                                                ""
                                                                            );
                                                                          }
                                                                        }}
                                                                      />
                                                                    </div>
                                                                    <div
                                                                      style={{
                                                                        alignContent:
                                                                          "center",
                                                                      }}
                                                                      {...provided.dragHandleProps}
                                                                      tabIndex={
                                                                        -1
                                                                      }
                                                                    >
                                                                      {ReferenceStandardIDEncrypted ? (
                                                                        <>
                                                                          <i
                                                                            className="fa fa-circle"
                                                                            style={{
                                                                              color:
                                                                                result?.ResultValue
                                                                                  ? result?.ConsiderResult ==
                                                                                    1
                                                                                    ? "green"
                                                                                    : result?.ConsiderResult ==
                                                                                      0
                                                                                    ? "red"
                                                                                    : result?.ConsiderResult ==
                                                                                      -1
                                                                                    ? "orange"
                                                                                    : ""
                                                                                  : "",
                                                                            }}
                                                                          ></i>
                                                                          <br></br>
                                                                        </>
                                                                      ) : (
                                                                        ""
                                                                      )}

                                                                      {item.IsNABLParameter ==
                                                                      true ? (
                                                                        <i
                                                                          className="fa fa-certificate"
                                                                          style={{
                                                                            color:
                                                                              result?.ResultValue
                                                                                ? result?.ConsiderNABLResult ==
                                                                                  1
                                                                                  ? "green"
                                                                                  : result?.ConsiderNABLResult ==
                                                                                    0
                                                                                  ? "red"
                                                                                  : result?.ConsiderNABLResult ==
                                                                                    -1
                                                                                  ? "orange"
                                                                                  : ""
                                                                                : "",
                                                                          }}
                                                                        ></i>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                              )
                                                            )}
                                                            {TestingQty &&
                                                            parseInt(
                                                              TestingQty
                                                            ) > 1 ? (
                                                              ListOfParameter?.filter(
                                                                (x) =>
                                                                  x.IsSelected ==
                                                                    true &&
                                                                  x.IsAverageRequired ==
                                                                    true
                                                              )?.length > 0 ? (
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    minWidth:
                                                                      "80px",
                                                                  }}
                                                                >
                                                                  {item.IsAverageRequired ==
                                                                    true && (
                                                                    <Field
                                                                      type="text"
                                                                      name={`ListOfParameter[${indx}].AverageResultValue`}
                                                                      component={
                                                                        CustomInput
                                                                      }
                                                                      placeholder="Average"
                                                                      maxLength={
                                                                        50
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                      noMarginBottom={
                                                                        true
                                                                      }
                                                                      onChange={() => {}} //to prevent change
                                                                    />
                                                                  )}
                                                                </td>
                                                              ) : (
                                                                ""
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </tr>
                                                        )}
                                                      </Draggable>
                                                    ) : (
                                                      ""
                                                    )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={10}
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <div>
                                                      {"No Record Found..."}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                              {provided.placeholder}
                                            </tbody>
                                          )}
                                        </Droppable>
                                      </table>
                                      <ErrorMessage
                                        name="ListOfParameter"
                                        component="div"
                                        className="invalid-feedback animated fadeInUp mb-0"
                                        style={{ display: "block" }}
                                      />
                                    </div>
                                  </div>
                                </DragDropContext>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {IsMixDesign == true && (
                      <>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>Sieve Analysis</label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <label className="mb-0">
                                      1 - Coarse Aggregate
                                    </label>
                                  </Col>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="mixDesignCourseAggRefStdParameterCriteria-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="mixDesignCourseAggRefStdParameterCriteria-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <thead>
                                            <tr key={0}>
                                              <th
                                                className="text-center"
                                                rowSpan="3"
                                              >
                                                IS Sieve Size <br></br>mm
                                              </th>
                                              {TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                  ?.SieveSizeList?.length > 0 &&
                                                TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                  (p, pIdx) => (
                                                    <th
                                                      className="text-center"
                                                      rowSpan={
                                                        p?.CriateriaList
                                                          .length > 0
                                                          ? p?.CriateriaList.filter(
                                                              (x) =>
                                                                x.IsInputColumn ==
                                                                true
                                                            ).length > 0
                                                            ? 1
                                                            : 2
                                                          : 3
                                                      }
                                                      colSpan={
                                                        p?.CriateriaList
                                                          .length > 0
                                                          ? p?.CriateriaList
                                                              .length
                                                          : 1
                                                      }
                                                      style={{
                                                        whiteSpace: "normal",
                                                      }}
                                                    >
                                                      {p?.ParameterColumnName}
                                                    </th>
                                                  )
                                                )}
                                            </tr>
                                            <tr key={1}>
                                              {TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                  ?.SieveSizeList?.length > 0 &&
                                                TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                  (p, pIdx) =>
                                                    p?.CriateriaList?.filter(
                                                      (x) =>
                                                        x.IsInputColumn == true
                                                    ).map((c, cIdx) => (
                                                      <th
                                                        className="text-center"
                                                        style={{
                                                          whiteSpace: "normal",
                                                        }}
                                                      >
                                                        {c?.ParameterCriteria}
                                                        <br></br>
                                                        <span
                                                          style={{
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          {c?.ColumnShortCode
                                                            ? `(Short Code: ${c?.ColumnShortCode})`
                                                            : ""}
                                                        </span>
                                                      </th>
                                                    ))
                                                )}
                                            </tr>
                                            <tr key={2}>
                                              {TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                                TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                  ?.SieveSizeList?.length > 0 &&
                                                TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                  (p, pIdx) =>
                                                    p?.CriateriaList?.map(
                                                      (c, cIdx) => (
                                                        <th
                                                          className="text-center"
                                                          style={{
                                                            whiteSpace:
                                                              "normal",
                                                          }}
                                                        >
                                                          {c?.IsInputColumn ==
                                                          true ? (
                                                            <div className="d-flex">
                                                              {c?.IsInputColumnValueType ==
                                                                true && (
                                                                <>
                                                                  <span className="mt-2 mb-1 me-1">
                                                                    {
                                                                      c.ColumnShortCode
                                                                    }
                                                                    {`${
                                                                      c.ColumnShortCode
                                                                        ? "X"
                                                                        : ""
                                                                    }`}
                                                                  </span>
                                                                  <Field
                                                                    style={{
                                                                      minWidth:
                                                                        "50px",
                                                                    }}
                                                                    type="number"
                                                                    name={`TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0].ParameterList[${pIdx}].CriateriaList[${cIdx}].InputColumnValueofX`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    placeholder="Value"
                                                                  />
                                                                </>
                                                              )}
                                                              <Field
                                                                style={{
                                                                  minWidth:
                                                                    c?.IsInputColumnValueType ==
                                                                    true
                                                                      ? "50px"
                                                                      : "100px",
                                                                }}
                                                                type="text"
                                                                name={`TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0].ParameterList[${pIdx}].CriateriaList[${cIdx}].InputColumnName`}
                                                                component={
                                                                  CustomInput
                                                                }
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                maxLength={200}
                                                                placeholder={
                                                                  c?.IsInputColumnValueType ==
                                                                  true
                                                                    ? "Prefix"
                                                                    : "Column Name"
                                                                }
                                                              />
                                                              {c.FormulaEvaluationStatus >
                                                                0 && (
                                                                <Link
                                                                  to="#"
                                                                  className={`icon-box icon-box-md ms-1 mt-1 ${
                                                                    c.FormulaEvaluationStatus ==
                                                                    1
                                                                      ? "bg-success"
                                                                      : c.FormulaEvaluationStatus ==
                                                                        2
                                                                      ? "bg-danger"
                                                                      : "bg-secondary-light"
                                                                  }`}
                                                                  title={
                                                                    c.FormulaExpression
                                                                  }
                                                                  onClick={() => {
                                                                    showFormula(
                                                                      `${p.ParameterColumnName} - ${c.ParameterCriteria}`,
                                                                      c.FormulaExpression
                                                                    );
                                                                  }}
                                                                  tabIndex={-1}
                                                                >
                                                                  {
                                                                    SVGICON.Formula
                                                                  }
                                                                </Link>
                                                              )}
                                                              {c.FormulaEvaluationStatus ==
                                                                1 && (
                                                                <Link
                                                                  to="#"
                                                                  className={`icon-box icon-box-md bg-primary-light ms-1 mt-1`}
                                                                  title="Calculate Formula"
                                                                  onClick={() => {
                                                                    calculateFormulaMixDesignSieveAnalysisCoarseAggregate(
                                                                      cIdx,
                                                                      pIdx,
                                                                      c.FormulaExpression,
                                                                      c.FormulaVariables
                                                                    );
                                                                  }}
                                                                  tabIndex={-1}
                                                                >
                                                                  {
                                                                    SVGICON.Calculator
                                                                  }
                                                                </Link>
                                                              )}
                                                            </div>
                                                          ) : (
                                                            c?.ParameterCriteria
                                                          )}
                                                        </th>
                                                      )
                                                    )
                                                )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                              TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                ?.SieveSizeList?.length > 0 &&
                                              TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList?.map(
                                                (s, sIdx) => (
                                                  <tr key={sIdx}>
                                                    <td className="text-center">
                                                      {s?.SieveSize}
                                                    </td>
                                                    {s?.ParameterList.map(
                                                      (p, pIdx) =>
                                                        p?.CriateriaList.map(
                                                          (c, cIdx) => (
                                                            <td className="text-center">
                                                              {c?.IsInputColumn ==
                                                              true ? (
                                                                <Field
                                                                  type="text"
                                                                  name={`TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[${sIdx}].ParameterList[${pIdx}].CriateriaList[${cIdx}].ColumnValue`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  maxLength={
                                                                    100
                                                                  }
                                                                />
                                                              ) : c?.ColumnValue ? (
                                                                c.ColumnValue
                                                              ) : (
                                                                "-"
                                                              )}
                                                            </td>
                                                          )
                                                        )
                                                    )}
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <label className="mb-0">
                                      2 - Fine Aggregate
                                    </label>
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Conforming To grading Zone"
                                      name={
                                        "TestMixDesignDetail.FineAggregateConformingToGradingZone"
                                      }
                                      placeholder={"Conforming to grading Zone"}
                                      component={CustomInput}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Reference Standard Table"
                                      name={
                                        "TestMixDesignDetail.FineAggregateReferenceStandardAndTableName"
                                      }
                                      placeholder={"Reference Standard Table"}
                                      options={
                                        optionsFineAggregateReferenceStandardWithTable
                                      }
                                      component={CustomSelect}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>
                                A-3 TARGET STRENGTH FOR MIX PROPORTIONING
                              </label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="mixDesignCourseAggRefStdParameterCriteria-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="mixDesignCourseAggRefStdParameterCriteria-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <tbody>
                                            {Object.entries(
                                              objMixDesignTargetStrength
                                            )?.map(
                                              (
                                                [formula, items],
                                                formulaIndex
                                              ) => (
                                                <React.Fragment
                                                  key={formulaIndex}
                                                >
                                                  <tr key={formulaIndex}>
                                                    <td
                                                      colSpan={2}
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      <label>{formula}</label>
                                                    </td>
                                                  </tr>
                                                  {items.map((T) => (
                                                    <tr key={T.originalIndex}>
                                                      <td>
                                                        {T.VariableName} ={" "}
                                                        {T.VariableTitle}
                                                        {T.FormulaExpression &&
                                                          T.IsResultRow ==
                                                            false &&
                                                          T.FormulaEvaluationStatus >
                                                            0 && (
                                                            <Link
                                                              to="#"
                                                              className={`icon-box icon-box-md ms-1 mt-1 ${
                                                                T.FormulaEvaluationStatus ==
                                                                1
                                                                  ? "bg-success"
                                                                  : T.FormulaEvaluationStatus ==
                                                                    2
                                                                  ? "bg-danger"
                                                                  : "bg-secondary-light"
                                                              }`}
                                                              title={
                                                                T.FormulaExpression
                                                              }
                                                              onClick={() => {
                                                                showFormula(
                                                                  "f 'ck",
                                                                  T.FormulaExpression
                                                                );
                                                              }}
                                                              tabIndex={-1}
                                                            >
                                                              {SVGICON.Formula}
                                                            </Link>
                                                          )}
                                                        {T.FormulaExpression &&
                                                          T.IsResultRow ==
                                                            false &&
                                                          T.FormulaEvaluationStatus ==
                                                            1 && (
                                                            <Link
                                                              to="#"
                                                              className={`icon-box icon-box-md bg-primary-light ms-1 mt-1`}
                                                              title="Calculate Formula"
                                                              onClick={() => {
                                                                calculateFormulaMixDesignTargetStrength(
                                                                  T.originalIndex,
                                                                  T.Formula,
                                                                  T.FormulaExpression,
                                                                  T.FormulaVariables
                                                                );
                                                              }}
                                                              tabIndex={-1}
                                                            >
                                                              {
                                                                SVGICON.Calculator
                                                              }
                                                            </Link>
                                                          )}
                                                        {T.IsResultRow ==
                                                          true &&
                                                          T.FormulaVariables
                                                            ?.length > 0 &&
                                                          `(${T.FormulaVariables})`}
                                                      </td>
                                                      <td>
                                                        <Field
                                                          style={{
                                                            minWidth: "100px",
                                                          }}
                                                          type="number"
                                                          name={`ListOfMixDesignTargetStrengthForMixProportioning[${T.originalIndex}].VariableValue`} // Use the original index here
                                                          placeholder="Value"
                                                          component={
                                                            CustomInput
                                                          }
                                                          noMarginBottom={true}
                                                          maxLength={50}
                                                        />
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </React.Fragment>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>A-4 APPROXIMATE AIR CONTENT</label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="mixDesignApproximateAirContent-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="mixDesignApproximateAirContent-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <tbody>
                                            <tr>
                                              <td colSpan={2}>
                                                {
                                                  TestMixDesignDetail.ApproximateAirContentResultTitle
                                                }
                                              </td>
                                              <td
                                                rowSpan={2}
                                                style={{ textAlign: "center" }}
                                              >
                                                {
                                                  TestMixDesignDetail.ApproximateAirContentResultValue
                                                }
                                              </td>
                                              <td
                                                rowspan={2}
                                                style={{ textAlign: "center" }}
                                              >
                                                {
                                                  TestMixDesignDetail.ApproximateAirContentReferenceStandardAndTableName
                                                }
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                For nominal maximum size of
                                                aggregate,
                                              </td>
                                              <td
                                                style={{ textAlign: "center" }}
                                              >
                                                {TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
                                                  ? optionsMaximumNominalSizeofAggregate?.filter(
                                                      (x) =>
                                                        x.value ==
                                                        TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
                                                    )[0]?.label
                                                  : ""}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>A-5 SELECTION OF WATER-CEMENT RATIO</label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={3}>
                                    <Field
                                      label="Reference Standard"
                                      name={
                                        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName"
                                      }
                                      placeholder={"Reference Standard"}
                                      options={
                                        optionsReferenceStandardConcreteExposure
                                      }
                                      component={CustomSelect}
                                      onChange={(e) => {
                                        handleChangeSelectionOfWaterCementRatioReferenceStandardName(
                                          e
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Reference Standard Table"
                                      name={
                                        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName"
                                      }
                                      placeholder={"Reference Standard Table"}
                                      options={
                                        optionsReferenceStandardTableConcreteExposure
                                      }
                                      component={CustomSelect}
                                      onChange={(e) => {
                                        handleChangeSelectionOfWaterCementRatioReferenceStandardTableName(
                                          e
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Concrete Type"
                                      name={"TestMixDesignDetail.ConcreteType"}
                                      placeholder={"Concrete Type"}
                                      options={optionsTypeOfConcrete}
                                      component={CustomSelect}
                                      onChange={(e) => {
                                        handleChangeSelectionOfWaterCementRatioTypeOfConcrete(
                                          e
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Concrete Grade"
                                      name={"TestMixDesignDetail.ConcreteGrade"}
                                      placeholder={"Concrete Grade"}
                                      options={optionsTypeOfConcreteGrade}
                                      component={CustomSelect}
                                      onChange={(e) => {
                                        handleChangeSelectionOfWaterCementRatioTypeOfConcreteGrade(
                                          e
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Max Free Water Cement Ratio"
                                      name={
                                        "TestMixDesignDetail.MaxFreeWaterCementRatio"
                                      }
                                      placeholder={
                                        "Max Free Water Cement Ratio"
                                      }
                                      component={CustomInput}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      type="number"
                                      label="Free Water Cement Ratio"
                                      name={
                                        "TestMixDesignDetail.FreeWaterCementRatio"
                                      }
                                      placeholder={"Free Water Cement Ratio"}
                                      component={CustomInput}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "TestMixDesignDetail.FreeWaterCementRatio",
                                          e?.target?.value ?? ""
                                        );
                                        formik.setFieldValue(
                                          "TestMixDesignDetail.WaterCementRatio",
                                          e?.target?.value ?? ""
                                        );
                                        if (e?.target?.value) {
                                          SetCalculateCementContent(true);
                                        }
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>A-6 SELECTION OF WATER CONTENT</label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="mixDesignA6-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="mixDesignA6-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <tbody>
                                            <tr>
                                              <td>
                                                For nominal maximum size of
                                                aggregate,
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "center",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
                                                  ? optionsMaximumNominalSizeofAggregate?.filter(
                                                      (x) =>
                                                        x.value ==
                                                        TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
                                                    )[0]?.label
                                                  : ""}
                                              </td>
                                              <td>Estimated Water Content</td>
                                              <td
                                                style={{
                                                  textAlign: "center",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {
                                                  TestMixDesignDetail.Workability
                                                }
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.AsSuperPlasticizerIsUsed"
                                      }
                                      label={"As Super Plasticizer is used"}
                                      placeholder={
                                        "As Super Plasticizer is used"
                                      }
                                      component={CustomInput}
                                      maxLength={500}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.SelectionOfWaterContentReferenceStandardAndTableName"
                                      }
                                      label={
                                        "Reference Standard With Table Name"
                                      }
                                      placeholder={
                                        "Reference Standard With Table Name"
                                      }
                                      component={CustomInput}
                                      maxLength={500}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.SelectionOfWaterContentRemarks"
                                      }
                                      label={"Remarks"}
                                      placeholder={"Remarks"}
                                      component={CustomInput}
                                      maxLength={1000}
                                    />
                                  </Col>
                                  {ListOfMixDesignGroupParameters?.map(
                                    (item, indx) =>
                                      item.GroupName == "A-6" && (
                                        <>
                                          <Col lg={3}>
                                            {item.IsResultValueBasedOnFormula ==
                                              false &&
                                              item.FormulaExpression && (
                                                <>
                                                  {item.FormulaEvaluationStatus ==
                                                    1 && (
                                                    <Link
                                                      to="#"
                                                      className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                      title="Calculate Formula"
                                                      style={{ float: "right" }}
                                                      onClick={() => {
                                                        calculateFormulaMixDesignGroupParameters(
                                                          indx,
                                                          item.FormulaExpression,
                                                          item.FormulaVariables,
                                                          "A-6"
                                                        );
                                                      }}
                                                      tabIndex={-1}
                                                    >
                                                      {SVGICON.Calculator}
                                                    </Link>
                                                  )}
                                                  <Link
                                                    to="#"
                                                    className={`icon-box icon-box-md ms-1 ${
                                                      item.FormulaEvaluationStatus ==
                                                      1
                                                        ? "bg-success"
                                                        : item.FormulaEvaluationStatus ==
                                                          2
                                                        ? "bg-danger"
                                                        : "bg-secondary-light"
                                                    }`}
                                                    style={{ float: "right" }}
                                                    title={
                                                      item.FormulaExpression
                                                    }
                                                    onClick={() => {
                                                      showFormula(
                                                        item.ParameterName,
                                                        item.FormulaExpression
                                                      );
                                                    }}
                                                    tabIndex={-1}
                                                  >
                                                    {SVGICON.Formula}
                                                  </Link>
                                                </>
                                              )}
                                            <Field
                                              type="number"
                                              name={`ListOfMixDesignGroupParameters[${indx}].ParameterValue`}
                                              label={`${item.ParameterName} ${
                                                item.ShortCode
                                                  ? "(" + item.ShortCode + ")"
                                                  : ""
                                              }`}
                                              placeholder={`Enter ${item.ParameterName} Value`}
                                              component={CustomInput}
                                              maxLength={50}
                                            />
                                          </Col>
                                          {item.IsResultValueBasedOnFormula ==
                                            true && (
                                            <Col lg={3}>
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md ms-1 ${
                                                  item.FormulaEvaluationStatus ==
                                                  1
                                                    ? "bg-success"
                                                    : item.FormulaEvaluationStatus ==
                                                      2
                                                    ? "bg-danger"
                                                    : "bg-secondary-light"
                                                }`}
                                                title={item.FormulaExpression}
                                                onClick={() => {
                                                  showFormula(
                                                    item.ParameterName,
                                                    item.FormulaExpression
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Formula}
                                              </Link>
                                              {item.FormulaEvaluationStatus ==
                                                1 && (
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateFormulaMixDesignGroupParameters(
                                                      indx,
                                                      item.FormulaExpression,
                                                      item.FormulaVariables,
                                                      "A-6"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              )}
                                              <Field
                                                type="number"
                                                name={`ListOfMixDesignGroupParameters[${indx}].ResultValue`}
                                                placeholder={`Result Value`}
                                                component={CustomInput}
                                                maxLength={50}
                                              />
                                            </Col>
                                          )}
                                        </>
                                      )
                                  )}
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>
                                A-7(I) CALCULATION OF CEMENT CONTENT
                              </label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.WaterCementRatio"
                                      }
                                      label={"Water Cement Ratio"}
                                      placeholder={"Water Cement Ratio"}
                                      component={CustomInput}
                                      maxLength={50}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.CementContentKgPerM3FormulaValue"
                                      }
                                      label={"Cement Content Kg/m3 Calculation"}
                                      placeholder={
                                        "Cement Content Kg/m3 Calculation"
                                      }
                                      component={CustomInput}
                                      maxLength={50}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.CementContentKgPerM3ResultValue"
                                      }
                                      label={
                                        "Cement Content Kg/m3 Result Value"
                                      }
                                      placeholder={
                                        "Cement Content Kg/m3 Calculation"
                                      }
                                      component={CustomInput}
                                      maxLength={50}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      name={
                                        "TestMixDesignDetail.CementContentKgPerM3FinalResult"
                                      }
                                      label={
                                        "Cement Content Kg/m3 Final Result Value"
                                      }
                                      placeholder={
                                        "Cement Content Kg/m3 Final Result Value"
                                      }
                                      component={CustomInput}
                                      maxLength={50}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      type="number"
                                      name={
                                        "TestMixDesignDetail.MinimumCementContent"
                                      }
                                      label={"Minimum Cement Content (kg/m3)"}
                                      placeholder={
                                        "Minimum Cement Content (kg/m3)"
                                      }
                                      component={CustomInput}
                                      maxLength={50}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {TestMixDesignDetail?.TypeofMineralAdmixtureIDEncrypted && (
                          <>
                            <hr className="mt-0 mb-1"></hr>
                            <Row>
                              <div className="d-flex justify-content-between mb-0">
                                <div className="d-flex mb-0">
                                  <label>
                                    A-7(II) CALCULATION OF CEMENTITOUS MATERIAL
                                    / Mineral Admixture
                                  </label>
                                </div>
                              </div>
                              <Col lg={12}>
                                <div
                                  className="card mb-2"
                                  style={{ height: "auto" }}
                                >
                                  <div className="card-body p-2">
                                    <Row>
                                      <Col lg={12}>
                                        In certain situations, increase in
                                        cementitious material content may be
                                        warranted. The decision on increase in
                                        cementitious material content and its
                                        percentage may be based on experience
                                        and trials.
                                      </Col>
                                      <Col lg={3}>
                                        <label>
                                          Cementitious material content kg/m3:
                                        </label>
                                      </Col>
                                      <Col lg={3}>
                                        <Field
                                          type="number"
                                          name={
                                            "TestMixDesignDetail.CementitiousMaterialContentIsTakenAsMoreOrLessPercentage"
                                          }
                                          label={"Is Taken as More Or Less %"}
                                          placeholder={
                                            "Is Taken as More Or Less %"
                                          }
                                          component={CustomInput}
                                          maxLength={50}
                                          onChange={(e) => {
                                            if (e?.target.value <= 100) {
                                              formik.setFieldValue(
                                                "TestMixDesignDetail.CementitiousMaterialContentIsTakenAsMoreOrLessPercentage",
                                                e?.target?.value ?? ""
                                              );
                                            }
                                          }}
                                          onBlur={(e) => {
                                            let cementContentPer =
                                              100 - (e?.target?.value ?? 0);
                                            formik.setFieldValue(
                                              "TestMixDesignDetail.CementitiousMaterialContentOfCementContentPercentage",
                                              cementContentPer
                                            );
                                            let cementContent =
                                              ((TestMixDesignDetail.CementContentKgPerM3FinalResult ??
                                                0) *
                                                cementContentPer) /
                                              100;
                                            formik.setFieldValue(
                                              "TestMixDesignDetail.CementContentKgPerM3",
                                              cementContent.toFixed(2)
                                            );
                                            let cementitiousContent =
                                              TestMixDesignDetail.CementContentKgPerM3FinalResult -
                                              cementContent;
                                            formik.setFieldValue(
                                              "TestMixDesignDetail.CementitiousMaterialContentKgPerM3",
                                              cementitiousContent.toFixed(2)
                                            );
                                          }}
                                        />
                                      </Col>
                                      <Col lg={3}>
                                        <Field
                                          type="number"
                                          name={
                                            "TestMixDesignDetail.CementitiousMaterialContentOfCementContentPercentage"
                                          }
                                          label={"Of Cement Content %"}
                                          placeholder={"Of Cement Content %"}
                                          component={CustomInput}
                                          maxLength={50}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col lg={3}>
                                        <Field
                                          type="number"
                                          name={
                                            "TestMixDesignDetail.CementContentKgPerM3"
                                          }
                                          label={"Cement Content Kg/m3"}
                                          placeholder={"Cement Content Kg/m3"}
                                          component={CustomInput}
                                          maxLength={50}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col lg={3}>
                                        <Field
                                          type="number"
                                          name={
                                            "TestMixDesignDetail.WaterContentKgPerM3"
                                          }
                                          label={"Water Content Kg/m3"}
                                          placeholder={"Water Content Kg/m3"}
                                          component={CustomInput}
                                          maxLength={50}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col lg={3}>
                                        <Field
                                          type="number"
                                          name={
                                            "TestMixDesignDetail.WaterCementRatioCementitiousMaterial"
                                          }
                                          label={"Water Cement Ratio"}
                                          placeholder={"Water Cement Ratio"}
                                          component={CustomInput}
                                          maxLength={50}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col lg={3}>
                                        <Field
                                          type="number"
                                          name={
                                            "TestMixDesignDetail.CementitiousMaterialContentKgPerM3"
                                          }
                                          label={
                                            "Cementitious Material Content Kg/m3"
                                          }
                                          placeholder={
                                            "Cementitious Material Content Kg/m3"
                                          }
                                          component={CustomInput}
                                          maxLength={50}
                                          disabled={true}
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>
                                A-8 PROPORTION OF VOLUME OF COARSE AGGREGATE AND
                                FINE AGGREGETE CONTENT
                              </label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="A-8-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="A-8-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <tbody>
                                            <tr>
                                              <td>
                                                For nominal maximum size of
                                                aggregate,
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "center",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
                                                  ? optionsMaximumNominalSizeofAggregate?.filter(
                                                      (x) =>
                                                        x.value ==
                                                        TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted
                                                    )[0]?.label
                                                  : ""}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                Fine Aggregate grading Zone
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "center",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {
                                                  TestMixDesignDetail.FineAggregateConformingToGradingZone
                                                }
                                              </td>
                                            </tr>
                                            {ListOfMixDesignGroupParameters?.map(
                                              (item, indx) =>
                                                (item.GroupName == "A-8" ||
                                                  (item.GroupName == "A-8." &&
                                                    TestMixDesignDetail.MethodofConcretePlacingIsPumping ==
                                                      true)) && (
                                                  <tr key={indx}>
                                                    <td
                                                      style={{
                                                        whiteSpace: "normal",
                                                        minWidth: "100px",
                                                        maxWidth: "400px",
                                                      }}
                                                    >
                                                      <label>{`${
                                                        item.ParameterName
                                                      } ${
                                                        item.ShortCode
                                                          ? "(" +
                                                            item.ShortCode +
                                                            ")"
                                                          : ""
                                                      }`}</label>
                                                    </td>
                                                    <td
                                                      style={{
                                                        minWidth: "100px",
                                                        maxWidth: "100px",
                                                      }}
                                                    >
                                                      {item.IsResultValueBasedOnFormula ==
                                                        false &&
                                                        item.FormulaExpression && (
                                                          <>
                                                            {item.FormulaEvaluationStatus ==
                                                              1 && (
                                                              <Link
                                                                to="#"
                                                                className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                                title="Calculate Formula"
                                                                style={{
                                                                  float:
                                                                    "right",
                                                                }}
                                                                onClick={() => {
                                                                  calculateFormulaMixDesignGroupParameters(
                                                                    indx,
                                                                    item.FormulaExpression,
                                                                    item.FormulaVariables,
                                                                    "A-8"
                                                                  );
                                                                }}
                                                                tabIndex={-1}
                                                              >
                                                                {
                                                                  SVGICON.Calculator
                                                                }
                                                              </Link>
                                                            )}
                                                            <Link
                                                              to="#"
                                                              className={`icon-box icon-box-md ms-1 ${
                                                                item.FormulaEvaluationStatus ==
                                                                1
                                                                  ? "bg-success"
                                                                  : item.FormulaEvaluationStatus ==
                                                                    2
                                                                  ? "bg-danger"
                                                                  : "bg-secondary-light"
                                                              }`}
                                                              style={{
                                                                float: "right",
                                                              }}
                                                              title={
                                                                item.FormulaExpression
                                                              }
                                                              onClick={() => {
                                                                showFormula(
                                                                  item.ParameterName,
                                                                  item.FormulaExpression
                                                                );
                                                              }}
                                                              tabIndex={-1}
                                                            >
                                                              {SVGICON.Formula}
                                                            </Link>
                                                          </>
                                                        )}
                                                      <Field
                                                        type="number"
                                                        label={" "}
                                                        name={`ListOfMixDesignGroupParameters[${indx}].ParameterValue`}
                                                        placeholder={`Enter ${item.ParameterName} Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                      />
                                                    </td>
                                                    {item.IsResultValueBasedOnFormula ==
                                                      true && (
                                                      <td width={"200px"}>
                                                        {item.FormulaEvaluationStatus ==
                                                          1 && (
                                                          <Link
                                                            to="#"
                                                            className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                            style={{
                                                              float: "right",
                                                            }}
                                                            title="Calculate Formula"
                                                            onClick={() => {
                                                              calculateFormulaMixDesignGroupParameters(
                                                                indx,
                                                                item.FormulaExpression,
                                                                item.FormulaVariables,
                                                                "A-8"
                                                              );
                                                            }}
                                                            tabIndex={-1}
                                                          >
                                                            {SVGICON.Calculator}
                                                          </Link>
                                                        )}
                                                        <Link
                                                          to="#"
                                                          className={`icon-box icon-box-md ms-1 ${
                                                            item.FormulaEvaluationStatus ==
                                                            1
                                                              ? "bg-success"
                                                              : item.FormulaEvaluationStatus ==
                                                                2
                                                              ? "bg-danger"
                                                              : "bg-secondary-light"
                                                          }`}
                                                          style={{
                                                            float: "right",
                                                          }}
                                                          title={
                                                            item.FormulaExpression
                                                          }
                                                          onClick={() => {
                                                            showFormula(
                                                              item.ParameterName,
                                                              item.FormulaExpression
                                                            );
                                                          }}
                                                          tabIndex={-1}
                                                        >
                                                          {SVGICON.Formula}
                                                        </Link>

                                                        <Field
                                                          type="number"
                                                          name={`ListOfMixDesignGroupParameters[${indx}].ResultValue`}
                                                          placeholder={`Result Value`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          maxLength={50}
                                                        />
                                                      </td>
                                                    )}
                                                    {item?.Remarks && (
                                                      <td
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                        colSpan={2}
                                                      >
                                                        <Field
                                                          // label="Remarks"
                                                          name={`ListOfMixDesignGroupParameters[${indx}].Remarks`}
                                                          placeholder={`Remarks`}
                                                          component={
                                                            CustomTextArea
                                                          }
                                                          rows={5}
                                                          maxLength={2000}
                                                        />
                                                      </td>
                                                    )}
                                                  </tr>
                                                )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>A-9 MIX CALCULATIONS</label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="A-9-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="A-9-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                colSpan={4}
                                                style={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                The mix calculations per unit
                                                volume of concrete shall be as
                                                follows:
                                              </td>
                                            </tr>
                                            {ListOfMixDesignMixCalculation?.map(
                                              (item, indx) => (
                                                <tr key={indx}>
                                                  <td
                                                    style={{
                                                      minWidth: "100px",
                                                    }}
                                                  >
                                                    {item.ParameterShortCode
                                                      ? `${item.ParameterShortCode}) `
                                                      : ""}
                                                    {item.ParameterName}
                                                  </td>
                                                  <td
                                                    style={{ minWidth: "100%" }}
                                                  >
                                                    {item.ParameterFormula}
                                                  </td>
                                                  <td
                                                    style={{
                                                      minWidth: "100px",
                                                    }}
                                                  >
                                                    {item.ParameterFormulaValue}
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                      minWidth: "150px",
                                                    }}
                                                  >
                                                    <div className="d-flex">
                                                      {item.ParameterShortCode !=
                                                      "a" ? (
                                                        <Link
                                                          to="#"
                                                          className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                          title="Calculate Formula"
                                                          onClick={() => {
                                                            calculateFormulaMixCalculation(
                                                              indx,
                                                              item.ParameterShortCode
                                                            );
                                                          }}
                                                          tabIndex={-1}
                                                        >
                                                          {SVGICON.Calculator}
                                                        </Link>
                                                      ) : (
                                                        <>
                                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        </>
                                                      )}
                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignMixCalculation[${indx}].ParameterResultValue`}
                                                        placeholder={`Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                      <div
                                                        style={{ width: "10%" }}
                                                      >
                                                        &nbsp;
                                                        {item.ResultUnit}
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="mt-0 mb-1"></hr>
                        <Row>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="table-responsive active-projects style-1 shorting mb-0">
                                      <div
                                        id="mixProportionsForTrial-tbl_wrapper"
                                        className="dataTables_wrapper table-responsive no-footer"
                                      >
                                        <table
                                          id="mixProportionsForTrial-tbl"
                                          className="table table-bordered no-footer mb-2"
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                colSpan={3}
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                A-10 MIX PROPORTIONS FOR TRIAL
                                              </th>
                                              <th
                                                colSpan={2}
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                A-11 ADJUSTMENT ON WATER, FINE
                                                AGGREGATE AND COARSE AGGREGATE
                                                (IF THE COARSE AND FINE
                                                AGGREGATE IS IN DRY CONDITION)
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                A-12 MIX PROPORTIONS AFTER
                                                ADUSTMENT FOR DRY AGGREGATES
                                              </th>
                                              <th
                                                colSpan={4}
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                A-12 LABORATORY MIX TRIAL
                                                PROPORTIONS AFTER MOSTURE
                                                CONTENT CORRECTION
                                              </th>
                                            </tr>
                                            <tr>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                Sr. No.
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Type of material
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Per m3 of Concrete, Kg (SSD-
                                                Aggregates shall be used in
                                                saturated surface dry condition)
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "PerM3OfConcreteKg"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Water Absorption %
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "WaterAbsorptionPercentage"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Weight of W.A,kg
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "WeightOfWaterAbsorptionKg"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Per m3 of Concrete, Kg after
                                                water absorption correction
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "PerM3OfConcreteKgAfterWaterAbsorptionCorrection"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Moisture content % of aggregate
                                                {/* [As per IS 2386 (Part 3)]: */}
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "MoistureContentPercentageOfAggregate"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Moisture content weigth,kg
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "MoistureContentWeightKg"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                Per m3 of Concrete, Kg after
                                                Moisture content correction
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "PerM3OfConcreteKgAfterMoistureContentCorrection"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                              <th
                                                style={{
                                                  textAlign: "center",
                                                  whiteSpace: "normal",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                0.027 m3 of concrete , Kg for
                                                Laboratory Mix Trial proportion{" "}
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                  title="Calculate Formula"
                                                  onClick={() => {
                                                    calculateMixProportionsForTrial(
                                                      "LaboratoryMixTrialProportion"
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Calculator}
                                                </Link>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {ListOfMixDesignMixProportionsForTrial?.map(
                                              (item, indx) => (
                                                <tr key={indx}>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {item?.SrNo == 0
                                                      ? ""
                                                      : item?.SrNo}
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {item?.TypeOfMaterial}
                                                  </td>
                                                  <td
                                                    style={{
                                                      minWidth: "150px",
                                                    }}
                                                  >
                                                    <div className="d-flex">
                                                      {(item?.MaterialShortCode ==
                                                        "CA20" ||
                                                        item?.MaterialShortCode ==
                                                          "CA10") && (
                                                        <Field
                                                          type="text"
                                                          name={`ListOfMixDesignMixProportionsForTrial[${indx}].CoarseAggregatePercentageOfFraction`}
                                                          placeholder={`Percentage(%)`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          maxLength={50}
                                                          noMarginBottom={true}
                                                        />
                                                      )}
                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKg`}
                                                        placeholder={`Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td>
                                                    {item?.SrNo && (
                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignMixProportionsForTrial[${indx}].WaterAbsorptionPercentage`}
                                                        placeholder={`Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                    )}
                                                  </td>
                                                  <td>
                                                    {item?.SrNo && (
                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignMixProportionsForTrial[${indx}].WeightOfWaterAbsorptionKg`}
                                                        placeholder={`Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                    )}
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  </td>
                                                  <td>
                                                    {item?.SrNo && (
                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignMixProportionsForTrial[${indx}].MoistureContentPercentageOfAggregate`}
                                                        placeholder={`Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                    )}
                                                  </td>
                                                  <td>
                                                    {item?.SrNo && (
                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignMixProportionsForTrial[${indx}].MoistureContentWeightKg`}
                                                        placeholder={`Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                    )}
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKgAfterMoistureContentCorrection`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].LaboratoryMixTrialProportion`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                    <hr className="mt-0 mb-1"></hr>
                    <Row>
                      <Col lg={6}>
                        <Field
                          label="Result"
                          name="Result"
                          placeholder={"Enter Result"}
                          component={CustomTextArea}
                          rows={5}
                          maxLength={2000}
                        />
                      </Col>
                      <Col lg={6}>
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-primary-light me-1"
                          title="Select Testing Remarks"
                          style={{ float: "right" }}
                          onClick={() => {
                            setShowTestingRemarksModal(true);
                          }}
                        >
                          <i className="fa fa-edit"></i>
                        </Link>
                        <Field
                          label="Remarks"
                          name="Remarks"
                          placeholder={"Enter Remarks"}
                          component={CustomTextArea}
                          rows={5}
                          maxLength={2000}
                        />
                      </Col>
                    </Row>
                    {TestingStatus > 1 ? (
                      <Row>
                        <Col lg={6}>
                          <Field
                            label="Change Note"
                            name="ChangeNote"
                            placeholder={"Enter Change Note"}
                            component={CustomTextArea}
                            rows={5}
                            maxLength={2000}
                            required
                          />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </div>
                )}

                <div className="stickyBottomButtons">
                  <hr className="mt-0 mb-2"></hr>
                  {InwardMaterialTestDetailIDEncrypt &&
                    AllowTestingEdit == 1 && (
                      <>
                        {TestingStatus <= 2 && (
                          <>
                            <button
                              type="submit"
                              className="btn btn-primary btn-sm me-2"
                              onClick={() => {
                                formik.setFieldValue("btnSubmitType", 1);
                              }}
                            >
                              <i className="fa fa-bookmark"></i> Draft
                            </button>
                          </>
                        )}
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            formik.setFieldValue("btnSubmitType", 2);
                          }}
                        >
                          <i className="fa-solid fa-floppy-disk"></i> Submit
                        </button>
                        {AuthUser?.Permissions?.IsOperationApprover == true &&
                          AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.TestingApprovalRequired ==
                            true && (
                            <button
                              type="submit"
                              className="btn btn-primary btn-sm me-2"
                              onClick={() => {
                                formik.setFieldValue("btnSubmitType", 3);
                              }}
                            >
                              <i className="fa-solid fa-floppy-disk"></i> Submit
                              & Approve
                            </button>
                          )}
                      </>
                    )}
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      //   navigate(-1);
                      if (
                        AuthUser?.Permissions
                          ?.TestingAfterSaveStayOnEntryScreen == true
                      ) {
                        navigate("/testing-list");
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>

        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="mb-2">
                    <label></label>
                    <div className="avatar-file">
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                        //key={fileKeyMaterialPhoto || ""}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                    <div
                      id="webCam"
                      className="avatar-camera"
                      onClick={() => {
                        setOpenWebCamModalLetterRefDocImage(true);
                      }}
                      style={{ marginLeft: "50px" }}
                    >
                      <input type="hidden" />
                      <label htmlFor="webCam" name=""></label>
                    </div>
                  </div>
                  {/* <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                  </div> */}
                </Col>
                {letterRefDocPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={
                                letterRefDocPhoto ? letterRefDocPhoto : img200
                              }
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addLetterRefDocFile();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setLetterRefDocPhoto(null);
                            setLetterRefDocPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="LetterRefDocPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="LetterRefDocPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td style={{ textAlign: "left" }}>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      //deleteLetterRefDoc(indx);
                                      delete_RecordWithoutApi(
                                        deleteLetterRefDoc,
                                        indx
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefImageFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {openWebCamModalLetterRefDocImage == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowLetterRefDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalLetterRefDocImage}
          onHide={setOpenWebCamModalLetterRefDocImage}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={captureLetterRefDocPhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalLetterRefDocImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="fade"
          show={showAddTPIDetailModal}
          onHide={setShowAddTPIDetailModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTPIDetail}>
              <Form onSubmit={formikTPIDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {actionFlagTPI == 1 ? "Edit" : "Add"} TPI Detail
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="TPI"
                        name="TPIIDEncrypted"
                        placeholder={"Select TPI"}
                        options={tpiCustomerOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIIDEncrypted",
                            e.value ?? ""
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIName",
                            e.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Contact Person"
                        name="TPIContactPersonIDEncrypted"
                        placeholder={"Select Contact Person"}
                        options={tpiContactPersonOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonIDEncrypted",
                            e.value ?? ""
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonName",
                            e.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Expected Date"
                        name="TPIExpectedDate"
                        placeholder={"Select Expected Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate
                            ? new Date(InwardDate)
                            : new Date(),
                          static: true, //to solve month dropdown not visible inside modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        {/* <Modal
          className="fade"
          show={showAddParametersModal}
          onHide={setShowAddParametersModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikAddParameters}>
              <Form onSubmit={formikAddParameters.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Add Parameter</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Parameter"
                        name="ParameterIDEncrypted"
                        placeholder={"Select Parameter"}
                        options={parametersOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikAddParameters.setFieldValue(
                            "ParameterIDEncrypted",
                            e.value ?? ""
                          );
                          formikAddParameters.setFieldValue(
                            "ParameterName",
                            e.label ?? ""
                          );
                          formikAddParameters.setFieldValue(
                            "DisplayName",
                            e.DisplayName ?? ""
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                  <Button
                    variant="danger light"
                    onClick={() => setShowAddParametersModal(false)}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}

        <Modal
          className="fade"
          show={showTestMasterImagesModal}
          onHide={setShowTestMasterImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Test Master Images</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTestMasterImagesModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <div className="table-responsive active-projects style-1 shorting mb-2">
                <div
                  id="TestMasterImages-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="TestMasterImages-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="2%"></th>
                        <th width="98%" style={{ textAlign: "left" }}>
                          Image Preview
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {ListTestMasterImages?.length > 0 ? (
                        ListTestMasterImages?.map((item, indx) => (
                          <tr key={indx}>
                            <td>
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="View"
                                onClick={() => {
                                  window.open(item.ImageFilePath, "_blank");
                                }}
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                            </td>
                            <td>
                              <div
                                className="image-placeholder"
                                style={{
                                  maxWidth: "100px",
                                  margin: "10px",
                                  zIndex: 0,
                                }}
                              >
                                <div
                                  className="avatar-preview"
                                  style={{
                                    width: "100px",
                                    height: "auto",
                                  }}
                                >
                                  <div id="testMasterImagePreview">
                                    <img
                                      id="saveTestMasterImageFile"
                                      src={item.ImageFilePath}
                                      alt={"Image"}
                                      onClick={() => {
                                        window.open(
                                          item.ImageFilePath,
                                          "_blank"
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTestMasterImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showTestingImagesModal}
          onHide={setShowTestingImagesModal}
          size="lg"
        >
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Spin
                size="large"
                spinning={isLoading}
                tip={"Loading..."}
                style={{ position: "fixed" }}
              >
                <Modal.Header>
                  <Modal.Title>Testing Images</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestingImagesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    {/* {IsReTestTesting == false ? ( */}
                    <Col lg={12}>
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        + Add
                        <div
                          className="open-file mt-2"
                          style={{ marginLeft: "2rem" }}
                        >
                          <input
                            type="file"
                            id="TestingImages"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={uploadTestingResultImage}
                          />
                          <label htmlFor="TestingImages" name=""></label>
                        </div>
                      </div>
                    </Col>
                    {/* ) : (
                      ""
                    )} */}
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="TestingImages-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestingImages-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="4%"></th>
                                <th width="50%">Image Preview</th>
                                <th width="46%" style={{ textAlign: "left" }}>
                                  Remarks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListTestingResultImages?.filter(
                                (x) => x.IsDeleted == false
                              ).length > 0 ? (
                                ListTestingResultImages?.map((item, indx) => (
                                  <tr
                                    key={indx}
                                    style={{
                                      display:
                                        item?.IsDeleted == true ? "none" : "",
                                    }}
                                  >
                                    <td>
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light me-1"
                                        className="icon-box icon-box-md me-1"
                                        title="View"
                                        onClick={() => {
                                          window.open(
                                            item.ResultImagePath
                                              ? item.ResultImagePath
                                              : item.viewFile,
                                            "_blank"
                                          );
                                        }}
                                      >
                                        <i className="fa fa-eye"></i>
                                      </Link>
                                      {/* {IsReTestTesting == false ? ( */}
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-danger-light"
                                        className="icon-box icon-box-md me-1"
                                        title="Delete"
                                        onClick={() => {
                                          //deleteTestingResultImage(indx);
                                          delete_RecordWithoutApi(
                                            deleteTestingResultImage,
                                            indx
                                          );
                                        }}
                                      >
                                        {SVGICON.DeleteDanger}
                                      </Link>
                                      {/* ) : (
                                        ""
                                      )} */}
                                    </td>
                                    <td>
                                      <div
                                        className="image-placeholder"
                                        style={{
                                          maxWidth: "100px",
                                          margin: "10px",
                                          zIndex: 0,
                                        }}
                                      >
                                        <div
                                          className="avatar-preview"
                                          style={{
                                            width: "100px",
                                            height: "auto",
                                          }}
                                        >
                                          <div id="testingImagePreview">
                                            <img
                                              id="saveTestMasterImageFile"
                                              src={
                                                item.ResultImagePath
                                                  ? item.ResultImagePath
                                                  : item.viewFile
                                              }
                                              alt={"Image"}
                                              onClick={() => {
                                                window.open(
                                                  item.ResultImagePath
                                                    ? item.ResultImagePath
                                                    : item.viewFile,
                                                  "_blank"
                                                );
                                              }}
                                              style={{ cursor: "pointer" }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <Field
                                        name={`ListTestingResultImages[${indx}].Remarks`}
                                        component={CustomInput}
                                      />
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={3} style={{ textAlign: "left" }}>
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTestingImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
              </Spin>
            </Form>
          </FormikProvider>
        </Modal>
        <Modal
          className="fade"
          show={showTestingRemarksModal}
          onHide={setShowTestingRemarksModal}
          size="lg"
        >
          <FormikProvider value={formikTestingRemarks}>
            <Form onSubmit={formikTestingRemarks.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Testing Remarks</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowTestingRemarksModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting mb-0">
                      <div
                        id="TestingRemarks-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="TestingRemarks-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Testing Remarks
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {TestingRemarksList?.length > 0 ? (
                              TestingRemarksList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkTestingRemarks${indx}`}
                                      name={`chkTestingRemarks${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formikTestingRemarks.setFieldValue(
                                          "TestingRemarksList",
                                          TestingRemarksList?.map((x, idx) => {
                                            if (idx == indx) {
                                              return {
                                                ...x,
                                                IsSelected: true,
                                              };
                                            } else {
                                              return {
                                                ...x,
                                                IsSelected: false,
                                              };
                                            }
                                          })
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.TestingRemarks}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                >
                  <i className="fa-solid fa-plus"></i> Add
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowTestingRemarksModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
        <Modal
          className="fade"
          show={showTestParametersModal}
          onHide={setShowTestParametersModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestPrameters}>
              <Form onSubmit={formikTestPrameters.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Testing Parameters</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div
                        className="table-responsive active-projects style-1 shorting"
                        style={{ maxHeight: "450px" }}
                      >
                        <div
                          id="TestParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%" className="ps-1">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`chkSelectAllPara`}
                                    name={`chkSelectAllPara`}
                                    checked={selectAllPara}
                                    onChange={(e) => {
                                      handleChangeSelectAllPara(
                                        e?.target?.checked
                                      );
                                    }}
                                  />
                                </th>
                                <th width="97%" style={{ textAlign: "left" }}>
                                  Parameters
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ParametersList?.length > 0 ? (
                                ParametersList?.map((para, iPara) => (
                                  <tr key={iPara}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${iPara}`}
                                        name={`chkIsSelected${iPara}`}
                                        checked={para.IsSelected}
                                        onChange={(e) => {
                                          formikTestPrameters.setFieldValue(
                                            "selectAllPara",
                                            false
                                          );
                                          formikTestPrameters.setFieldValue(
                                            `ParametersList[${iPara}].IsSelected`,
                                            e?.target?.checked
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {para?.ParameterName}
                                      {para.ShortCode
                                        ? " (" + para.ShortCode + ")"
                                        : ""}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestParametersModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showParameterFormulaExpressionModal}
          onHide={setShowParameterFormulaExpressionModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikParameterFormula}>
              <Form onSubmit={formikParameterFormula.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {formikParameterFormula.values.ParameterName}
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() =>
                      setShowParameterFormulaExpressionModal(false)
                    }
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label={`Formula Expression`}
                        name="FormulaExpression"
                        placeholder={"Enter Formula Expression"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showDefineMoreRatesModal}
          onHide={setShowDefineMoreRatesModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikDefineMoreRates}>
              <Form onSubmit={formikDefineMoreRates.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Define More Rates</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="DefineMoreRates-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="DefineMoreRates-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="5%" className="ps-1"></th>
                                <th width="95%" style={{ textAlign: "left" }}>
                                  Rate Type
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {MoreTestRatesList?.length > 0 ? (
                                MoreTestRatesList?.map((itemTest, indxTest) => (
                                  <tr key={indxTest}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${indxTest}`}
                                        name={`chkIsSelected${indxTest}`}
                                        checked={itemTest?.IsSelected}
                                        onChange={(e) => {
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${indxTest}].IsSelected`,
                                            e?.target?.checked
                                          );
                                        }}
                                      />
                                    </td>

                                    <td style={{ textAlign: "left" }}>
                                      {itemTest?.RateTypeName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={10}
                                    style={{ textAlign: "left" }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {IsReTestTesting === false ? (
                    <Button type="submit" variant="primary btn-sm">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMachineListModal}
          onHide={setShowMachineListModal}
          backdrop="static"
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Machine Calibration </Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMachineListModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="Machine-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="Machine-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="5%"> Sr No</th>
                            <th width="35%">Machine Name</th>
                            <th width="20%">Calibration Date</th>
                            <th width="20%">Calibration Expiry Date</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              Certificate
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMachines?.length > 0 ? (
                            ListOfMachines?.map((item, indx) => (
                              <tr key={indx}>
                                <td style={{ textAlign: "center" }}>
                                  {indx + 1}
                                </td>
                                <td>{item?.MachineName}</td>
                                <td>{item?.CalibrationDate}</td>
                                <td>{item?.CalibrationExpiryDate}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item?.ListOfMachineCalibrationDocuments
                                    ?.length > 0 ? (
                                    <Link
                                      to="#"
                                      className="text-primary"
                                      onClick={() => {
                                        setMachineCalibrationDocumentsList([]);
                                        setMachineCalibrationDocumentsList(
                                          item?.ListOfMachineCalibrationDocuments
                                        );
                                        setShowCertificateModal(true);
                                      }}
                                    >
                                      View
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showCertificateModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary btn-sm"
                onClick={() => setShowMachineListModal(false)}
              >
                OK
              </Button>
            </Modal.Footer>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showCertificateModal}
          onHide={setShowCertificateModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Machine Calibration Certificate</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowCertificateModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="CertificateImages-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="CertificateImages-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Certificate Preview
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {machineCalibrationDocumentsList?.length > 0 ? (
                            machineCalibrationDocumentsList?.map(
                              (item, indx) => (
                                <tr key={indx}>
                                  <td>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item.MachineCalibrationDocumentPath
                                            ? item.MachineCalibrationDocumentPath
                                            : "",
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.MachineCalibrationDocumentFileName}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary btn-sm"
                onClick={() => setShowCertificateModal(false)}
              >
                OK
              </Button>
            </Modal.Footer>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddTesting;
